import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import DragController from '../../hooks/DragController';
import ModuleLoader from '../loaders/ModuleLoader';
import {
  CSS2DRenderer,
  CSS2DObject,
} from 'three/examples/jsm/renderers/CSS2DRenderer.js';

import { ColladaExporter } from 'three/examples/jsm/exporters/ColladaExporter.js';
import { message } from 'antd';
import { roundTo } from '../../utils/geometry/epsilon';
import { InsideType, ModuleType, TypeConnerModule } from '../../constants/enum';

import { GeometryUtils } from '../../utils/geometry/GeometryUtils';
import { InteractiveDimensionSystem } from '../core/geometry/Dimensions';

import { LineSegmentsGeometry } from 'three/examples/jsm/lines/LineSegmentsGeometry.js';
import { LineSegments2 } from 'three/examples/jsm/lines/LineSegments2.js';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js';
import { openMessageError } from '../../components/common/Message/openMessageError';
import {
  evaluateExpression,
  getInputType,
  isValidExpression,
} from '../../utils/string/inputExpression';
import DragMolduleController from '../core/controllers/drag/DragMolduleController';
import TextureModuleController from '../core/controllers/texture/TextureModuleController';
import AutoFitModuleController from '../core/controllers/transform/AutoFitModuleController';
import CreateCabinetTrim from '../core/geometry/CreateCabinetTrim';
import CreateGroupPlane from '../core/geometry/CreateGroupPlane';
import PositionController from '../core/controllers/positioning/PositionController';

import { RectAreaLightHelper } from 'three/examples/jsm/helpers/RectAreaLightHelper.js';
import { RectAreaLightUniformsLib } from 'three/examples/jsm/lights/RectAreaLightUniformsLib.js';

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass';
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter';
import i18n from '../../languages/i18n';

export default class SceneManager {
  // constructor(canvasId, onSelectMesh) {
  //   this.skipSpecialTexture = false;

  //   this.canvas = document.getElementById(canvasId);
  //   this.onSelectMesh = onSelectMesh;
  //   this.scene = new THREE.Scene();

  //   this.walls = [];
  //   this.columns = [];
  //   this.beams = [];
  //   this.labels = [];

  //   this.countertop = {
  //     using: false,
  //     material: null,
  //     texture: null,
  //     dimension: { height: 0.02 },
  //   };
  //   this.backsplash = {
  //     using: false,
  //     material: null,
  //     texture: null,
  //     dimension: { height: 0.65 },
  //   };
  //   this.ledDecor = {
  //     using: false,
  //     material: null,
  //     texture: null,
  //   };

  //   this.composer = null;
  //   this.outlinePass = null;
  //   this.selectedMesh = null;

  //   this.ceiling = null;
  //   this.ceilingVisibilityEnabled = true;

  //   this.mouse = new THREE.Vector2();

  //   this._appearance = {
  //     floorTexUrl: null, // nhớ texture sàn đang dùng
  //     floorRepeat: 4, // mặc định lặp 4x4
  //     metersPerTile: null, // nếu muốn quy đổi theo mét/ô
  //     wallColor: '#ffffff', // màu tường/cột/dầm
  //   };

  //   this.floor = null;
  //   this.floorSize = { width: 5, depth: 4 };
  //   this.wallHeight = 3.5;
  //   this.wallThickness = 0.15;

  //   this.camera = new THREE.PerspectiveCamera(
  //     45,
  //     window.innerWidth / window.innerHeight,
  //     0.01,
  //     100
  //   );
  //   this.camera.position.set(0, 4, 8);
  //   this.camera.lookAt(0, 1.5, 0);

  //   this.border = [];
  //   this.borderSelectedModule = [];
  //   this.borderErrorMesh = [];
  //   this.errorModule = [];
  //   this.boxes = [];
  //   this.wireframeBoxes = [];

  //   this.planToCheck = [];

  //   this.cornerPillars = [];
  //   this.wallVisibilityEnabled = true; // Mặc định bật tính năng
  //   this.minWallOpacity = 0.0; // Độ trong suốt tối thiểu khi ẩn

  //   this.renderer = new THREE.WebGLRenderer({
  //     canvas: this.canvas,
  //     preserveDrawingBuffer: true,
  //     antialias: true,
  //     powerPreference: 'high-performance',
  //   });
  //   this.renderer.setSize(window.innerWidth, window.innerHeight);
  //   this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  //   this.renderer.shadowMap.enabled = true;
  //   this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;

  //   this.renderer.physicallyCorrectLights = true;
  //   this.renderer.outputEncoding = THREE.sRGBEncoding;
  //   this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
  //   this.renderer.toneMappingExposure = 1.1;

  //   this.controls = new OrbitControls(this.camera, this.renderer.domElement);
  //   this.controls.enableDamping = true;
  //   // this.controls.maxDistance = 200;
  //   // EffectComposer setup

  //   const panOffset = 1.5;
  //   this.camera.position.add(new THREE.Vector3(0, panOffset, 0));
  //   this.controls.target.add(new THREE.Vector3(0, panOffset, 0));

  //   // Renderer setup
  //   this.renderer = new THREE.WebGLRenderer({
  //     canvas: this.canvas,
  //     antialias: true,
  //   });
  //   this.renderer.setSize(window.innerWidth, window.innerHeight);
  //   this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  //   this.renderer.shadowMap.enabled = true;
  //   this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  //   this.renderer.setClearColor(0xf0f0f0);

  //   //Point door
  //   this.arrayPointDoor = [];
  //   this.arrayPointDoorPrev = [];
  //   this.arrayPointRecommend = [];
  //   this.slit = 0.0;

  //   this.plane = new THREE.Plane();
  //   this.planeIntersect = new THREE.Vector3();
  //   this.pIntersect = new THREE.Vector3();
  //   this.shift = new THREE.Vector3();
  //   this.normal = null;
  //   this.dragObject = undefined;

  //   // const renderTarget = new WebGLRenderTarget(
  //   //   window.innerWidth,
  //   //   window.innerHeight,
  //   //   {
  //   //     format: THREE.RGBAFormat,
  //   //     encoding: THREE.sRGBEncoding,
  //   //     samples: 4, // Thêm samples để enable multisampling
  //   //   }
  //   // );
  //   // this.composer = new EffectComposer(this.renderer, renderTarget);

  //   // const renderPass = new RenderPass(this.scene, this.camera);
  //   // this.composer.addPass(renderPass);

  //   // this.outlinePass = new OutlinePass(
  //   //   new THREE.Vector2(window.innerWidth, window.innerHeight),
  //   //   this.scene,
  //   //   this.camera
  //   // );
  //   // this.outlinePass.edgeStrength = 3.0;
  //   // this.outlinePass.edgeGlow = 0.0; // 👈 nên để 0 hoặc rất nhỏ
  //   // this.outlinePass.edgeThickness = 1.0; // 👈 càng thấp càng mịn, nhưng mảnh

  //   // this.outlinePass.pulsePeriod = 2;
  //   // this.outlinePass.visibleEdgeColor.set("#00ffff");
  //   // this.outlinePass.hiddenEdgeColor.set("#000000");

  //   // this.composer.addPass(this.outlinePass);

  //   // // FXAA (chống răng cưa)
  //   // const effectFXAA = new ShaderPass(FXAAShader);
  //   // effectFXAA.uniforms["resolution"].value.set(
  //   //   1 / window.innerWidth,
  //   //   1 / window.innerHeight
  //   // );
  //   // this.composer.addPass(effectFXAA);

  //   this.raycaster = new THREE.Raycaster();

  //   this.dragController = new DragMolduleController(this);

  //   this.textureController = new TextureModuleController();

  //   this.labelRenderer = new CSS2DRenderer();
  //   this.labelRenderer.setSize(window.innerWidth, window.innerHeight);
  //   this.labelRenderer.domElement.style.position = 'absolute';
  //   this.labelRenderer.domElement.style.top = '0px';
  //   this.labelRenderer.domElement.style.pointerEvents = 'none';
  //   this.labelRenderer.domElement.style.zIndex = '1000';
  //   document
  //     .getElementById('container__canvas')
  //     ?.appendChild(this.labelRenderer.domElement);

  //   // this.positionController = new PositionController(this, this.labelRenderer);

  //   this.autoFitModuleController = new AutoFitModuleController(this);

  //   // Optional: Set callback để listen distance changes
  //   // this.positionController.setOnDistanceChanged(data => {
  //   //   // data contains:
  //   //   // - moduleId: ID của module
  //   //   // - direction: Hướng (x1, x2, z1, z2)
  //   //   // - oldDistance: Khoảng cách cũ
  //   //   // - newDistance: Khoảng cách mới
  //   //   // - newPosition: Vị trí mới {x, z}
  //   // });

  //   this.dimensionSystem = new InteractiveDimensionSystem(
  //     this.camera,
  //     this.renderer.domElement,
  //     this.scene
  //   );

  //   this.moduleLoader = new ModuleLoader(this);

  //   this.createGroupPlane = new CreateGroupPlane(this);
  //   this.createCabinetTrim = new CreateCabinetTrim(this);

  //   this.renderer.setClearColor(0xfafafa);
  //   window.addEventListener('resize', this.onWindowResize.bind(this), false);
  // }

  constructor(canvasId, onSelectMesh, onDimensionChange) {
    this.skipSpecialTexture = false;

    this.canvas = document.getElementById(canvasId);
    this.onSelectMesh = onSelectMesh;
    this.onDimensionChange = onDimensionChange;
    this.scene = new THREE.Scene();

    this.walls = [];
    this.columns = [];
    this.beams = [];
    this.labels = [];

    this.countertop = {
      using: false,
      material: null,
      texture: null,
      dimension: { height: 0.02 },
    };
    this.backsplash = {
      using: false,
      material: null,
      texture: null,
      dimension: { height: 0.65 },
    };
    this.ledDecor = {
      using: false,
      material: null,
      texture: null,
    };

    this.composer = null;
    this.outlinePass = null;
    this.selectedMesh = null;

    this.ceiling = null;
    this.ceilingVisibilityEnabled = true;

    this.mouse = new THREE.Vector2();

    this._appearance = {
      floorTexUrl: null, // nhớ texture sàn đang dùng
      floorRepeat: 4, // mặc định lặp 4x4
      metersPerTile: null, // nếu muốn quy đổi theo mét/ô
      wallColor: '#ffffff', // màu tường/cột/dầm
    };

    this.floor = null;
    this.floorSize = { width: 5, depth: 4 };
    this.wallHeight = 3.5;
    this.wallThickness = 0.15;

    this.camera = new THREE.PerspectiveCamera(
      45,
      window.innerWidth / window.innerHeight,
      0.01,
      100
    );
    this.camera.position.set(0, 4, 8);
    this.camera.lookAt(0, 1.5, 0);

    this.border = [];
    this.borderSelectedModule = [];
    this.borderErrorMesh = [];
    this.errorModule = [];
    this.boxes = [];
    this.wireframeBoxes = [];

    this.planToCheck = [];

    this.cornerPillars = [];
    this.wallVisibilityEnabled = true; // Mặc định bật tính năng
    this.minWallOpacity = 0.0; // Độ trong suốt tối thiểu khi ẩn

    // Renderer setup
    // this.renderer = new THREE.WebGLRenderer({
    //   canvas: this.canvas,
    //   antialias: true,
    // });
    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas,
      preserveDrawingBuffer: true,
      antialias: true,
      powerPreference: 'high-performance',
    });

    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    this.renderer.setClearColor(0xf0f0f0);

    this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    this.controls.enableDamping = true;
    // this.controls.maxDistance = 200;
    // EffectComposer setup

    const panOffset = 1.5;
    this.camera.position.add(new THREE.Vector3(0, panOffset, 0));
    this.controls.target.add(new THREE.Vector3(0, panOffset, 0));

    //Point door
    this.arrayPointDoor = [];
    this.arrayPointDoorPrev = [];
    this.arrayPointRecommend = [];
    this.slit = 0.0;

    this.plane = new THREE.Plane();
    this.planeIntersect = new THREE.Vector3();
    this.pIntersect = new THREE.Vector3();
    this.shift = new THREE.Vector3();
    this.normal = null;
    this.dragObject = undefined;

    // const renderTarget = new WebGLRenderTarget(
    //   window.innerWidth,
    //   window.innerHeight,
    //   {
    //     format: THREE.RGBAFormat,
    //     encoding: THREE.sRGBEncoding,
    //     samples: 4, // Thêm samples để enable multisampling
    //   }
    // );
    // this.composer = new EffectComposer(this.renderer, renderTarget);

    // const renderPass = new RenderPass(this.scene, this.camera);
    // this.composer.addPass(renderPass);

    // this.outlinePass = new OutlinePass(
    //   new THREE.Vector2(window.innerWidth, window.innerHeight),
    //   this.scene,
    //   this.camera
    // );
    // this.outlinePass.edgeStrength = 3.0;
    // this.outlinePass.edgeGlow = 0.0; // 👈 nên để 0 hoặc rất nhỏ
    // this.outlinePass.edgeThickness = 1.0; // 👈 càng thấp càng mịn, nhưng mảnh

    // this.outlinePass.pulsePeriod = 2;
    // this.outlinePass.visibleEdgeColor.set("#00ffff");
    // this.outlinePass.hiddenEdgeColor.set("#000000");

    // this.composer.addPass(this.outlinePass);

    // // FXAA (chống răng cưa)
    // const effectFXAA = new ShaderPass(FXAAShader);
    // effectFXAA.uniforms["resolution"].value.set(
    //   1 / window.innerWidth,
    //   1 / window.innerHeight
    // );
    // this.composer.addPass(effectFXAA);

    this.raycaster = new THREE.Raycaster();

    this.dragController = new DragMolduleController(this);

    this.textureController = new TextureModuleController();

    this.labelRenderer = new CSS2DRenderer();
    this.labelRenderer.setSize(window.innerWidth, window.innerHeight);
    this.labelRenderer.domElement.style.position = 'absolute';
    this.labelRenderer.domElement.style.top = '0px';
    this.labelRenderer.domElement.style.pointerEvents = 'none';
    this.labelRenderer.domElement.style.zIndex = '1000';
    document
      .getElementById('container__canvas')
      ?.appendChild(this.labelRenderer.domElement);

    // this.positionController = new PositionController(this, this.labelRenderer);

    this.autoFitModuleController = new AutoFitModuleController(this);

    // Optional: Set callback để listen distance changes
    // this.positionController.setOnDistanceChanged(data => {
    //   // data contains:
    //   // - moduleId: ID của module
    //   // - direction: Hướng (x1, x2, z1, z2)
    //   // - oldDistance: Khoảng cách cũ
    //   // - newDistance: Khoảng cách mới
    //   // - newPosition: Vị trí mới {x, z}
    // });

    this.dimensionSystem = new InteractiveDimensionSystem(
      this.camera,
      this.renderer.domElement,
      this.scene
    );

    this.moduleLoader = new ModuleLoader(this);

    this.createGroupPlane = new CreateGroupPlane(this);
    this.createCabinetTrim = new CreateCabinetTrim(this);

    this.renderer.setClearColor(0xfafafa);
    window.addEventListener('resize', this.onWindowResize.bind(this), false);
  }

  generateCornerPoints(module, axis, showLabel) {
    // this.dimensionSystem.clearAll();
    // this.dimensionSystem.removeFromScene(this.scene);
    this.dimensionSystem.clearPoints();
    let realityModule = module;
    this.scene.traverse(child => {
      if (child.uuid === module?.uuid) {
        realityModule = child;
      }
    });
    this.dimensionSystem.generateCornerPoints(
      realityModule ?? this.scene,
      axis,
      showLabel
    );
    this.dimensionSystem.addToScene(this.scene);
  }

  clearAllCornerPoints() {
    this.dimensionSystem.clearAll();
    this.dimensionSystem.removeFromScene(this.scene);
  }

  async addAllCountertop(moduleData) {
    // this.countertop.using = true;
    if (moduleData !== this.countertop.material) {
      this.countertop = { ...this.countertop, texture: null };
    }
    this.countertop = { ...this.countertop, material: moduleData, using: true };

    await this.updateAllCountertopAndBacksplash();
  }

  async addAllBacksplash(moduleData) {
    // this.backsplash.using = true;
    if (moduleData !== this.backsplash.material) {
      this.backsplash = { ...this.backsplash, texture: null };
    }
    this.backsplash = { ...this.backsplash, material: moduleData, using: true };

    await this.updateAllCountertopAndBacksplash();
  }

  async addAllLedDecor(moduleData) {
    // this.ledDecor.using = true;
    if (moduleData !== this.ledDecor?.material) {
      this.ledDecor = { ...this.ledDecor, texture: null };
    }
    this.ledDecor = { ...this.ledDecor, material: moduleData, using: true };

    await this.updateAllCountertopAndBacksplash();
  }

  // Thêm vào sceneRef.current hoặc sceneManager
  getFloorBounds() {
    if (!this.floor) return null;

    const box = new THREE.Box3().setFromObject(this.floor);
    return {
      min: {
        x: box.min.x,
        y: box.min.y,
        z: box.min.z,
      },
      max: {
        x: box.max.x,
        y: box.max.y,
        z: box.max.z,
      },
    };
  }

  async removeAllCountertop() {
    this.countertop = {
      using: false,
      material: null,
      texture: null,
      dimension: { height: 0.02 },
    };

    await this.updateAllCountertopAndBacksplash();
  }

  async removeAllBacksplash() {
    this.backsplash = {
      using: false,
      material: null,
      texture: null,
      dimension: { height: 0.65 },
    };

    await this.updateAllCountertopAndBacksplash();
  }

  async removeAllLedDecor() {
    this.ledDecor = {
      using: false,
      material: null,
      texture: null,
    };

    this.disposeKitchenLeds();
    // await this.updateAllCountertopAndBacksplash();
  }

  updateDataCountertopAndBacksplash(countertop, backsplash, ledDecor) {
    this.countertop = countertop ? { ...countertop } : countertop;
    this.backsplash = backsplash ? { ...backsplash } : backsplash;
    this.ledDecor = ledDecor ? { ...ledDecor } : ledDecor;
  }

  async changeBacksplashHeight(height) {
    if (this.backsplash && this.backsplash.using !== false) {
      this.backsplash = {
        ...this.backsplash,
        dimension: {
          ...this.backsplash.dimension,
          height: height,
        },
      };
      this.createGroupPlane.changeBacksplashHeight(height);

      await this.createGroupPlane.updateGroupPlanes();
    }
  }

  async updateAllCountertopAndBacksplash() {
    if (
      this.backsplash &&
      this.backsplash.using !== false &&
      this.backsplash.dimension?.height !==
        this.createGroupPlane.backsplashHeight
    ) {
      this.createGroupPlane.changeBacksplashHeight(
        this.backsplash.dimension?.height || 0.6
      );
    }

    await this.createGroupPlane.updateGroupPlanes();
  }

  clearAllCountertopAndBacksplash() {
    //Xoá tất cả MB, VB
    this.createGroupPlane.clearAllGroupPlanes();

    //Xoá led bếp nếu có
    this.disposeKitchenLeds();
  }

  updateAllCabinetTrim() {
    //Tạo nẹp viền
    this.createCabinetTrim.updateCabinetTrim();
  }

  async updateAllCabinetCover() {
    //Tạo ốp bìa
    await this.createCabinetTrim.updateCabinetCover();
  }

  setSelectedModelUIEvents(events) {
    this.dragController?.setUIEvents?.(events);
  }

  startDragSelectedModel(event, axis = null, dragModuleData) {
    return this.dragController.startDrag(event, axis, dragModuleData);
  }

  getSelectedModel() {
    return this.dragController.getSelectedModel();
  }

  isDragging() {
    return this.dragController.isDragging();
  }

  clearSelection() {
    this.dragController.clearSelection();
  }

  // Delegate methods cho ModuleLoader
  async loadModule(moduleData, position) {
    return this.moduleLoader.loadModule(moduleData, position);
  }

  async loadModuleWithCabinet(moduleData, cabinet, position) {
    return this.moduleLoader.loadModuleWithCabinet(
      moduleData,
      cabinet,
      position
    );
  }

  // Legacy support methods
  async load(moduleData, position) {
    return this.loadModule(moduleData, position);
  }

  async loadNewModule(moduleData, cabinet) {
    const position = new THREE.Vector3(-2.8, 0, 2.5);
    return this.loadModuleWithCabinet(moduleData, cabinet, position);
  }

  // Click handler (legacy support)
  onClick(event) {
    const rect = this.canvas.getBoundingClientRect();
    this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

    this.raycaster.setFromCamera(this.mouse, this.camera);
    const intersects = this.raycaster.intersectObjects(
      this.scene.children,
      true
    );

    if (intersects.length > 0) {
      const topParent = this.findTopLevelParent(intersects[0].object);
      this.selectedObject = topParent;
      this.onSelect?.(topParent);
    } else {
      this.selectedObject = null;
      this.onSelect?.(null);
    }
  }

  findTopLevelParent(object) {
    let current = object;
    while (current.parent && current.parent.type !== 'Scene') {
      current = current.parent;
    }
    return current;
  }

  findGLTFByUuid(uuid) {
    // return this.scene.getObjectByProperty("uuid", uuid);
    return this.findInGroupByUuid(this.scene, uuid);
  }

  findInGroupByUuid(group, uuid) {
    const foundObject = group.getObjectByProperty('uuid', uuid);
    if (foundObject) {
      return foundObject;
    }
    for (let i = 0; i < group.children.length; i++) {
      const child = group.children[i];
      if (child.type === 'Group') {
        const result = this.findInGroupByUuid(child, uuid);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  initialize(options = {}) {
    const { draggable = true, containerId } = options;
    this.cabinetType = options.cabinetType || null;
    this.draggable = draggable;
    this.addLights();
    // this.addAxesHelper();
    this.createGround(5, 4);
    this.updateWallsAccordingToFloor();
    this.animate();

    if (draggable) {
      this.dragController = new DragController({
        camera: this.camera,
        canvas: this.renderer.domElement,
        controls: this.controls,

        // Kéo được cả cột và dầm
        getDraggableMeshes: () => [
          ...this.columns.map(col => col.mesh),
          ...this.beams.map(beam => beam.mesh),
        ],

        getFloorSize: this.getFloorSize.bind(this),
        getSelectedMesh: () => this.selectedMesh,
        getDraggedSize: mesh => {
          const column = this.columns.find(col => col.mesh === mesh);
          if (column) return column.size;

          const beam = this.beams.find(b => b.mesh === mesh);
          if (beam) return beam.size;

          return [0.3, 3, 0.3]; // fallback
        },

        getWallThickness: () => this.wallThickness,

        onDragging: mesh => {
          this.clearAllCornerPoints();
          this.showDistanceArrows(mesh);
          this.generateCornerPoints?.();
        },
        onDragEnd: () => {
          this.removeDistanceArrows();
          // this.clearAllCornerPoints();
        },
      });
    }
    if (this._appearance.wallColor) {
      this.updateWallColor(this._appearance.wallColor);
    }
    if (this._appearance.floorTexUrl) {
      this.updateFloorTextureFromImage(this._appearance.floorTexUrl, {
        metersPerTile: this._appearance.metersPerTile,
        repeatBy: this._appearance.floorRepeat,
      });
    }
    this.raycaster = new THREE.Raycaster();
    this.pointer = new THREE.Vector2();
    this.canvas.addEventListener('click', this.onCanvasClick.bind(this));

    if (containerId) {
      this.labelRenderer = new CSS2DRenderer();
      this.labelRenderer.setSize(window.innerWidth, window.innerHeight);
      this.labelRenderer.domElement.style.position = 'absolute';
      this.labelRenderer.domElement.style.top = '0px';
      this.labelRenderer.domElement.style.pointerEvents = 'none';
      this.labelRenderer.domElement.style.zIndex = '1000';
      document
        .getElementById(containerId)
        ?.appendChild(this.labelRenderer.domElement);
    }
  }

  onCanvasClick(event) {
    const rect = this.canvas.getBoundingClientRect();
    this.pointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    this.pointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

    this.raycaster.setFromCamera(this.pointer, this.camera);
    const allMeshes = [...this.columns, ...this.beams].map(obj => obj.mesh);
    const intersects = this.raycaster.intersectObjects(allMeshes);

    if (intersects.length > 0) {
      this.selectedMesh = intersects[0].object;
      // this.outlinePass.selectedObjects = [this.selectedMesh];

      const column = this.columns.find(col => col.mesh === this.selectedMesh);
      const beam = this.beams.find(b => b.mesh === this.selectedMesh);
      const obj = column || beam;

      if (this.onSelectMesh && obj) {
        const { position } = obj.mesh;
        const box = new THREE.Box3().setFromObject(obj.mesh);
        const size = box.getSize(new THREE.Vector3());
        const [width, height, depth] = size;

        const wall1 = this.walls.find(w => w.mesh.position.x === 0);
        const wall2 = this.walls.find(w => w.mesh.position.z === 0);

        let distanceToWallFront = null;
        let distanceToWallLeft = null;

        if (wall1) {
          const obj1Box = new THREE.Box3().setFromObject(obj.mesh);
          const wall1Z = wall1.mesh.position.z;
          const objZ = position.z;
          distanceToWallFront = Math.abs(
            objZ -
              wall1Z -
              this.wallThickness / 2 -
              obj1Box.getSize(new THREE.Vector3()).z / 2
          );
        }

        if (wall2) {
          const obj2Box = new THREE.Box3().setFromObject(obj.mesh);
          const wall2X = wall2.mesh.position.x;
          const objX = position.x;
          distanceToWallLeft = Math.abs(
            objX -
              wall2X -
              this.wallThickness / 2 -
              obj2Box.getSize(new THREE.Vector3()).x / 2
          );
        }

        this.onSelectMesh({
          width,
          height,
          depth,
          position: {
            x: position.x,
            y: position.y,
            z: position.z,
          },
          distanceToWallFront,
          distanceToWallLeft,
          mesh: obj.mesh,
          obj,
        });
        this.showDistanceArrows(this.selectedMesh);
        this.generateCornerPoints(obj.mesh, null, false);
      }
    } else {
      this.selectedMesh = null;
      // this.outlinePass.selectedObjects = [];
      this.onSelectMesh?.(null);
      this.removeDistanceArrows();
      // this.clearAllCornerPoints();
    }
  }

  updateFloorSize(width, depth) {
    this.createGround(width, depth);
    this.updateWallsAccordingToFloor();
  }

  updateMeshSize(dimension, value) {
    const mesh = this.selectedMesh;
    if (!mesh || isNaN(value)) return;

    const column = this.columns.find(col => col.mesh === mesh);
    const beam = this.beams.find(beam => beam.mesh === mesh);
    const obj = column || beam;
    if (!obj) return;

    const isColumn = !!column;
    const isBeam = !!beam;

    const size = [...obj.size]; // [width, height, depth]
    const indexMap = { width: 0, height: 1, depth: 2 };
    const index = indexMap[dimension];

    const oldSize = [...size];
    const oldBox = new THREE.Box3().setFromObject(mesh);
    const oldCenter = oldBox.getCenter(new THREE.Vector3());

    // Xác định khoảng cách ban đầu đến tường
    let offsetX = null;
    let offsetZ = null;

    const wall1 = this.walls.find(w => w.mesh.position.x === 0); // tường Z
    const wall2 = this.walls.find(w => w.mesh.position.z === 0); // tường X

    if (wall1) {
      offsetZ = mesh.position.z - wall1.mesh.position.z;
    }
    if (wall2) {
      offsetX = mesh.position.x - wall2.mesh.position.x;
    }

    // Cập nhật kích thước mới
    size[index] = value;
    obj.size = size;

    const [w, h, d] = size;
    const geometry = new THREE.BoxGeometry(w, h, d);
    mesh.geometry.dispose();
    mesh.geometry = geometry;

    // Cập nhật vị trí để giữ nguyên khoảng cách
    if (dimension === 'width' && offsetX !== null) {
      const delta = (value - oldSize[0]) / 2;
      mesh.position.x += offsetX > 0 ? delta : -delta;
    }

    if (dimension === 'depth' && offsetZ !== null) {
      const delta = (value - oldSize[2]) / 2;
      mesh.position.z += offsetZ > 0 ? delta : -delta;
    }

    // Nếu thay đổi chiều cao thì cập nhật Y như cũ
    if (dimension === 'height') {
      if (isColumn) {
        mesh.position.y = h / 2;
      }
      if (isBeam) {
        mesh.position.y = this.wallHeight - h / 2;
      }
    }

    // Callback cập nhật giao diện
    if (this.onSelectMesh) {
      const box = new THREE.Box3().setFromObject(mesh);
      const size = box.getSize(new THREE.Vector3());

      const distanceToWallFront = wall1
        ? Math.abs(
            mesh.position.z -
              wall1.mesh.position.z -
              this.wallThickness / 2 -
              size.z / 2
          )
        : null;

      const distanceToWallLeft = wall2
        ? Math.abs(
            mesh.position.x -
              wall2.mesh.position.x -
              this.wallThickness / 2 -
              size.x / 2
          )
        : null;

      this.onSelectMesh({
        width: w,
        height: h,
        depth: d,
        position: {
          x: mesh.position.x,
          y: mesh.position.y,
          z: mesh.position.z,
        },
        distanceToWallFront,
        distanceToWallLeft,
      });
    }
  }

  updateMeshDistance({
    distanceToWallFront,
    distanceToWallLeft,
    distanceToWallBack,
    distanceToWallRight,
  }) {
    const mesh = this.selectedMesh;
    if (!mesh) return;

    const column = this.columns.find(col => col.mesh === mesh);
    const beam = this.beams.find(beam => beam.mesh === mesh);
    const obj = column || beam;
    if (!obj) return;

    if (mesh && obj) {
      const { position } = obj.mesh;
      const [width, height, depth] = obj.size;
      const { width: floorWidth, depth: floorDepth } = this.floorSize;
      const wallFront = this.walls.find(w => w.name === 'front');
      const wallLeft = this.walls.find(w => w.name === 'left');
      const wallBack = this.walls.find(w => w.name === 'back');
      const wallRight = this.walls.find(w => w.name === 'right');

      let z = position.z;

      const obj1Box = new THREE.Box3().setFromObject(obj.mesh);
      const sizeZ = obj1Box.getSize(new THREE.Vector3()).z;
      if (
        wallFront &&
        distanceToWallFront !== undefined &&
        distanceToWallFront + sizeZ <= floorDepth
      ) {
        const wallFrontZ = wallFront.mesh.position.z;
        z =
          distanceToWallFront + wallFrontZ + this.wallThickness / 2 + sizeZ / 2;
        mesh.position.z = z;
        this.showDistanceArrowToWallFrontAndBack(this.selectedMesh);
      } else if (distanceToWallFront + sizeZ > floorDepth) {
        openMessageError({
          content: i18n.t('Distance is outside the floor area'),
        });
        const wallFrontZ = wallFront.mesh.position.z;
        z = floorDepth + wallFrontZ + this.wallThickness / 2 - sizeZ / 2;
        mesh.position.z = z;
        this.showDistanceArrowToWallFrontAndBack(this.selectedMesh);
      }
      if (
        wallBack &&
        distanceToWallBack !== undefined &&
        distanceToWallBack + sizeZ <= floorDepth
      ) {
        const wallBackZ = wallBack.mesh.position.z;
        z =
          -distanceToWallBack + wallBackZ - this.wallThickness / 2 - sizeZ / 2;
        mesh.position.z = z;
        this.showDistanceArrowToWallFrontAndBack(this.selectedMesh);
      } else if (distanceToWallBack + sizeZ > floorDepth) {
        openMessageError({
          content: i18n.t('Distance is outside the floor area'),
        });
        const wallBackZ = wallBack.mesh.position.z;
        z = -floorDepth + wallBackZ - this.wallThickness / 2 + sizeZ / 2;
        mesh.position.z = z;
        this.showDistanceArrowToWallFrontAndBack(this.selectedMesh);
      }

      let x = position.x;

      const obj2Box = new THREE.Box3().setFromObject(obj.mesh);
      const sizeX = obj2Box.getSize(new THREE.Vector3()).x;

      if (
        wallLeft &&
        distanceToWallLeft !== undefined &&
        distanceToWallLeft + sizeX <= floorWidth
      ) {
        const wallLeftX = wallLeft.mesh.position.x;
        x = distanceToWallLeft + wallLeftX + this.wallThickness / 2 + sizeX / 2;
        mesh.position.x = x;
        this.showDistanceArrowToWallLeftAndRight(this.selectedMesh);
      } else if (distanceToWallLeft + sizeX > floorWidth) {
        openMessageError({
          content: i18n.t('Distance is outside the floor area'),
        });
        const wallLeftX = wallLeft.mesh.position.x;
        x = floorWidth + wallLeftX + this.wallThickness / 2 - sizeX / 2;
        mesh.position.x = x;
        this.showDistanceArrowToWallLeftAndRight(this.selectedMesh);
      }

      if (
        wallRight &&
        distanceToWallRight !== undefined &&
        distanceToWallRight + sizeX <= floorWidth
      ) {
        const wallRightX = wallRight.mesh.position.x;
        x =
          -distanceToWallRight +
          wallRightX -
          this.wallThickness / 2 -
          sizeX / 2;
        mesh.position.x = x;
        this.showDistanceArrowToWallLeftAndRight(this.selectedMesh);
      } else if (distanceToWallRight + sizeX > floorWidth) {
        openMessageError({
          content: i18n.t('Distance is outside the floor area'),
        });
        const wallRightX = wallRight.mesh.position.x;
        x = -floorWidth + wallRightX - this.wallThickness / 2 + sizeX / 2;
        mesh.position.x = x;
        this.showDistanceArrowToWallLeftAndRight(this.selectedMesh);
      }

      this.clearAllCornerPoints();
      this.generateCornerPoints(mesh, null, false);

      this.onSelectMesh({
        width,
        height,
        depth,
        position: {
          x: x,
          y: position.y,
          z: z,
        },
        distanceToWallFront:
          distanceToWallFront ??
          (this.selectedMesh
            ? this.distanceToWallFrontAndBack(this.selectedMesh)
                ?.distanceToWallFront
            : undefined),
        distanceToWallLeft:
          distanceToWallLeft ??
          (this.selectedMesh
            ? this.distanceToWallLeftAndRight(this.selectedMesh)
                ?.distanceToWallLeft
            : undefined),
        mesh: mesh,
      });
    }
  }

  addLights() {
    // Đèn chính (ánh sáng từ bên phải trên chiếu xuống)
    // const dirLight = new THREE.DirectionalLight(0xffffff, 0.45);
    const dirLight = new THREE.DirectionalLight(0xffffff, 0.4);
    dirLight.position.set(4, 6, 2);
    dirLight.castShadow = true;

    dirLight.shadow.mapSize.width = 2048;
    dirLight.shadow.mapSize.height = 2048;
    dirLight.shadow.camera.left = -10;
    dirLight.shadow.camera.right = 10;
    dirLight.shadow.camera.top = 10;
    dirLight.shadow.camera.bottom = -10;
    dirLight.shadow.camera.near = 0.5;
    dirLight.shadow.camera.far = 50;
    dirLight.shadow.normalBias = 0.05;

    dirLight.target.position.set(0, 1.5, 0);
    this.scene.add(dirLight);
    this.scene.add(dirLight.target);

    // Đèn phụ phía đối diện (ánh sáng từ bên trái dưới với độ sáng nhỏ hơn)
    const dirLight2 = new THREE.DirectionalLight(0xffffff, 0.35); // Độ sáng nhỏ hơn (1 thay vì 3)
    dirLight2.position.set(-4, 6, -2); // Vị trí đối diện qua trục tọa độ
    dirLight2.castShadow = false; // Không tạo bóng để tránh xung đột shadow

    dirLight2.target.position.set(0, 1.5, 0); // Cùng hướng về trung tâm
    this.scene.add(dirLight2);
    this.scene.add(dirLight2.target);

    // Đèn chiếu ngược từ góc tọa độ (0,0,0) lên trần
    const upwardLight = new THREE.DirectionalLight(0xffffff, 0.25); // Cường độ nhẹ
    upwardLight.position.set(0, 0, 0); // Góc tọa độ
    upwardLight.target.position.set(0, 3, 0); // Hướng lên trần (trục Y)
    upwardLight.castShadow = false; // Không cần bóng để nhẹ

    this.scene.add(upwardLight);
    this.scene.add(upwardLight.target);

    // Ánh sáng môi trường
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
    this.scene.add(ambientLight);

    // SpotLight ở 4 góc
    const spotConfigs = [
      { x: -5, z: -5 }, // góc trái sau
      { x: 5, z: -5 }, // góc phải sau
      { x: -5, z: 5 }, // góc trái trước
      { x: 5, z: 5 }, // góc phải trước
    ];

    spotConfigs.forEach(cfg => {
      const spot = new THREE.SpotLight(
        0xffffff,
        0.2, // intensity — nhẹ để không lấn át đèn chính
        16, // distance
        Math.PI / 4, // angle
        0.5, // penumbra — viền mềm
        1 // decay
      );

      spot.position.set(cfg.x, 1, cfg.z);
      spot.target.position.set(0, 0, 0); // hướng vào trung tâm
      spot.castShadow = false;

      this.scene.add(spot);
      this.scene.add(spot.target);
    });
  }

  //LED BẾP
  addKitchenLeds() {
    this.disposeKitchenLeds();

    if (!this._ledShaderMaterials) {
      this._ledShaderMaterials = this._buildLedShaderMaterials();
    }

    if (!this.ledMeshMaterial) {
      this.ledMeshMaterial = new THREE.MeshBasicMaterial({
        color: 0xfeec41,
        toneMapped: false,
      });
    }

    const ledMeshes = [];
    this.scene?.traverse(obj => {
      if (
        obj?.userData?.type === ModuleType.BACKSPLASH &&
        !obj?.userData?.isEdgeBacksplash //không lấy ốp vách bìa
      ) {
        ledMeshes.push(obj);
      }
    });

    if (ledMeshes.length === 0) return;

    ledMeshes.forEach(mesh => {
      const bbox = new THREE.Box3().setFromObject(mesh);
      const size = new THREE.Vector3();
      const center = new THREE.Vector3();
      bbox.getSize(size);
      bbox.getCenter(center);

      const isAlongX = size.x > size.z;
      const ledWidth = isAlongX ? size.x : size.z;
      const px = center.x;
      const py = center.y + size.y / 2;
      const pz = center.z;

      const ledGeometry = isAlongX
        ? new THREE.BoxGeometry(ledWidth, 0.005, 0.005)
        : new THREE.BoxGeometry(0.005, 0.005, ledWidth);

      const ledMesh = new THREE.Mesh(ledGeometry, this.ledMeshMaterial);
      ledMesh.position.set(px, py, pz);
      ledMesh.castShadow = false;
      ledMesh.receiveShadow = false;
      ledMesh.userData.type = ModuleType.LED_DECOR;
      this.scene.add(ledMesh);
      this.ledList.push(ledMesh);

      this._addGlowLayers(px, py, pz, ledWidth, isAlongX, bbox);
    });
  }

  _addGlowLayers(px, py, pz, ledWidth, isAlongX, bbox) {
    let normalX = 0,
      normalZ = 0;

    if (isAlongX) {
      const absMin = Math.abs(bbox.min.z);
      const absMax = Math.abs(bbox.max.z);
      normalZ = absMax > absMin ? 1 : -1;
    } else {
      const absMin = Math.abs(bbox.min.x);
      const absMax = Math.abs(bbox.max.x);
      normalX = absMax > absMin ? 1 : -1;
    }

    const GLOW_OFFSET = 0.004;

    this._ledShaderMaterials.forEach(({ height, mat }) => {
      const geo = new THREE.PlaneGeometry(ledWidth, height);
      const plane = new THREE.Mesh(geo, mat);

      if (isAlongX) {
        plane.rotation.y = normalZ > 0 ? 0 : Math.PI;
      } else {
        plane.rotation.y = normalX > 0 ? -Math.PI / 2 : Math.PI / 2;
      }

      plane.position.set(
        px - normalX * GLOW_OFFSET,
        py - height / 2,
        pz - normalZ * GLOW_OFFSET
      );

      this.scene.add(plane);
      this.ledList.push(plane);
    });
  }

  _buildLedShaderMaterials() {
    const vertexShader = `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `;

    const fragmentShader = `
    uniform vec3 uColor;
    uniform float uOpacity;
    uniform float uSigma;
    varying vec2 vUv;

    void main() {
      // vUv.y: 0 = dưới (xa LED), 1 = trên (sát LED)
      float distY = 1.0 - vUv.y;
      float glowY = exp(-(distY * distY) / (uSigma * uSigma));

      float alpha = glowY * uOpacity;
      gl_FragColor = vec4(uColor, clamp(alpha, 0.0, 1.0));
    }
  `;

    const make = (height, color, opacity, sigma) => ({
      height,
      mat: new THREE.ShaderMaterial({
        uniforms: {
          uColor: { value: new THREE.Color(color) },
          uOpacity: { value: opacity },
          uSigma: { value: sigma },
        },
        vertexShader,
        fragmentShader,
        transparent: true,
        blending: THREE.AdditiveBlending,
        depthWrite: false,
        depthTest: true,
        side: THREE.DoubleSide,
        polygonOffset: true,
        polygonOffsetFactor: -2,
        polygonOffsetUnits: -2,
      }),
    });

    // return [
    //   make(0.025, 0xfffef5, 1.0, 0.25),
    //   make(0.08, 0xfff8e0, 0.8, 0.35),
    //   make(0.22, 0xfff0c0, 0.45, 0.5),
    //   make(0.65, 0xffe8a0, 0.18, 0.65),
    // ];
    return [
      // make(0.055, 0xfffef5, 0.5, 0.15),
      make(0.03, 0xfff8e0, 0.5, 0.25),
      make(0.4, 0xfff0c0, 0.22, 0.55),
      make(0.8, 0xffe8a0, 0.08, 0.7),
    ];
  }

  disposeKitchenLeds() {
    this.ledList?.forEach(obj => {
      if (obj.parent) obj.parent.remove(obj);
      if (obj.geometry) obj.geometry.dispose();
      if (obj.material && obj.material !== this.ledMeshMaterial) {
        obj.material.dispose();
      }
    });
    this.ledList = [];

    this._ledShaderMaterials?.forEach(({ mat }) => mat.dispose());
    this._ledShaderMaterials = null;

    this.ledMeshMaterial?.dispose();
    this.ledMeshMaterial = null;
  }
  //LED BẾP

  addGround() {
    const loader = new THREE.TextureLoader();
    const repeat = 4;

    const material = new THREE.MeshStandardMaterial({
      map: this.wrapAndRepeat(loader.load('/textures/color.jpg'), repeat),
      normalMap: this.wrapAndRepeat(
        loader.load('/textures/normal.jpg'),
        repeat
      ),
      roughnessMap: this.wrapAndRepeat(
        loader.load('/textures/roughness.jpg'),
        repeat
      ),
      roughness: 1.0,
      metalness: 0.1,
    });

    const floor = new THREE.Mesh(new THREE.PlaneGeometry(6, 6), material);
    floor.rotation.x = -Math.PI / 2;
    floor.receiveShadow = true;
    this.scene.add(floor);
  }

  // Trong phương thức createGround
  createGround(width, depth) {
    const loader = new THREE.TextureLoader();

    const PLANK_WIDTH = 0.804;
    const PLANK_LENGTH = 1.2;

    const repeatX = width / PLANK_WIDTH;
    const repeatY = depth / PLANK_LENGTH;

    const colorMap = loader.load('/textures/color.jpg');
    const normalMap = loader.load('/textures/normal.jpg');
    const roughnessMap = loader.load('/textures/roughness.jpg');

    // ===== FIX: KHÔNG SET ENCODING CHO TEXTURE MAP =====
    [colorMap, normalMap, roughnessMap].forEach(texture => {
      texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
      texture.repeat.set(repeatX, repeatY);

      // BỎ dòng này: texture.encoding = THREE.sRGBEncoding;

      const maxAnisotropy = this.renderer.capabilities.getMaxAnisotropy();
      texture.anisotropy = maxAnisotropy;
      texture.minFilter = THREE.LinearMipmapLinearFilter;
      texture.magFilter = THREE.LinearFilter;
      texture.generateMipmaps = true;
    });

    const material = new THREE.MeshStandardMaterial({
      map: colorMap,
      normalMap: normalMap,
      roughnessMap: roughnessMap,
      roughness: 0.7, // Giảm từ 0.8 xuống 0.7
      metalness: 0.0, // Giảm từ 0.1 xuống 0.0
      color: 0xffffff, // Thêm màu trắng base
    });

    if (this.floor) {
      this.scene.remove(this.floor);
      this.floor.geometry.dispose();
      this.floor.material.dispose();
    }

    const floor = new THREE.Mesh(
      new THREE.PlaneGeometry(width, depth),
      material
    );
    floor.rotation.x = -Math.PI / 2;
    floor.receiveShadow = true;
    floor.userData.ground = true;

    this.scene.add(floor);
    this.planToCheck.push(floor);
    this.floor = floor;
    this.floorSize = { width, depth };

    const box = new THREE.Box3().setFromObject(floor);
    const center = new THREE.Vector3();
    box.getCenter(center);

    // this.positionController.addModule({
    //   id: floor.uuid,
    //   x: center.x,
    //   y: 0,
    //   z: center.z,
    //   width,
    //   height: 0,
    //   depth,
    //   note: 'Nền',
    //   noCheckCollision: false,
    //   rotate: floor.rotation,
    //   group: floor,
    // });

    if (this._appearance.floorTexUrl) {
      this.updateFloorTextureFromImage(this._appearance.floorTexUrl, {
        metersPerTile: this._appearance.metersPerTile,
        repeatBy: this._appearance.floorRepeat,
      });
    }
  }

  getFloorSize() {
    return this.floorSize; // { width, depth }
  }

  createArrow = (start, end, color = 0x0000ff) => {
    const dir = new THREE.Vector3().subVectors(end, start).normalize();
    const length = start.distanceTo(end);

    const arrow = new THREE.ArrowHelper(dir, start, length, color, 0.2, 0.1);
    return arrow;
  };

  clearTextLabels() {
    this.labels.forEach(label => {
      this.scene.remove(label);
      label.geometry?.dispose?.();
      label.material?.dispose?.();
    });
    this.labels = [];
  }

  createDoubleArrow(
    start,
    end,
    color = 0x00aaff,
    shorten = 0.2,
    thickness = 1
  ) {
    const group = new THREE.Group();

    const direction = new THREE.Vector3().subVectors(end, start).normalize();
    const totalLength = start.distanceTo(end);

    // Tính điểm mới sau khi rút ngắn
    const newStart = start
      .clone()
      .add(direction.clone().multiplyScalar(shorten));
    const newEnd = end.clone().add(direction.clone().multiplyScalar(-shorten));

    // Line chính giữa
    const lineMaterial = new THREE.LineBasicMaterial({
      color,
      linewidth: thickness,
    });
    const lineGeometry = new THREE.BufferGeometry().setFromPoints([
      newStart.clone(),
      newEnd.clone(),
    ]);
    const line = new THREE.Line(lineGeometry, lineMaterial);
    group.add(line);

    // Hàm tạo cone
    const createArrowHead = (position, directionVec) => {
      const coneGeometry = new THREE.ConeGeometry(0.04, 0.1, 8);
      const coneMaterial = new THREE.MeshStandardMaterial({ color });
      const cone = new THREE.Mesh(coneGeometry, coneMaterial);
      cone.position.copy(position);

      // Xoay cone
      const axis = new THREE.Vector3(0, 1, 0);
      const quaternion = new THREE.Quaternion().setFromUnitVectors(
        axis,
        directionVec.clone().normalize()
      );
      cone.quaternion.copy(quaternion);

      return cone;
    };

    const arrow1 = createArrowHead(newStart, direction.clone().negate());
    const arrow2 = createArrowHead(newEnd, direction.clone());

    group.add(arrow1);
    group.add(arrow2);

    return group;
  }

  addMeasurementArrows(width, depth, height) {
    // Mũi tên chiều dài tường 1 (trục X)
    const arrow1 = this.createDoubleArrow(
      new THREE.Vector3(-width / 2, height + 0.2, -depth / 2),
      new THREE.Vector3(width / 2, height + 0.2, -depth / 2),
      0x258fd2
    );

    // Mũi tên chiều dài tường 2 (trục Z)
    const arrow2 = this.createDoubleArrow(
      new THREE.Vector3(-width / 2, height + 0.2, -depth / 2),
      new THREE.Vector3(-width / 2, height + 0.2, depth / 2),
      0x258fd2
    );

    const arrow3 = this.createDoubleArrow(
      new THREE.Vector3(width / 2 + 0.5, 0, -depth / 2),
      new THREE.Vector3(width / 2 + 0.5, height, -depth / 2),
      0x258fd2
    );

    this.scene.add(arrow1);
    this.scene.add(arrow2);
    this.scene.add(arrow3);

    this._createDimensionLabel('width', width, [0, height + 0.4, -depth / 2]);
    this._createDimensionLabel('depth', depth, [-width / 2, height + 0.4, 0]);
    this._createDimensionLabel('height', height, [
      width / 2 + 1,
      height / 2,
      -depth / 2,
    ]);

    this.measurementArrows = [arrow1, arrow2, arrow3];
  }

  updateWallHeight(height) {
    this.wallHeight = height;
    this.updateWallsAccordingToFloor();
  }

  wrapAndRepeat(texture, repeat) {
    texture.wrapS = texture.wrapT = THREE.RepeatWrapping;

    // Tính tỷ lệ cho texture 804x1200
    const aspectRatio = 804 / 1200; // 0.67
    texture.repeat.set(repeat, repeat / aspectRatio);

    // Sử dụng encoding thay vì colorSpace
    texture.encoding = THREE.sRGBEncoding;

    // Cải thiện chất lượng
    const maxAnisotropy =
      this.renderer?.capabilities?.getMaxAnisotropy?.() || 16;
    texture.anisotropy = maxAnisotropy;
    texture.minFilter = THREE.LinearMipmapLinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.generateMipmaps = true;

    return texture;
  }

  addCornerPillars() {
    const { width, depth } = this.floorSize;
    const wallHeight = this.wallHeight;
    const thickness = this.wallThickness;

    // Xóa cột góc cũ nếu có
    if (this.cornerPillars && this.cornerPillars.length > 0) {
      this.cornerPillars.forEach(pillar => {
        this.scene.remove(pillar);
        pillar.geometry.dispose();
        pillar.material.dispose();
      });
    }
    this.cornerPillars = [];

    const material = new THREE.MeshStandardMaterial({
      color: 0xffffff,
      roughness: 0.2,
      metalness: 0.0,
      transparent: true,
      opacity: 1.0,
      side: THREE.DoubleSide,
    });

    // ✅ 4 vị trí góc
    const corners = [
      {
        position: [
          -width / 2 - thickness / 2,
          wallHeight / 2,
          depth / 2 + thickness / 2,
        ],
        name: 'corner-back-left',
      },
      {
        position: [
          width / 2 + thickness / 2,
          wallHeight / 2,
          depth / 2 + thickness / 2,
        ],
        name: 'corner-back-right',
      },
      {
        position: [
          -width / 2 - thickness / 2,
          wallHeight / 2,
          -depth / 2 - thickness / 2,
        ],
        name: 'corner-front-left',
      },
      {
        position: [
          width / 2 + thickness / 2,
          wallHeight / 2,
          -depth / 2 - thickness / 2,
        ],
        name: 'corner-front-right',
      },
    ];

    corners.forEach(({ position, name }, index) => {
      const pillar = new THREE.Mesh(
        new THREE.BoxGeometry(thickness, wallHeight, thickness),
        material.clone()
      );
      pillar.position.set(...position);
      pillar.castShadow = false;
      pillar.userData.isCornerPillar = true;
      pillar.userData.cornerIndex = index;
      pillar.userData.cornerName = name;

      this.scene.add(pillar);
      this.cornerPillars.push(pillar);
    });
  }

  addCeiling() {
    const { width, depth } = this.floorSize;
    const wallHeight = this.wallHeight;
    const thickness = 0.1; // Độ dày trần nhà

    // Xóa trần cũ nếu có
    if (this.ceiling) {
      this.scene.remove(this.ceiling);
      this.ceiling.geometry.dispose();
      this.ceiling.material.dispose();
    }

    // Tạo material cho trần
    const material = new THREE.MeshStandardMaterial({
      color: 0xf5f5f5, // Màu trắng ngà
      roughness: 0.9,
      metalness: 0.15,
      // Thêm transparent để có thể ẩn hiện
      transparent: true,
      opacity: 1.0,
      side: THREE.DoubleSide,
    });

    // Tạo geometry trần
    const ceiling = new THREE.Mesh(
      new THREE.BoxGeometry(
        width + this.wallThickness * 2,
        thickness / 3,
        depth + this.wallThickness * 2
      ),
      material
    );

    // Đặt vị trí trần ở độ cao bằng chiều cao tường
    ceiling.position.set(0, wallHeight + thickness / 6, 0);
    ceiling.castShadow = false;
    ceiling.receiveShadow = false;
    ceiling.userData.isCeiling = true;

    this.scene.add(ceiling);
    this.ceiling = ceiling;

    const box = new THREE.Box3().setFromObject(ceiling);

    const center = new THREE.Vector3();
    box.getCenter(center);

    // this.positionController.addModule({
    //   id: ceiling.uuid,
    //   x: center.x,
    //   y: wallHeight,
    //   z: center.z,
    //   width,
    //   height: 0,
    //   depth,
    //   note: 'Trần',
    //   noCheckCollision: false,
    //   rotate: ceiling.rotation,
    //   group: ceiling,
    // });
  }

  // 3. Thêm phương thức cập nhật visibility cho trần
  updateCeilingVisibility() {
    if (!this.camera || !this.ceiling || !this.ceilingVisibilityEnabled) return;

    const cameraPosition = this.camera.position;
    const ceilingHeight = this.ceiling.position.y;

    // Trần chỉ hiển thị khi camera ở dưới trần
    const shouldShow = cameraPosition.y < ceilingHeight;

    const targetOpacity = shouldShow ? 1.0 : 0.0;
    const currentOpacity = this.ceiling.material.opacity;

    // Smooth transition
    if (Math.abs(currentOpacity - targetOpacity) > 0.01) {
      this.ceiling.material.opacity = THREE.MathUtils.lerp(
        currentOpacity,
        targetOpacity,
        0.2
      );
    } else {
      this.ceiling.material.opacity = targetOpacity;
    }

    // Tắt raycast khi ẩn
    if (shouldShow) {
      this.ceiling.raycast = THREE.Mesh.prototype.raycast;
    } else {
      this.ceiling.raycast = () => {};
    }

    this.ceiling.visible = this.ceiling.material.opacity > 0.01;
  }

  // 4. Thêm phương thức để bật/tắt tính năng ẩn hiện trần
  toggleCeilingVisibility(enabled = true) {
    this.ceilingVisibilityEnabled = enabled;

    if (!enabled && this.ceiling) {
      // Hiện trần khi tắt tính năng
      this.ceiling.material.opacity = 1.0;
      this.ceiling.visible = true;
      this.ceiling.raycast = THREE.Mesh.prototype.raycast;
    }
  }

  addToPlanToCheck = obj => {
    if (!obj) return;
    if (!this.planToCheck.includes(obj)) this.planToCheck.push(obj);
  };

  removeFromPlanToCheck = obj => {
    this.planToCheck = this.planToCheck.filter(o => o !== obj);
  };

  clearPlanToCheck = () => {
    this.planToCheck.length = 0;
  };

  updateFloorTextureFromImage(url, opts = {}) {
    if (!this.floor) return;

    const { metersPerTile = null, repeatBy = null } = opts;

    this._appearance = this._appearance || {};
    this._appearance.floorTexUrl = url;
    if (metersPerTile !== null) this._appearance.metersPerTile = metersPerTile;
    if (repeatBy !== null) this._appearance.floorRepeat = repeatBy;

    const loader = new THREE.TextureLoader();
    loader.load(
      url,
      tex => {
        // ===== FIX MÀU SẮC - QUAN TRỌNG =====
        // KHÔNG set encoding cho texture - để THREE tự động xử lý
        // tex.encoding = THREE.sRGBEncoding; // BỎ DÒNG NÀY!

        // Tăng chất lượng texture
        const maxAnisotropy =
          this.renderer?.capabilities?.getMaxAnisotropy?.() || 16;
        tex.anisotropy = maxAnisotropy;
        tex.minFilter = THREE.LinearMipmapLinearFilter;
        tex.magFilter = THREE.LinearFilter;
        tex.generateMipmaps = true;

        // ===== LOGIC CỐ ĐỊNH TÍNH TOÁN =====
        const PLANK_WIDTH = 0.804; // mét
        const PLANK_LENGTH = 1.1; // mét

        let repU, repV;

        if (this.floorSize) {
          repU = this.floorSize.width / PLANK_WIDTH;
          repV = this.floorSize.depth / PLANK_LENGTH;
        } else {
          repU = 6.2;
          repV = 3.3;
        }

        tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
        tex.repeat.set(repU, repV);

        const mat = this.floor.material;
        if (mat.map && mat.map !== tex) mat.map.dispose?.();
        mat.map = tex;

        // ===== FIX MÀU SẮC CHO MATERIAL =====
        // Tăng độ sáng nếu cần
        mat.color.setHex(0xcccccc); // Đảm bảo màu base là trắng
        mat.roughness = 1; // Giảm roughness để sáng hơn
        mat.metalness = 0.0; // Không metallic

        mat.needsUpdate = true;

        this.renderer?.render(this.scene, this.camera);
      },
      undefined,
      err => console.warn('Floor texture load error:', err)
    );
  }

  // =====================
  // 2) Đổi màu tường (cả cột + dầm)
  // =====================
  updateWallColor(hex = '#ffffff') {
    this._appearance = this._appearance || {};
    this._appearance.wallColor = hex;

    const apply = mesh => {
      if (!mesh || !mesh.material) return;
      mesh.material.color?.set?.(hex);
      mesh.material.needsUpdate = true;
    };

    this.walls.forEach(({ mesh }) => apply(mesh));
    this.columns.forEach(({ mesh }) => apply(mesh));
    this.beams.forEach(({ mesh }) => apply(mesh));
    (this.cornerPillars || []).forEach(apply);
  }

  updateWallsAccordingToFloor() {
    const { width, depth } = this.floorSize;
    const wallHeight = this.wallHeight;

    // Xóa tường cũ
    this.walls.forEach(({ mesh }) => {
      this.scene.remove(mesh);
      mesh.geometry.dispose();
      mesh.material.dispose();
    });
    this.walls = [];

    this.clearPlanToCheck();

    // Tạo 4 bức tường
    // Tường phía trước (front wall - Z âm)
    this.addWall({
      position: [0, wallHeight / 2, -depth / 2 - this.wallThickness / 2],
      size: [width, wallHeight, this.wallThickness],
      name: 'front',
    });

    // Tường phía sau (back wall - Z dương)
    this.addWall({
      position: [0, wallHeight / 2, depth / 2 + this.wallThickness / 2],
      size: [width, wallHeight, this.wallThickness],
      name: 'back',
    });

    // Tường bên trái (left wall - X âm)
    this.addWall({
      position: [-width / 2 - this.wallThickness / 2, wallHeight / 2, 0],
      size: [this.wallThickness, wallHeight, depth],
      name: 'left',
    });

    // Tường bên phải (right wall - X dương)
    this.addWall({
      position: [width / 2 + this.wallThickness / 2, wallHeight / 2, 0],
      size: [this.wallThickness, wallHeight, depth],
      name: 'right',
    });

    this.addCornerPillars();

    this.addCeiling();

    if (this.measurementArrows?.length) {
      this.measurementArrows.forEach(arrow => this.scene.remove(arrow));
    }
    this.clearTextLabels();
    if (this.draggable === true) {
      this.addMeasurementArrows(width, depth, wallHeight);
    }
    // re-apply màu tường/cột/dầm
    if (this._appearance.wallColor) {
      this.updateWallColor(this._appearance.wallColor);
    }
  }

  addWall({ position, size, name }) {
    const material = new THREE.MeshStandardMaterial({
      color: 0xffffff,
      roughness: 0.9,
      metalness: 0,
      // Thêm transparent để có thể ẩn hiện
      // transparent: true,
      opacity: 1.0,
      side: THREE.FrontSide,
    });

    const mesh = new THREE.Mesh(new THREE.BoxGeometry(...size), material);
    mesh.position.set(...position);
    mesh.castShadow = false;
    mesh.userData.wallName = name; // Thêm tên tường để dễ quản lý
    const sizeWall = this.getSize(mesh);
    mesh.userData.size = sizeWall;

    mesh.userData.type === 'wall';

    this.scene.add(mesh);
    this.walls.push({ mesh, position, size, name });

    const box = new THREE.Box3().setFromObject(mesh);
    const center = new THREE.Vector3();
    box.getCenter(center);

    // this.positionController.addModule({
    //   id: mesh.uuid + 'wall',
    //   x: center.x,
    //   y: 0,
    //   z: center.z,
    //   width: size[0],
    //   height: size[1],
    //   depth: size[2],
    //   note: 'Tường' + name,
    //   noCheckCollision: true,
    //   rotate: mesh.rotation,
    //   group: mesh,
    // });
    this.addToPlanToCheck(mesh);
  }

  updateWallVisibility() {
    if (
      !this.camera ||
      this.walls.length === 0 ||
      this.wallVisibilityEnabled === false
    )
      return;

    const cameraPosition = this.camera.position;
    const minOpacity = this.minWallOpacity || 0.0;

    // ✅ Thu thập trạng thái hiển thị của từng tường
    const wallVisibility = {};

    // Cập nhật tường và lưu trạng thái
    this.walls.forEach(({ mesh, name }) => {
      let shouldShow = true;

      switch (name) {
        case 'front':
          shouldShow = cameraPosition.z > mesh.position.z;
          break;
        case 'back':
          shouldShow = cameraPosition.z < mesh.position.z;
          break;
        case 'left':
          shouldShow = cameraPosition.x > mesh.position.x;
          break;
        case 'right':
          shouldShow = cameraPosition.x < mesh.position.x;
          break;
      }

      // Lưu trạng thái tường
      wallVisibility[name] = shouldShow;

      const targetOpacity = shouldShow ? 1.0 : minOpacity;
      const currentOpacity = mesh.material.opacity;

      if (Math.abs(currentOpacity - targetOpacity) > 0.01) {
        mesh.material.opacity = THREE.MathUtils.lerp(
          currentOpacity,
          targetOpacity,
          0.2
        );
      } else {
        mesh.material.opacity = targetOpacity;
      }

      if (shouldShow) {
        mesh.raycast = THREE.Mesh.prototype.raycast;
      } else {
        mesh.raycast = () => {};
      }

      mesh.visible = mesh.material.opacity > 0.01;
    });

    // ✅ Cập nhật corner pillars dựa trên trạng thái tường liền kề
    if (this.cornerPillars && this.cornerPillars.length > 0) {
      this.cornerPillars.forEach((pillar, index) => {
        let shouldShow = true;

        // ✅ Logic mới: Cột góc chỉ hiện khi CẢ HAI tường liền kề đều hiển thị
        switch (index) {
          case 0: // corner-back-left (góc giữa tường back và left)
            shouldShow = wallVisibility.back && wallVisibility.left;
            break;
          case 1: // corner-back-right (góc giữa tường back và right)
            shouldShow = wallVisibility.back && wallVisibility.right;
            break;
          case 2: // corner-front-left (góc giữa tường front và left)
            shouldShow = wallVisibility.front && wallVisibility.left;
            break;
          case 3: // corner-front-right (góc giữa tường front và right)
            shouldShow = wallVisibility.front && wallVisibility.right;
            break;
        }

        const targetOpacity = shouldShow ? 1.0 : minOpacity;
        const currentOpacity = pillar.material.opacity;

        if (Math.abs(currentOpacity - targetOpacity) > 0.01) {
          pillar.material.opacity = THREE.MathUtils.lerp(
            currentOpacity,
            targetOpacity,
            0.2
          );
        } else {
          pillar.material.opacity = targetOpacity;
        }

        // Tắt raycast cho corner pillars ẩn
        pillar.raycast = shouldShow ? THREE.Mesh.prototype.raycast : () => {};
        pillar.visible = pillar.material.opacity > 0.01;
      });
    }
  }

  // Cập nhật phương thức animate để kiểm tra visibility

  // Phương thức để bật/tắt tính năng ẩn hiện tường
  toggleWallVisibility(enabled = true) {
    this.wallVisibilityEnabled = enabled;

    if (!enabled) {
      // Hiện tất cả tường khi tắt tính năng
      this.walls.forEach(({ mesh }) => {
        mesh.material.opacity = 1.0;
        mesh.visible = true;
      });
    }
  }

  // Phương thức để thiết lập độ trong suốt tối thiểu khi ẩn
  setWallMinOpacity(opacity = 0.1) {
    this.minWallOpacity = Math.max(0, Math.min(1, opacity));
  }

  // Cập nhật lại phương thức updateWallVisibility với opacity tối thiểu
  // updateWallVisibility() {
  //   if (!this.camera || this.walls.length === 0 || this.wallVisibilityEnabled === false) return;

  //   const cameraPosition = this.camera.position;
  //   const minOpacity = this.minWallOpacity || 0.0;

  //   this.walls.forEach(({ mesh, name }) => {
  //     let shouldShow = true;

  //     switch (name) {
  //       case 'front':
  //         shouldShow = cameraPosition.z > mesh.position.z;
  //         break;
  //       case 'back':
  //         shouldShow = cameraPosition.z < mesh.position.z;
  //         break;
  //       case 'left':
  //         shouldShow = cameraPosition.x > mesh.position.x;
  //         break;
  //       case 'right':
  //         shouldShow = cameraPosition.x < mesh.position.x;
  //         break;
  //     }

  //     const targetOpacity = shouldShow ? 1.0 : minOpacity;
  //     const currentOpacity = mesh.material.opacity;

  //     if (Math.abs(currentOpacity - targetOpacity) > 0.01) {
  //       mesh.material.opacity = THREE.MathUtils.lerp(currentOpacity, targetOpacity, 0.1);
  //     } else {
  //       mesh.material.opacity = targetOpacity;
  //     }

  //     mesh.raycast = shouldShow ? THREE.Mesh.prototype.raycast : () => {};

  //     mesh.visible = mesh.material.opacity > 0.01;
  //   });
  // }

  addColumn(defaultWidth = 0.35, defaultDepth = 0.35) {
    if (this.walls.length === 0) {
      console.warn(
        'Chưa có tường (this.wall). Hãy tạo tường trước khi thêm cột.'
      );
      return;
    }

    // Tính kích thước thực tế của tường qua bounding box
    const box = new THREE.Box3().setFromObject(this.walls[0].mesh);
    const sizeVec = new THREE.Vector3();
    box.getSize(sizeVec);

    const wallHeight = sizeVec.y;
    const width = defaultWidth;
    const height = wallHeight;
    const depth = defaultDepth;

    const size = [width, height, depth];
    const mat = new THREE.MeshStandardMaterial({
      color: new THREE.Color(this._appearance?.wallColor || 0x666666),
    });
    const mesh = new THREE.Mesh(new THREE.BoxGeometry(...size), mat);

    const position = { x: 0, y: height / 2, z: 0 };

    if (this.columns.length > 0) {
      const last = this.columns[this.columns.length - 1];
      position.x = last.mesh.position.x + width + 0.01;
      position.y = height / 2;
      position.z = last.mesh.position.z;
    }

    mesh.position.set(position.x, position.y, position.z);
    mesh.castShadow = false;

    this.scene.add(mesh);
    this.columns.push({ mesh, position, size });

    const boxMesh = new THREE.Box3().setFromObject(mesh);
    const center = new THREE.Vector3();
    boxMesh.getCenter(center);

    // this.positionController.addModule({
    //   id: mesh.uuid + 'column',
    //   x: center.x,
    //   y: 0,
    //   z: center.z,
    //   width,
    //   height,
    //   depth,
    //   note: 'Cột' + this.columns.length,
    //   noCheckCollision: false,
    //   rotate: mesh.rotation,
    //   group: mesh,
    // });
  }

  removeColumn(mesh) {
    const index = this.columns.findIndex(
      item => item.mesh?.uuid === mesh?.uuid
    );
    this.columns.splice(index, 1);
    return true;
  }

  removeBeam(mesh) {
    const index = this.beams.findIndex(item => item.mesh?.uuid === mesh?.uuid);
    this.beams.splice(index, 1);
    return true;
  }

  addAxesHelper(size = 1.5) {
    const axesHelper = new THREE.AxesHelper(size);
    this.scene.add(axesHelper);
  }

  addBeam({ position, size }) {
    const mat = new THREE.MeshStandardMaterial({
      color: new THREE.Color(this._appearance?.wallColor || 0x666666),
    });
    const mesh = new THREE.Mesh(new THREE.BoxGeometry(...size), mat);
    mesh.position.set(...position);
    mesh.castShadow = false;
    this.scene.add(mesh);
    this.beams.push({ mesh, position, size });

    const boxMesh = new THREE.Box3().setFromObject(mesh);
    const center = new THREE.Vector3();
    boxMesh.getCenter(center);

    const [width, height, depth] = size;

    // this.positionController.addModule({
    //   id: mesh.uuid + 'beam',
    //   x: center.x,
    //   y: 0,
    //   z: center.z,
    //   width,
    //   height,
    //   depth,
    //   note: 'Dầm' + this.columns.length,
    //   noCheckCollision: false,
    //   rotate: mesh.rotation,
    //   group: mesh,
    // });
  }

  addBeamForWall1() {
    const { width } = this.getFloorSize();
    const height = this.wallHeight;

    this.addBeam({
      position: [0, height - 0.35 / 2, -this.floorSize.depth / 2 + 0.35 / 2],
      size: [width, 0.35, 0.35],
    });
  }

  addBeamForWall2() {
    const { depth } = this.getFloorSize();
    const height = this.wallHeight;

    this.addBeam({
      position: [-this.floorSize.width / 2 + 0.35 / 2, height - 0.35 / 2, 0],
      size: [0.35, 0.35, depth],
    });
  }

  clearStructure() {
    [...this.walls, ...this.columns, ...this.beams].forEach(({ mesh }) => {
      // this.positionController.removeModule(mesh.uuid);
      this.scene.remove(mesh);
      mesh.geometry.dispose();
      mesh.material.dispose();
    });

    if (this.ceiling) {
      this.scene.remove(this.ceiling);
      this.ceiling.geometry.dispose();
      this.ceiling.material.dispose();
      this.ceiling = null;
    }

    this.walls = [];
    this.columns = [];
    this.beams = [];
  }

  exportSceneData() {
    return {
      floorSize: this.floorSize,
      wallHeight: this.wallHeight,
      wallTexture: this._appearance?.wallColor || null,
      floorTexture: this._appearance?.floorTexUrl || null,
      walls: this.walls.map(({ mesh, size }) => ({
        position: [mesh.position.x, mesh.position.y, mesh.position.z],
        size,
      })),
      columns: this.columns.map(({ mesh, size }) => ({
        position: [mesh.position.x, mesh.position.y, mesh.position.z],
        size,
      })),
      beams: this.beams.map(({ mesh, size }) => ({
        position: [mesh.position.x, mesh.position.y, mesh.position.z],
        size,
      })),

      ceiling: this.ceiling
        ? {
            position: [
              this.ceiling.position.x,
              this.ceiling.position.y,
              this.ceiling.position.z,
            ],
            size: [
              this.ceiling.geometry.parameters.width,
              this.ceiling.geometry.parameters.height,
              this.ceiling.geometry.parameters.depth,
            ],
          }
        : null,
    };
  }

  importSceneData(data) {
    // Clear toàn bộ cấu trúc cũ
    this.clearStructure();

    // Cập nhật sàn nếu có
    if (data.floorSize) {
      this.floorSize = data.floorSize;
      this.createGround(data.floorSize.width, data.floorSize.depth);
    }

    // Cập nhật chiều cao tường nếu có
    if (data.wallHeight) {
      this.wallHeight = data.wallHeight;
    }

    // Thêm lại tường
    if (Array.isArray(data.walls)) {
      data.walls.forEach(wall => {
        this.addWall(wall);
      });
    }

    this.updateWallsAccordingToFloor();

    // Thêm lại cột
    if (Array.isArray(data.columns)) {
      data.columns.forEach(({ position, size }) => {
        const material = new THREE.MeshStandardMaterial({ color: 0x666666 });
        const mesh = new THREE.Mesh(new THREE.BoxGeometry(...size), material);
        mesh.position.set(...Object.values(position));
        mesh.castShadow = false;

        mesh.userData = {
          isColumn: true,
          size: { width: size[0], height: size[1], depth: size[2] },
        };
        mesh.name = 'COLUMN';

        this.scene.add(mesh);

        // Cập nhật position từ chính mesh
        const updatedPos = {
          x: mesh.position.x,
          y: mesh.position.y,
          z: mesh.position.z,
        };

        this.columns.push({ mesh, position: updatedPos, size });

        const [width, height, depth] = size;
        const boxMesh = new THREE.Box3().setFromObject(mesh);
        const center = new THREE.Vector3();
        boxMesh.getCenter(center);

        // this.positionController.addModule({
        //   id: mesh.uuid,
        //   x: center.x,
        //   y: 0,
        //   z: center.z,
        //   width,
        //   height,
        //   depth,
        //   note: 'Cột' + this.columns.length,
        //   noCheckCollision: false,
        //   rotate: mesh.rotation,
        //   group: mesh,
        // });
      });
    }

    // Thêm lại dầm
    if (Array.isArray(data.beams)) {
      data.beams.forEach(({ position, size }) => {
        const material = new THREE.MeshStandardMaterial({ color: 0x666666 });
        const mesh = new THREE.Mesh(new THREE.BoxGeometry(...size), material);
        mesh.position.set(...Object.values(position));
        mesh.castShadow = false;
        mesh.name = 'BEAM';

        this.scene.add(mesh);

        // Cập nhật position từ chính mesh
        const updatedPos = {
          x: mesh.position.x,
          y: mesh.position.y,
          z: mesh.position.z,
        };

        this.beams.push({ mesh, position: updatedPos, size });

        const boxMesh = new THREE.Box3().setFromObject(mesh);
        const center = new THREE.Vector3();
        boxMesh.getCenter(center);

        const [width, height, depth] = size;

        // this.positionController.addModule({
        //   id: mesh.uuid,
        //   x: center.x,
        //   y: 0,
        //   z: center.z,
        //   width,
        //   height,
        //   depth,
        //   note: 'Dầm' + this.columns.length,
        //   noCheckCollision: false,
        //   rotate: mesh.rotation,
        //   group: mesh,
        // });
      });
    }

    // Cập nhật lại tường theo kích thước mới
  }

  /**
   * Set label active state
   */
  _setLabelActive(labelDiv, active) {
    if (labelDiv.label) {
      if (active) {
        labelDiv.element.classList.add('active');
      } else {
        labelDiv.element.classList.remove('active');
      }
    }
  }

  /**
   * Disable edit mode và return về label normal
   */
  _disableEditMode(labelDiv, content = null) {
    if (labelDiv.dataset.editing === 'false') return;

    labelDiv.dataset.editing = 'false';
    labelDiv.classList.remove('editing');

    if (content) {
      labelDiv.textContent = content;
    } else {
      const distance = parseFloat(labelDiv.dataset.distance);
      labelDiv.textContent = `${Math.abs(distance).toFixed(2)}m`;
    }

    labelDiv.classList.add('new');
    setTimeout(() => labelDiv.classList.remove('new'), 300);
  }

  /**
   * Apply new distance value và update module position
   */
  _applyNewDistance(newDistance, labelDiv, mesh) {
    const { width, depth } = this.floorSize;
    if (labelDiv && mesh) {
      const direction = labelDiv.dataset.direction;
      const wallFront = this.walls.find(w => w.name === 'front');
      const wallBack = this.walls.find(w => w.name === 'back');
      const wallLeft = this.walls.find(w => w.name === 'left');
      const wallRight = this.walls.find(w => w.name === 'right');
      const obj = new THREE.Box3().setFromObject(mesh);
      const { x, z } = obj.getSize(new THREE.Vector3());

      if (
        direction === 'front' &&
        // newDistance + x <= width &&
        wallFront
      ) {
        this.updateMeshDistance({ distanceToWallFront: newDistance });
      } else if (
        direction === 'left' &&
        // newDistance + z <= depth &&
        wallLeft
      ) {
        this.updateMeshDistance({ distanceToWallLeft: newDistance });
      } else if (
        direction === 'back' &&
        // newDistance + x <= width &&
        wallBack
      ) {
        this.updateMeshDistance({ distanceToWallBack: newDistance });
      } else if (
        direction === 'right' &&
        // newDistance + z <= depth &&
        wallRight
      ) {
        this.updateMeshDistance({ distanceToWallRight: newDistance });
      }
    }

    this.showDistanceArrows(mesh);
  }

  /**
   * Enable edit mode cho label
   */
  _enableEditMode(labelDiv, mesh) {
    if (labelDiv.dataset.editing === 'true') return;

    labelDiv.dataset.editing = 'true';
    const currentValue = parseFloat(labelDiv.dataset.distance);
    const originalContent = labelDiv.textContent;

    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'distance-input';
    input.value = Math.abs(currentValue).toFixed(0);
    input.placeholder = 'Nhập';

    labelDiv.classList.add('editing');
    labelDiv.textContent = '';
    labelDiv.appendChild(input);

    input.focus();
    input.select();

    const validateAndApply = () => {
      let newValue = parseFloat(input.value);
      if (
        getInputType(input.value) === 'expression' &&
        isValidExpression(input.value)
      ) {
        newValue = roundTo(Math.abs(evaluateExpression(input.value))) / 1000;
      }
      if (isNaN(newValue) || newValue < 0) {
        input.classList.add('invalid');
        setTimeout(() => input.classList.remove('invalid'), 300);
        return false;
      }

      this._applyNewDistance(newValue / 1000, labelDiv, mesh);
      return true;
    };

    input.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (validateAndApply()) {
          this._disableEditMode(labelDiv);
        }
      } else if (e.key === 'Escape') {
        e.preventDefault();
        this._disableEditMode(labelDiv, originalContent);
      }
    });

    input.addEventListener('blur', e => {
      setTimeout(() => {
        if (labelDiv.dataset.editing === 'true') {
          if (!validateAndApply()) {
            this._disableEditMode(labelDiv, originalContent);
          } else {
            this._disableEditMode(labelDiv);
          }
        }
      }, 100);
    });

    input.addEventListener('click', e => e.stopPropagation());
    input.addEventListener('dblclick', e => e.stopPropagation());
  }

  /**
   * Tạo CSS2D label hiển thị giá trị khoảng cách
   */
  _createDistanceLabel(midPoint, distance, direction, mesh) {
    // Tạo div element cho label
    const labelDiv = document.createElement('div');
    labelDiv.className = 'distance-label new';
    labelDiv.textContent = `${distance} mm`;
    labelDiv.title = 'Double click to edit';
    labelDiv.dataset.editing = 'false';
    labelDiv.dataset.distance = distance;
    labelDiv.dataset.direction = direction;
    labelDiv.dataset.mesh = mesh;

    // Single click - highlight
    labelDiv.addEventListener('click', e => {
      e.stopPropagation();
      if (labelDiv.dataset.editing === 'false') {
        this._setLabelActive(!labelDiv.classList.contains('active'));
      }
    });

    // Double click - edit mode
    labelDiv.addEventListener('dblclick', e => {
      e.stopPropagation();
      this._enableEditMode(labelDiv, mesh);
    });

    // Tạo CSS2DObject
    const label = new CSS2DObject(labelDiv);
    label.position.copy(midPoint);

    setTimeout(() => {
      labelDiv.classList.remove('new');
    }, 300);

    return label;
  }

  /**
   * CSS2D label hiển thị kích thước phòng, double click để nhập giá trị mới
   */
  _createDimensionLabel(dimension, meters, position) {
    const titles = {
      width: 'Wall Length 1',
      depth: 'Wall Length 2',
      height: 'Height',
    };
    const mm = roundTo(meters * 1000, 0);

    const labelDiv = document.createElement('div');
    labelDiv.className = 'distance-label new';
    labelDiv.textContent = `${i18n.t(titles[dimension])}: ${mm} mm`;
    labelDiv.title = 'Double click to edit';
    labelDiv.dataset.editing = 'false';
    labelDiv.dataset.dimension = dimension;
    labelDiv.dataset.mm = mm;

    labelDiv.addEventListener('click', e => e.stopPropagation());
    labelDiv.addEventListener('dblclick', e => {
      e.stopPropagation();
      this._enableDimensionEditMode(labelDiv);
    });

    const label = new CSS2DObject(labelDiv);
    label.position.set(...position);

    setTimeout(() => {
      labelDiv.classList.remove('new');
    }, 300);

    this.scene.add(label);
    this.labels.push(label);
    return label;
  }

  /**
   * Enable edit mode cho label kích thước phòng
   */
  _enableDimensionEditMode(labelDiv) {
    if (labelDiv.dataset.editing === 'true') return;

    labelDiv.dataset.editing = 'true';
    const originalContent = labelDiv.textContent;

    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'distance-input';
    input.value = labelDiv.dataset.mm;
    input.placeholder = 'Nhập';

    labelDiv.classList.add('editing');
    labelDiv.textContent = '';
    labelDiv.appendChild(input);

    input.focus();
    input.select();

    const cancelEdit = () => {
      if (labelDiv.dataset.editing === 'false') return;

      labelDiv.dataset.editing = 'false';
      labelDiv.classList.remove('editing');
      labelDiv.textContent = originalContent;
      labelDiv.classList.add('new');
      setTimeout(() => labelDiv.classList.remove('new'), 300);
    };

    const validateAndApply = () => {
      const raw = input.value;
      const mm =
        getInputType(raw) === 'expression' && isValidExpression(raw)
          ? Math.abs(evaluateExpression(raw))
          : parseFloat(raw);
      const meters = mm / 1000;

      // Cùng giới hạn 1m - 10m với validator của WallSetupForm
      if (isNaN(meters) || meters < 1 || meters > 10) {
        input.classList.add('invalid');
        setTimeout(() => input.classList.remove('invalid'), 300);
        return false;
      }

      // Đánh dấu xong trước khi apply: apply sẽ dựng lại toàn bộ label,
      // blur của input bị gỡ khỏi DOM không được chạy apply lần nữa.
      labelDiv.dataset.editing = 'false';
      this._applyNewDimension(labelDiv.dataset.dimension, meters);
      return true;
    };

    input.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        validateAndApply();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        cancelEdit();
      }
    });

    input.addEventListener('blur', () => {
      setTimeout(() => {
        if (labelDiv.dataset.editing === 'true' && !validateAndApply()) {
          cancelEdit();
        }
      }, 100);
    });

    input.addEventListener('click', e => e.stopPropagation());
    input.addEventListener('dblclick', e => e.stopPropagation());
  }

  /**
   * Apply kích thước phòng mới (mét) từ label
   */
  _applyNewDimension(dimension, meters) {
    if (dimension === 'width') {
      this.updateFloorSize(meters, this.floorSize.depth);
    } else if (dimension === 'depth') {
      this.updateFloorSize(this.floorSize.width, meters);
    } else {
      this.updateWallHeight(meters);
    }

    this.onDimensionChange?.({
      width: this.floorSize.width,
      depth: this.floorSize.depth,
      height: this.wallHeight,
    });
  }

  showDistanceArrows(mesh) {
    this.removeDistanceArrows();
    this.showDistanceArrowToWallFrontAndBack(mesh);
    this.showDistanceArrowToWallLeftAndRight(mesh);
  }

  distanceToWallFrontAndBack(mesh) {
    const wallFront = this.walls.find(w => w.name === 'front'); // tường Z
    const wallBack = this.walls.find(w => w.name === 'back'); // tường Z

    const box = new THREE.Box3().setFromObject(mesh);
    const size = box.getSize(new THREE.Vector3());

    const position = mesh.position;

    if (wallFront && wallBack) {
      const wallFrontZ = wallFront.mesh.position.z;
      const wallBackZ = wallBack.mesh.position.z;

      const objZ = position.z;
      const objDepth = size.z;
      const distanceToWallFront = Math.abs(
        objZ - wallFrontZ - this.wallThickness / 2 - objDepth / 2
      );
      const distanceToWallBack = Math.abs(
        -objZ + wallBackZ - this.wallThickness / 2 - objDepth / 2
      );

      return {
        distanceToWallFront,
        distanceToWallBack,
        position,
        objDepth,
        wallFrontZ,
        wallBackZ,
      };
    }
    return undefined;
  }

  distanceToWallLeftAndRight(mesh) {
    const wallLeft = this.walls.find(w => w.name === 'left'); // tường X
    const wallRight = this.walls.find(w => w.name === 'right'); // tường X

    this.removeDistanceArrowLeftAndRight(); // clear mũi tên cũ

    const box = new THREE.Box3().setFromObject(mesh);
    const size = box.getSize(new THREE.Vector3());

    const position = mesh.position;

    if (wallLeft && wallRight) {
      const wallLeftX = wallLeft.mesh.position.x;
      const wallRightX = wallRight.mesh.position.x;

      const objX = position.x;
      const objWidth = size.x;
      const distanceToWallLeft = Math.abs(
        objX - wallLeftX - this.wallThickness / 2 - objWidth / 2
      );
      const distanceToWallRight = Math.abs(
        -objX + wallRightX - this.wallThickness / 2 - objWidth / 2
      );

      return {
        distanceToWallLeft,
        distanceToWallRight,
        position,
        objWidth,
        wallLeftX,
        wallRightX,
      };
    }
    return undefined;
  }

  showDistanceArrowToWallFrontAndBack(mesh) {
    const {
      distanceToWallFront,
      distanceToWallBack,
      position,
      objDepth,
      wallFrontZ,
      wallBackZ,
    } = this.distanceToWallFrontAndBack(mesh);
    if (distanceToWallFront && distanceToWallBack) {
      const column = this.columns.find(col => col.mesh === this.selectedMesh);
      const beam = this.beams.find(b => b.mesh === this.selectedMesh);

      const heightArrow = column ? 0.1 : beam ? mesh.position.y : 0.1;

      this.removeDistanceArrowFrontAndBack(); // clear mũi tên cũ
      const startFront = new THREE.Vector3(
        position.x,
        heightArrow,
        position.z - objDepth / 2
      );
      const endFront = new THREE.Vector3(
        position.x,
        heightArrow,
        (position.z > wallFrontZ
          ? position.z - distanceToWallFront
          : position.z + distanceToWallFront) -
          objDepth / 2
      );
      const arrowFront = this.createDoubleArrow(
        startFront,
        endFront,
        new THREE.Color('#000'),
        0.1
      );
      const startBack = new THREE.Vector3(
        position.x,
        heightArrow,
        position.z + objDepth / 2
      );
      const endBack = new THREE.Vector3(
        position.x,
        heightArrow,
        (position.z > wallBackZ
          ? position.z - distanceToWallBack
          : position.z + distanceToWallBack) +
          objDepth / 2
      );
      const arrowBack = this.createDoubleArrow(
        startBack,
        endBack,
        new THREE.Color('#000'),
        0.1
      );
      this.scene.add(arrowFront);
      this.scene.add(arrowBack);
      this.distanceArrowFrontAndBack = [arrowFront, arrowBack];

      // Label giữa arrow
      const midpointFront = startFront
        .clone()
        .add(endFront)
        .multiplyScalar(0.5)
        .setY(heightArrow + 0.7);
      const labelFront = this._createDistanceLabel(
        midpointFront,
        roundTo(distanceToWallFront * 1000, 0),
        'front',
        mesh
      );
      const midpointBack = startBack
        .clone()
        .add(endBack)
        .multiplyScalar(0.5)
        .setY(heightArrow + 0.7);
      const labelBack = this._createDistanceLabel(
        midpointBack,
        roundTo(distanceToWallBack * 1000, 0),
        'back',
        mesh
      );
      this.scene.add(labelFront);
      this.scene.add(labelBack);
      this.distabceTextFrontAndBack = [labelFront, labelBack];
    }
  }

  showDistanceArrowToWallLeftAndRight(mesh) {
    const {
      distanceToWallLeft,
      distanceToWallRight,
      position,
      objWidth,
      wallLeftX,
      wallRightX,
    } = this.distanceToWallLeftAndRight(mesh);
    if (distanceToWallLeft && distanceToWallRight) {
      const column = this.columns.find(col => col.mesh === this.selectedMesh);
      const beam = this.beams.find(b => b.mesh === this.selectedMesh);

      const heightArrow = column ? 0.1 : beam ? mesh.position.y : 0.1;

      this.removeDistanceArrowLeftAndRight(); // clear mũi tên cũ
      const startLeft = new THREE.Vector3(
        position.x - objWidth / 2,
        heightArrow,
        position.z
      );
      const endLeft = new THREE.Vector3(
        (position.x > wallLeftX
          ? position.x - distanceToWallLeft
          : position.x + distanceToWallLeft) -
          objWidth / 2,
        heightArrow,
        position.z
      );
      const arrowLeft = this.createDoubleArrow(
        startLeft,
        endLeft,
        new THREE.Color('#000'),
        0.1
      );
      const startRight = new THREE.Vector3(
        position.x + objWidth / 2,
        heightArrow,
        position.z
      );
      const endRight = new THREE.Vector3(
        (position.x > wallRightX
          ? position.x - distanceToWallRight
          : position.x + distanceToWallRight) +
          objWidth / 2,
        heightArrow,
        position.z
      );
      const arrowRight = this.createDoubleArrow(
        startRight,
        endRight,
        new THREE.Color('#000'),
        0.1
      );
      this.scene.add(arrowLeft);
      this.scene.add(arrowRight);
      this.distanceArrowLeftAndRight = [arrowLeft, arrowRight];

      const midpointLeft = startLeft
        .clone()
        .add(endLeft)
        .multiplyScalar(0.5)
        .setY(heightArrow + 0.7);
      const labelLeft = this._createDistanceLabel(
        midpointLeft,
        roundTo(distanceToWallLeft * 1000, 0),
        'left',
        mesh
      );
      const midpointRight = startRight
        .clone()
        .add(endRight)
        .multiplyScalar(0.5)
        .setY(heightArrow + 0.7);

      const labelRight = this._createDistanceLabel(
        midpointRight,
        roundTo(distanceToWallRight * 1000, 0),
        'right',
        mesh
      );
      this.scene.add(labelLeft);
      this.scene.add(labelRight);
      this.distanceTextLeftAndRight = [labelLeft, labelRight];
    }
  }

  removeDistanceArrows() {
    this.removeDistanceArrowFrontAndBack();
    this.removeDistanceArrowLeftAndRight();
  }

  removeDistanceArrowLeftAndRight() {
    if (this.distanceArrowLeftAndRight?.length) {
      this.distanceArrowLeftAndRight.forEach(arrow => {
        this.scene.remove(arrow);
      });
      this.distanceArrowLeftAndRight = null;
    }

    if (this.distanceTextLeftAndRight?.length) {
      this.distanceTextLeftAndRight.forEach(text => {
        this.scene.remove(text);
      });
      this.distanceTextLeftAndRight = null;
    }
  }

  removeDistanceArrowFrontAndBack() {
    if (this.distanceArrowFrontAndBack?.length) {
      this.distanceArrowFrontAndBack.forEach(arrow => {
        this.scene.remove(arrow);
      });
      this.distanceArrowFrontAndBack = null;
    }

    if (this.distabceTextFrontAndBack?.length) {
      this.distabceTextFrontAndBack.forEach(text => {
        this.scene.remove(text);
      });
      this.distabceTextFrontAndBack = null;
    }
  }

  animate() {
    this._animationId = requestAnimationFrame(() => this.animate());
    if (this.isDisposed) return;
    this.controls?.update();
    this.updateWallVisibility();
    this.updateCeilingVisibility();
    if (this.camera && this.renderer && this.scene) {
      this.labelRenderer.render(this.scene, this.camera);
      this.renderer.render(this.scene, this.camera);
      this.composer?.render();
      this.updateBorderErrorMeshAnimation();
      this._afterRenderListeners?.forEach(listener => listener(this.camera));
    }
  }

  /**
   * Đăng ký callback chạy sau mỗi frame render (vd: đồng bộ SVG overlay DIM).
   * Trả về hàm huỷ đăng ký.
   */
  addAfterRenderListener(listener) {
    if (!this._afterRenderListeners) this._afterRenderListeners = new Set();
    this._afterRenderListeners.add(listener);
    return () => this._afterRenderListeners?.delete(listener);
  }

  onWindowResize() {
    if (this.camera) {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
    }
    if (this.renderer)
      this.renderer.setSize(window.innerWidth, window.innerHeight);
    if (this.composer) {
      this.composer.setSize(window.innerWidth, window.innerHeight);
      this.composer.setPixelRatio(window.devicePixelRatio);
    }
    this.labelRenderer.setSize(window.innerWidth, window.innerHeight);
  }

  updateModulePositionAfterScale = (module, oldDimensions, newDimensions) => {
    // if (module.userData.moduleType.toLowerCase().includes('corner')) {
    //   return;
    // }

    const orientation = GeometryUtils.getModuleOrientation(module);

    const widthDelta = newDimensions?.width
      ? newDimensions.width - oldDimensions.width
      : 0;
    const depthDelta = newDimensions?.depth
      ? newDimensions.depth - oldDimensions.depth
      : 0;

    if (orientation === 'NORMAL') {
      module.position.x += depthDelta / 2;
      module.position.z -= widthDelta / 2;
    } else if (orientation === 'ROTATED_90') {
      module.position.x -= widthDelta / 2;
      module.position.z -= depthDelta / 2;
    } else if (orientation === 'ROTATED_180') {
      module.position.x -= depthDelta / 2;
      module.position.z += widthDelta / 2;
    } else if (orientation === 'ROTATED_270') {
      module.position.x += widthDelta / 2;
      module.position.z += depthDelta / 2;
    }
  };

  exportToDAE(filename = 'model.dae') {
    return new Promise(resolve => {
      const exporter = new ColladaExporter();
      const group = new THREE.Group();

      this.scene.traverse(child => {
        if (
          child.userData &&
          (child.userData.type === 'module' ||
            child.userData.type === 'cabinetTrim' ||
            child.userData.type === 'cabinetCover')
        ) {
          child.traverse(cItem => {
            if (cItem.isMesh && cItem.visible) {
              if (cItem.userData?.type === InsideType.ACCESSORY_DISH_UPPER) {
                return;
              }

              const cloneCItem = cItem.clone();
              cloneCItem.position.copy(
                cItem.getWorldPosition(new THREE.Vector3())
              );
              cloneCItem.quaternion.copy(
                cItem.getWorldQuaternion(new THREE.Quaternion())
              );
              cloneCItem.scale.copy(cItem.getWorldScale(new THREE.Vector3()));
              group.add(cloneCItem);
            }
          });
        }
      });

      const materialProps = {
        metalness: 0.4,
        roughness: 0.8,
        color: '#f1f1f1',
        normalScale: new THREE.Vector2(0.15, 0.15),
      };
      const ballMat = new THREE.MeshStandardMaterial(materialProps);

      group.traverse(node => {
        if (node.isMesh) {
          node.material = ballMat;
        }
      });

      exporter.parse(group, result => {
        const colladaData = result.data;
        const blob = new Blob([colladaData], { type: 'model/vnd.collada+xml' });
        const file = new File([blob], filename, {
          type: 'model/vnd.collada+xml',
        });
        resolve(file);
      });
    });
  }

  exportToDAEfile(filename = 'model.dae') {
    return new Promise(resolve => {
      const exporter = new ColladaExporter();
      const group = new THREE.Group();

      this.scene.traverse(child => {
        if (
          child.userData &&
          (child.userData.type === 'module' ||
            child.userData.type === 'cabinetTrim' ||
            child.userData.type === 'cabinetCover')
        ) {
          child.traverse(cItem => {
            if (cItem.isMesh && cItem.visible) {
              if (cItem.userData?.type === InsideType.ACCESSORY_DISH_UPPER) {
                return;
              }

              const cloneCItem = cItem.clone();
              cloneCItem.position.copy(
                cItem.getWorldPosition(new THREE.Vector3())
              );
              cloneCItem.quaternion.copy(
                cItem.getWorldQuaternion(new THREE.Quaternion())
              );
              cloneCItem.scale.copy(cItem.getWorldScale(new THREE.Vector3()));
              group.add(cloneCItem);
            }
          });
        }
      });

      const materialProps = {
        metalness: 0.4,
        roughness: 0.8,
        color: '#f1f1f1',
        normalScale: new THREE.Vector2(0.15, 0.15),
      };
      const ballMat = new THREE.MeshStandardMaterial(materialProps);

      group.traverse(node => {
        if (node.isMesh) {
          node.material = ballMat;
        }
      });

      exporter.parse(group, result => {
        const colladaData = result.data;
        const blob = new Blob([colladaData], { type: 'model/vnd.collada+xml' });

        // Tạo URL tạm và trigger download
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        resolve();
      });
    });
  }

  exportToGLB(filename = 'model.glb') {
    return new Promise(resolve => {
      const exporter = new GLTFExporter();
      const group = new THREE.Group();

      this.scene.traverse(child => {
        if (
          child.userData &&
          (child.userData.type === 'module' ||
            child.userData.type === 'cabinetTrim' ||
            child.userData.type === 'cabinetCover')
        ) {
          child.traverse(cItem => {
            if (cItem.isMesh && cItem.visible) {
              if (cItem.userData?.type === InsideType.ACCESSORY_DISH_UPPER) {
                return;
              }
              const cloneCItem = cItem.clone();
              cloneCItem.position.copy(
                cItem.getWorldPosition(new THREE.Vector3())
              );
              cloneCItem.quaternion.copy(
                cItem.getWorldQuaternion(new THREE.Quaternion())
              );
              cloneCItem.scale.copy(cItem.getWorldScale(new THREE.Vector3()));
              group.add(cloneCItem);
            }
          });
        }
      });

      const materialProps = {
        metalness: 0.4,
        roughness: 0.8,
        color: '#f1f1f1',
        normalScale: new THREE.Vector2(0.15, 0.15),
      };
      const ballMat = new THREE.MeshStandardMaterial(materialProps);
      group.traverse(node => {
        if (node.isMesh) {
          node.material = ballMat;
        }
      });

      exporter.parse(
        group,
        result => {
          const blob = new Blob([result], { type: 'model/gltf-binary' });
          const url = URL.createObjectURL(blob);

          // Tạo link ảo và click để tải về
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          // Giải phóng bộ nhớ
          URL.revokeObjectURL(url);

          resolve();
        },
        error => {
          console.error('GLB export error:', error);
        },
        { binary: true }
      );
    });
  }

  // Thêm hàm helper để kiểm tra visibility đầy đủ
  isActuallyVisible(object) {
    let current = object;
    while (current) {
      if (!current.visible) {
        return false;
      }
      current = current.parent;
    }
    return true;
  }

  handleDrawBorder = (model, color = 0x000000, lineWidth = 0.5) => {
    if (!this.scene) return;
    // Xóa tất cả border hiện tại
    this.removeBorder();

    // Dùng chung 1 material cho toàn bộ wireframe của lần vẽ này
    const lineMaterial = new LineMaterial({
      color,
      linewidth: lineWidth, // tính theo pixel vì worldUnits = false
      resolution: new THREE.Vector2(
        this.renderer.domElement.width || window.innerWidth,
        this.renderer.domElement.height || window.innerHeight
      ),
      worldUnits: false,
      depthTest: true,
      depthWrite: true,
      vertexColors: false,
      dithering: false,
    });

    this.scene.traverse(child => {
      // Early exit nếu child thuộc về model
      if (model && this.isDescendantOf(child, model)) {
        return;
      }

      if (
        this.isActuallyVisible(child) && //mesh được hiển thị mới vẽ border
        child.isMesh &&
        child?.userData?.drawBorder !== false &&
        child.scale.x !== 0 &&
        child.scale.y !== 0 &&
        child.scale.z !== 0 &&
        child?.userData?.type !== InsideType.STOOL_CUSHION &&
        // child?.userData?.type !== InsideType.LOCK &&
        child?.userData?.type !== InsideType.HANDLE &&
        child?.userData?.type !== InsideType.ACCESSORY_GENERAL &&
        child?.userData?.type !== InsideType.ACCESSORY_DISH_UPPER &&
        child?.userData?.type !== InsideType.ACCESSORY_DISH_LOWER &&
        child?.userData?.type !== InsideType.CLOTHES_HANGER &&
        child?.userData?.type !== InsideType.ACCESSORY_COOKER &&
        child?.userData?.type !== InsideType.ACCESSORY_SINK &&
        child?.userData?.type !== InsideType.ACCESSORY_HOOD &&
        child?.userData?.type !== InsideType.ACCESSORY_FAUCET &&
        child?.userData?.type !== InsideType.ACCESSORY_FRIDGE &&
        child?.userData?.type !== InsideType.LED_CORNER &&
        child?.userData?.type !== InsideType.LED_RECESSED &&
        child?.userData?.type !== ModuleType.COUNTERTOP &&
        child?.userData?.type !== ModuleType.BACKSPLASH &&
        child?.name !== 'RAY_TRAI' &&
        child?.name !== 'RAY_PHAI' &&
        child?.name !== ''
      ) {
        //Bỏ qua những chi tiết kh cần vẽ đường viền
        if (child.userData?.requireBorder === false) {
          return;
        }

        // Vẽ wireframe theo đúng hình dạng
        const THRESH = 60; // thêm thresh để bỏ border các cạnh bo cong
        const edges = new THREE.EdgesGeometry(child.geometry, THRESH);
        const positions = edges.attributes.position.array;

        // Mesh không có cạnh nào thì bỏ qua (tránh NaN khi tính bounding sphere)
        if (!positions.length) {
          edges.dispose();
          return;
        }

        const lineGeometry = new LineSegmentsGeometry();
        lineGeometry.setPositions(positions);
        edges.dispose(); // đã copy sang lineGeometry, giải phóng bộ nhớ

        const wireframe = new LineSegments2(lineGeometry, lineMaterial);

        // Copy toàn bộ transform của mesh gốc
        wireframe.position.copy(child.position);
        wireframe.rotation.copy(child.rotation);
        wireframe.scale.copy(child.scale);

        // Nếu mesh có parent transform
        if (child.parent && child.parent !== this.scene) {
          wireframe.applyMatrix4(child.parent.matrixWorld);
        }

        //Loại bỏ khi click
        wireframe.visibleForRaycast = false;

        this.scene.add(wireframe);
        this.border.push(wireframe);
      }
    });
  };

  handleDrawBorderSelectedModule = async (group, removeAllBorder) => {
    const color = 0x2653a0;

    if (group && this.errorModule.some(item => group.uuid === item.uuid)) {
      // this.removeBorderErrorMesh();
      this.handleDrawBorderErrorMesh(group);
    }
    if (group) {
      //Xoá đi viền đen cho module đang được chọn
      this.handleDrawBorder(group);
      removeAllBorder && this.removeBorderSelectedModule();

      // Vẽ viền vàng cho module đang được chọn
      group.traverse(child => {
        if (
          this.scene &&
          child.isMesh &&
          this.isActuallyVisible(child) && //mesh được hiển thị mới vẽ border
          child?.userData?.drawBorder !== false &&
          child.scale.x !== 0 &&
          child.scale.y !== 0 &&
          child.scale.z !== 0 &&
          (child?.userData?.type === ModuleType.COUNTERTOP ||
            child?.userData?.type === ModuleType.BACKSPLASH ||
            child?.userData?.type === InsideType.DOOR ||
            (child?.userData?.type !== 0 && !child?.userData?.type)) //Chỉ vẽ cho phần khung tủ
        ) {
          //Bỏ qua những chi tiết kh cần vẽ đường viền
          if (child.userData?.requireBorder === false) {
            return;
          }

          // Vẽ wireframe theo đúng hình dạng
          const THRESH = 60; // thêm thresh để bỏ border các cạnh bo cong
          const edges = new THREE.EdgesGeometry(child.geometry, THRESH);
          // const lineMaterial = new THREE.LineBasicMaterial({
          //   color,
          //   linewidth: 2,
          //   depthTest: true, // Tắt depth test - line sẽ luôn hiển thị trên cùng
          //   depthWrite: false, // Tắt depth write để không ảnh hưởng đến các object khác
          // });
          // const wireframe = new THREE.LineSegments(edges, lineMaterial);

          const positions = edges.attributes.position.array;
          // Tạo LineSegmentsGeometry
          const lineGeometry = new LineSegmentsGeometry();
          lineGeometry.setPositions(positions);

          //Module đặc biệt vẽ nét đậm hơn
          const checkSpecialModule =
            child?.userData?.type === ModuleType.COUNTERTOP ||
            child?.userData?.type === ModuleType.BACKSPLASH;

          // Tạo LineMaterial
          const lineMaterial = new LineMaterial({
            color,
            linewidth: checkSpecialModule ? 8 : 3,
            resolution: new THREE.Vector2(
              this.renderer.domElement.width || window.innerWidth,
              this.renderer.domElement.height || window.innerHeight
            ),
            worldUnits: false, // true = linewidth theo đơn vị 3D, false = theo pixel
            depthTest: true, // true = bị che bởi vật thể phía trước, false = luôn hiển thị trên cùng
            depthWrite: true, // true = ghi vào depth buffer, false = không ảnh hưởng depth buffer
            vertexColors: false, // true = dùng màu từng vertex, false = dùng màu color chung
            dithering: false, // Tắt dithering cho đường nét sắc hơn
          });

          // Tạo LineSegments2
          const wireframe = new LineSegments2(lineGeometry, lineMaterial);

          // Copy transform...
          wireframe.position.copy(child.position);
          wireframe.rotation.copy(child.rotation);
          wireframe.scale.copy(child.scale);

          if (child.parent && child.parent !== this.scene) {
            wireframe.applyMatrix4(child.parent.matrixWorld);
          }

          // Đặt renderOrder cao để render sau cùng (hiển thị trên cùng)
          wireframe.renderOrder = 99;

          wireframe.visibleForRaycast = false;

          this.scene.add(wireframe);
          this.borderSelectedModule.push(wireframe);
        }
      });
    }
  };

  handleDrawBorderErrorMesh = async (group, color = 0xff0000) => {
    this.removeBorderErrorMesh();

    if (group) {
      group.traverse(mesh => {
        if (
          this.scene &&
          mesh.isMesh &&
          mesh.visible &&
          mesh.scale.x !== 0 &&
          mesh.scale.y !== 0 &&
          mesh.scale.z !== 0 &&
          (mesh?.userData?.type === ModuleType.COUNTERTOP ||
            mesh?.userData?.type === ModuleType.BACKSPLASH ||
            (mesh?.userData?.type !== 0 && !mesh?.userData?.type)) //Chỉ vẽ cho phần khung tủ
        ) {
          // Vẽ wireframe theo đúng hình dạng
          const THRESH = 60; // thêm thresh để bỏ border các cạnh bo cong
          const edges = new THREE.EdgesGeometry(mesh.geometry, THRESH);

          const material = new THREE.LineBasicMaterial({
            color,
            linewidth: 8,
            depthTest: true, // Tắt depth test - line sẽ luôn hiển thị trên cùng
            depthWrite: false, // Tắt depth write để không ảnh hưởng đến các object khác
            transparent: true,
            opacity: 1,
          });

          const wireframe = new THREE.LineSegments(edges, material);

          // Copy transform...
          wireframe.position.copy(mesh.position);
          wireframe.rotation.copy(mesh.rotation);
          wireframe.scale.copy(mesh.scale);

          if (mesh.parent && mesh.parent !== this.scene) {
            wireframe.applyMatrix4(mesh.parent.matrixWorld);
          }

          // Đặt renderOrder cao để render sau cùng (hiển thị trên cùng)
          wireframe.renderOrder = 9999;

          wireframe.visibleForRaycast = false;

          // Thêm animation nhấp nháy mượt mà
          wireframe.userData.blinkAnimation = {
            startTime: Date.now(),
            duration: 1200, // 1.2s mỗi vòng nhấp nháy
            isBlinking: true,
          };

          this.scene.add(wireframe);
          this.borderErrorMesh.push(wireframe);
        }
      });
      if (!this.errorModule.some(item => item.uuid === group.uuid))
        this.errorModule.push(group);
    }
  };

  /**
   * Update animation cho border error mesh - gọi trong animation loop
   */
  updateBorderErrorMeshAnimation = () => {
    this.borderErrorMesh.forEach(wireframe => {
      if (!wireframe.userData.blinkAnimation) return;

      const anim = wireframe.userData.blinkAnimation;
      const elapsed = (Date.now() - anim.startTime) % anim.duration;
      const progress = elapsed / anim.duration; // 0 to 1

      // Tạo hiệu ứng nhấp nháy mượt: 0->1->0
      const opacity = Math.sin(progress * Math.PI);

      // Tăng line width khi blink để nhìn rõ hơn
      wireframe.material.linewidth = 2 + opacity * 2;
      wireframe.material.opacity = 0.4 + opacity * 0.6; // 0.4 to 1.0
    });
  };

  // handleDrawBorder = model => {
  //   if (!this.scene) return;

  //   // Xóa tất cả border hiện tại
  //   this.removeBorder();

  //   this.scene.traverse(child => {
  //     // Early exit nếu child thuộc về model
  //     if (model && this.isDescendantOf(child, model)) {
  //       return;
  //     }

  //     if (
  //       child.isMesh &&
  //       child.visible &&
  //       child?.userData?.drawBorder !== false &&
  //       child.scale.x !== 0 &&
  //       child.scale.y !== 0 &&
  //       child.scale.z !== 0 &&
  //       child?.userData?.type !== InsideType.HANDLE &&
  //       child?.userData?.type !== InsideType.ACCESSORY_GENERAL &&
  //       child?.userData?.type !== InsideType.ACCESSORY_DISH_UPPER &&
  //       child?.userData?.type !== InsideType.ACCESSORY_COOKER &&
  //       child?.userData?.type !== InsideType.ACCESSORY_SINK &&
  //       child?.name !== 'RAY_TRAI' &&
  //       child?.name !== 'RAY_PHAI' &&
  //       child?.name !== ''
  //     ) {
  //       try {
  //         // Tạo edges geometry với threshold cao hơn để nét hơn
  //         const edges = new THREE.EdgesGeometry(child.geometry, 1); // ✅ Thêm threshold = 1
  //         const positions = edges.attributes.position.array;

  //         // Tạo LineSegmentsGeometry
  //         const lineGeometry = new LineSegmentsGeometry();
  //         lineGeometry.setPositions(positions);

  //         // Tạo LineMaterial
  //         const lineMaterial = new LineMaterial({
  //           color: 0x000000,
  //           linewidth: 3,
  //           transparent: true,
  //           opacity: 1,
  //           worldUnits: false,
  //           resolution: new THREE.Vector2(
  //             this.renderer.domElement.width || window.innerWidth,
  //             this.renderer.domElement.height || window.innerHeight
  //           ),
  //           alphaToCoverage: true,
  //           depthTest: true,
  //           depthWrite: false,
  //           vertexColors: false, // ✅ Đảm bảo màu đồng nhất
  //           dithering: false, // ✅ Tắt dithering cho nét hơn
  //         });

  //         // Tạo LineSegments2
  //         const wireframe = new LineSegments2(lineGeometry, lineMaterial);

  //         // Copy transform
  //         wireframe.position.copy(child.position);
  //         wireframe.rotation.copy(child.rotation);
  //         wireframe.scale.copy(child.scale);

  //         // Apply parent transform
  //         if (child.parent && child.parent !== this.scene) {
  //           wireframe.applyMatrix4(child.parent.matrixWorld);
  //         }

  //         // Disable raycast
  //         wireframe.raycast = () => {};

  //         this.scene.add(wireframe);
  //         this.border.push(wireframe);

  //         // Cleanup
  //         edges.dispose();
  //       } catch (error) {
  //         console.error('Error creating wireframe for:', child.name, error);
  //       }
  //     }
  //   });
  // };

  // Kiểm tra xem child có phải là con cháu của ancestor không
  isDescendantOf = (child, ancestor) => {
    let current = child;
    while (current && current !== this.scene) {
      if (current === ancestor) return true;
      current = current.parent;
    }
    return false;
  };

  removeBorder() {
    if (!this.border.length) return;
    this.border.forEach(box => this.scene?.remove(box));
    this.border = [];
  }

  removeBorderSelectedModule() {
    if (!this.borderSelectedModule.length) return;
    this.borderSelectedModule.forEach(async box => {
      this.scene?.remove(box);
    });
    this.borderSelectedModule = [];
  }

  removeBorderErrorMesh() {
    if (!this.borderErrorMesh.length) return;
    this.borderErrorMesh.forEach(async box => {
      this.scene?.remove(box);
    });
    this.borderErrorMesh = [];
  }

  removeWireframeBoxes() {
    this.wireframeBoxes.forEach(box => this.scene.remove(box));
    this.wireframeBoxes = [];
  }

  createWireframeBox(
    mesh,
    color = 0x569dff,
    lineThickness = 0.1,
    expandSize = 0.001
  ) {
    this.removeWireframeBoxes();

    const box = new THREE.Box3().setFromObject(mesh).expandByScalar(expandSize);

    const size = new THREE.Vector3();
    const center = new THREE.Vector3();
    box.getSize(size);
    box.getCenter(center);

    const vertices = [
      // Bottom face
      [-0.5, -0.5, -0.5],
      [0.5, -0.5, -0.5],
      [0.5, -0.5, -0.5],
      [0.5, -0.5, 0.5],
      [0.5, -0.5, 0.5],
      [-0.5, -0.5, 0.5],
      [-0.5, -0.5, 0.5],
      [-0.5, -0.5, -0.5],
      // Top face
      [-0.5, 0.5, -0.5],
      [0.5, 0.5, -0.5],
      [0.5, 0.5, -0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [-0.5, 0.5, 0.5],
      [-0.5, 0.5, 0.5],
      [-0.5, 0.5, -0.5],
      // Vertical edges
      [-0.5, -0.5, -0.5],
      [-0.5, 0.5, -0.5],
      [0.5, -0.5, -0.5],
      [0.5, 0.5, -0.5],
      [0.5, -0.5, 0.5],
      [0.5, 0.5, 0.5],
      [-0.5, -0.5, 0.5],
      [-0.5, 0.5, 0.5],
    ];
    const positionArray = new Float32Array(vertices.flat());
    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute(
      'position',
      new THREE.BufferAttribute(positionArray, 3)
    );

    geometry.scale(size.x, size.y, size.z);

    const material = new THREE.ShaderMaterial({
      uniforms: {
        lineColor: { value: new THREE.Color(color) },
        thickness: { value: lineThickness },
      },
      vertexShader: `
            void main() {
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
            }
        `,
      fragmentShader: `
            uniform vec3 lineColor;
            void main() {
                gl_FragColor = vec4(lineColor, 1.0);
            }
        `,
      depthTest: false,
      depthWrite: false,
      transparent: true,
    });

    const wireframe = new THREE.LineSegments(geometry, material);
    wireframe.position.copy(center);

    this.scene.add(wireframe);
    this.wireframeBoxes.push(wireframe);
  }

  removeBoxes = () => {
    if (!this.boxes || this.boxes.length === 0) return;

    for (const node of this.boxes) {
      if (!node) continue;

      // 1) Gỡ khỏi parent thực tế (dù parent là scene hay group nào)
      if (node.parent) node.parent.remove(node);

      // 2) Dispose tất cả mesh/line/points bên trong
      node.traverse(o => {
        // Mesh / LineSegments / Points đều có geometry/material
        if (o.isMesh || o.isLine || o.isPoints) {
          if (o.geometry) o.geometry.dispose?.();
          const mat = o.material;
          if (Array.isArray(mat)) mat.forEach(m => m && m.dispose?.());
          else mat && mat.dispose?.();
        }
      });
    }

    this.boxes.length = 0;
  };

  createBoxBorder = result => {
    // 0) cleanup
    (this.boxes || []).forEach(box => {
      if (box.parent) box.parent.remove(box);
      box.geometry?.dispose?.();
      box.material?.dispose?.();
    });
    this.boxes = [];

    const { leftEdge, rightEdge, topEdge, bottomEdge } = result.edges;

    // ---- helper: common ancestor
    const getAncestors = o => {
      const a = [];
      for (let c = o; c; c = c.parent) a.push(c);
      return a.reverse();
    };
    if (!leftEdge || !rightEdge || !topEdge || !bottomEdge) {
      return;
    }
    const A = getAncestors(leftEdge.mesh);
    const B = getAncestors(rightEdge.mesh);
    const C = getAncestors(topEdge.mesh);
    const D = getAncestors(bottomEdge.mesh);
    let parentGroup = this.scene;
    for (
      let i = 0, len = Math.min(A.length, B.length, C.length, D.length);
      i < len;
      i++
    ) {
      if (A[i] === B[i] && B[i] === C[i] && C[i] === D[i]) parentGroup = A[i];
      else break;
    }

    // 1) đảm bảo matrix world mới nhất
    this.scene.updateMatrixWorld(true);
    parentGroup.updateMatrixWorld(true);
    leftEdge.mesh.updateMatrixWorld(true);
    rightEdge.mesh.updateMatrixWorld(true);
    topEdge.mesh.updateMatrixWorld(true);
    bottomEdge.mesh.updateMatrixWorld(true);

    const invParent = new THREE.Matrix4()
      .copy(parentGroup.matrixWorld)
      .invert();

    // 2) Box3 strict + normalize
    const localBoxOf = root => {
      const box = new THREE.Box3().makeEmpty();
      root.traverseVisible(obj => {
        if (!obj.isMesh || !obj.geometry) return;
        const g = obj.geometry;
        if (!g.boundingBox) g.computeBoundingBox();
        const bb = g.boundingBox.clone();
        const m = new THREE.Matrix4()
          .copy(obj.matrixWorld)
          .premultiply(invParent);
        bb.applyMatrix4(m);
        box.union(bb);
      });
      // normalize (đề phòng trục lật)
      const min = box.min.clone(),
        max = box.max.clone();
      box.min.set(
        Math.min(min.x, max.x),
        Math.min(min.y, max.y),
        Math.min(min.z, max.z)
      );
      box.max.set(
        Math.max(min.x, max.x),
        Math.max(min.y, max.y),
        Math.max(min.z, max.z)
      );
      return box;
    };

    const l = localBoxOf(leftEdge.mesh);
    const r = localBoxOf(rightEdge.mesh);
    const t = localBoxOf(topEdge.mesh);
    const b = localBoxOf(bottomEdge.mesh);

    const padding = 0.0;

    // 3) Biên X (tự chọn cặp đúng chiều, chống “trái/phải” bị hoán đổi)
    const L1 = l.max.x,
      R1 = r.min.x; // giả định chuẩn: trái=max, phải=min
    const L2 = r.max.x,
      R2 = l.min.x; // phương án hoán đổi
    let minX = L1,
      maxX = R1;
    if (R2 - L2 > R1 - L1) {
      minX = L2;
      maxX = R2;
    }
    if (maxX < minX) {
      const tmp = minX;
      minX = maxX;
      maxX = tmp;
    } // nếu vẫn lật
    minX += padding;
    maxX -= padding;

    // 4) Biên Y (đáy & nắp; cũng xử lý lật)
    let minY = b.max.y + padding;
    let maxY = t.min.y - padding;
    if (maxY < minY) {
      const altMinY = t.max.y + padding;
      const altMaxY = b.min.y - padding;
      if (altMaxY - altMinY > maxY - minY) {
        minY = altMinY;
        maxY = altMaxY;
      } else {
        const tmp = minY;
        minY = maxY;
        maxY = tmp;
      }
    }

    // 5) Biên Z (giao của 2 vách; normalize nếu lật)
    let minZ = Math.max(l.min.z, r.min.z) + padding;
    let maxZ = Math.min(l.max.z, r.max.z) - padding;
    if (maxZ < minZ) {
      const tmp = minZ;
      minZ = maxZ;
      maxZ = tmp;
    }

    const width = Math.max(0, maxX - minX) + 0.002;
    const height = Math.max(0, maxY - minY);
    const depth = Math.max(0, maxZ - minZ) + 0.002;

    if (width <= 0 || height <= 0 || depth <= 0) {
      console.warn('Inner box invalid', { width, height, depth, l, r, t, b });
      return;
    }

    const center = new THREE.Vector3(
      (minX + maxX) / 2,
      (minY + maxY) / 2,
      (minZ + maxZ) / 2
    );

    const geom = new THREE.BoxGeometry(width, height, depth);
    const mat = new THREE.MeshStandardMaterial({
      color: new THREE.Color('#B7D5FF'),
      metalness: 0.5,
      roughness: 0.5,
      transparent: true,
      opacity: 0.5,
    });

    const box = new THREE.Mesh(geom, mat);
    box.userData.isHelperBox = true;
    box.position.copy(center);
    parentGroup.add(box);
    this.boxes.push(box);
  };

  getSize(object3D) {
    if (!object3D) return null;

    const box = new THREE.Box3().setFromObject(object3D);

    const size = new THREE.Vector3();
    box.getSize(size);

    const min = box.min.clone();
    const max = box.max.clone();

    return {
      x: size.x,
      y: size.y,
      z: size.z,
      min,
      max,
    };
  }

  async loadModulePreview(module) {
    return new Promise((resolve, reject) => {
      const loader = new GLTFLoader();
      loader.load(module.model, gltf => {
        const model = gltf.scene;

        model.position.set(0, 0, 0);
        model.traverse(child => {
          if (child.isMesh) {
            child.frustumCulled = false;
            child.material = child.material.clone();
            child.material.transparent = true;
            child.material.opacity = 1; // Set opacity for the preview
          }
        });
        const size = this.getSize(model);
        model.userData.type = module.type;
        model.userData.size = size;
        resolve(model);
      });
    });
  }

  setPointDoor(door) {
    this.removeAllPoints();

    if (door) {
      const doorOrientation = GeometryUtils.getModuleOrientation(door);
      const box = new THREE.Box3().setFromObject(door);
      const min = box.min;
      const max = box.max;
      let lstCorners;

      const typeHau = door.userData?.typeHau;

      switch (doorOrientation) {
        case 'NORMAL':
          lstCorners = [
            new THREE.Vector3(max.x, min.y, min.z), // Góc dưới phải
            new THREE.Vector3(max.x, min.y, max.z), // Góc dưới trái
            new THREE.Vector3(max.x, max.y, max.z), // Góc trên trái
            new THREE.Vector3(max.x, max.y, min.z), // Góc trên phải
          ];
          break;

        case 'ROTATED_90':
          // Khi quay 270 mặt phẳng door sẽ nằm ở max.z
          lstCorners = [
            new THREE.Vector3(max.x, min.y, min.z), // Góc dưới phải
            new THREE.Vector3(min.x, min.y, min.z), // Góc dưới trái
            new THREE.Vector3(min.x, max.y, min.z), // Góc trên trái
            new THREE.Vector3(max.x, max.y, min.z), // Góc trên phải
          ];
          break;

        case 'ROTATED_180':
          lstCorners = [
            new THREE.Vector3(min.x, min.y, min.z), // Góc dưới phải
            new THREE.Vector3(min.x, min.y, max.z), // Góc dưới trái
            new THREE.Vector3(min.x, max.y, max.z), // Góc trên trái
            new THREE.Vector3(min.x, max.y, min.z), // Góc trên phải
          ];
          break;

        case 'ROTATED_270':
          // Khi quay 270 mặt phẳng door sẽ nằm ở max.z
          lstCorners = [
            new THREE.Vector3(max.x, min.y, max.z), // Góc dưới phải
            new THREE.Vector3(min.x, min.y, max.z), // Góc dưới trái
            new THREE.Vector3(min.x, max.y, max.z), // Góc trên trái
            new THREE.Vector3(max.x, max.y, max.z), // Góc trên phải
          ];
          break;
      }

      // if (doorOrientation === 'NORMAL' || doorOrientation === 'ROTATED_180') {
      //   lstCorners = [
      //     new THREE.Vector3(max.x, min.y, min.z), // Góc dưới phải
      //     new THREE.Vector3(max.x, min.y, max.z), // Góc dưới trái
      //     new THREE.Vector3(max.x, max.y, max.z), // Góc trên trái
      //     new THREE.Vector3(max.x, max.y, min.z), // Góc trên phải
      //   ];
      // } else if (
      //   doorOrientation === 'ROTATED_90' ||
      //   doorOrientation === 'ROTATED_270'
      // ) {
      //   // Khi quay 270 mặt phẳng door sẽ nằm ở max.z
      //   lstCorners = [
      //     new THREE.Vector3(max.x, min.y, max.z), // Góc dưới phải
      //     new THREE.Vector3(min.x, min.y, max.z), // Góc dưới trái
      //     new THREE.Vector3(min.x, max.y, max.z), // Góc trên trái
      //     new THREE.Vector3(max.x, max.y, max.z), // Góc trên phải
      //   ];
      // }

      this.createDoorCorners(lstCorners);

      return lstCorners;
    }
  }

  createDoorCorners(lstCorners) {
    if (!lstCorners) return;

    const p1 = lstCorners[0];
    const p2 = lstCorners[1];
    const p3 = lstCorners[2];

    const vector1 = new THREE.Vector3().subVectors(p2, p1);
    const vector2 = new THREE.Vector3().subVectors(p3, p1);

    this.normal = new THREE.Vector3()
      .crossVectors(vector1, vector2)
      .normalize();

    const pointMaterial = new THREE.MeshBasicMaterial({ color: 0x569dff });
    const distance = this.camera.position.distanceTo(lstCorners[0]);

    lstCorners.forEach((corner, index) => {
      // const sphereGeometry = new THREE.SphereGeometry(0.01, 10, 10);
      const sphereGeometry = new THREE.SphereGeometry(
        0.01 + distance / 1000,
        10,
        10
      );
      const sphere = new THREE.Mesh(sphereGeometry, pointMaterial);
      sphere.position.copy(corner);
      this.scene.add(sphere);
      sphere.userData.index = index;
      sphere.userData.drawBorder = false;
      this.arrayPointDoor.push(sphere);

      //lưu để snap về vị trí cũ
      this.arrayPointDoorPrev.push(sphere.clone());
    });
  }

  drawPointRecommendDoor(result, doorType, doorCorners, door) {
    this.removePointRecommend();

    if (!result || doorCorners.length < 1) return;

    const orientation = GeometryUtils.getModuleOrientation(door);
    let lstPoints = [];

    const deltaDoor = doorType === 0 ? 0 : 0.02;

    const boxL = new THREE.Box3().setFromObject(result.edges.leftEdge.mesh);
    const minL = boxL.min;
    const maxL = boxL.max;

    const boxR = new THREE.Box3().setFromObject(result.edges.rightEdge.mesh);
    const minR = boxR.min;
    const maxR = boxR.max;

    const boxT = new THREE.Box3().setFromObject(result.edges.topEdge.mesh);
    const minT = boxT.min;
    const maxT = boxT.max;

    const boxB = new THREE.Box3().setFromObject(result.edges.bottomEdge.mesh);
    const minB = boxB.min;
    const maxB = boxB.max;

    const checkL = result.edges.leftEdge.mesh.userData.type !== undefined;
    const checkR = result.edges.rightEdge.mesh.userData.type !== undefined;
    const checkT = result.edges.topEdge.mesh.userData.type !== undefined;
    const checkB = result.edges.bottomEdge.mesh.userData.type !== undefined;

    switch (orientation) {
      case 'NORMAL':
        if (doorType === 0) {
          // Tính trước các giá trị Z
          const rightZ = checkR ? (maxR.z + minR.z) / 2 + this.slit : minR.z;
          const leftZ = checkL ? (minL.z + maxL.z) / 2 - this.slit : maxL.z;
          const middleZ = (rightZ + leftZ) / 2;

          // Tính trước các giá trị Y
          const top1 = maxT.y;
          const top2 = (maxT.y + minT.y) / 2 - this.slit;
          const top3 = minT.y;
          const top4 = doorCorners[2].y;

          const bottom1 = maxB.y;
          const bottom2 = (maxB.y + minB.y) / 2 - this.slit;
          const bottom3 = minB.y;
          const bottom4 = doorCorners[0].y;

          lstPoints = [
            new THREE.Vector3(maxT.x, top1, rightZ),
            new THREE.Vector3(maxB.x, bottom1, rightZ),
            new THREE.Vector3(maxT.x, top1, leftZ),
            new THREE.Vector3(maxB.x, bottom1, leftZ),
            new THREE.Vector3(maxT.x, top1, middleZ), // Trung điểm cạnh trên
            new THREE.Vector3(maxB.x, bottom1, middleZ), // Trung điểm cạnh dưới
            new THREE.Vector3(maxT.x, top1, doorCorners[0].z),
            new THREE.Vector3(maxB.x, bottom1, doorCorners[0].z),
            new THREE.Vector3(maxT.x, top1, doorCorners[1].z),
            new THREE.Vector3(maxB.x, bottom1, doorCorners[1].z),

            new THREE.Vector3(maxT.x, top2, rightZ),
            new THREE.Vector3(maxT.x, top2, leftZ),
            new THREE.Vector3(maxB.x, bottom2, rightZ),
            new THREE.Vector3(maxB.x, bottom2, leftZ),
            new THREE.Vector3(maxT.x, top2, middleZ),
            new THREE.Vector3(maxB.x, bottom2, middleZ),
            new THREE.Vector3(maxT.x, top2, doorCorners[0].z),
            new THREE.Vector3(maxB.x, bottom2, doorCorners[0].z),
            new THREE.Vector3(maxT.x, top2, doorCorners[1].z),
            new THREE.Vector3(maxB.x, bottom2, doorCorners[1].z),

            new THREE.Vector3(maxT.x, top3, rightZ),
            new THREE.Vector3(maxT.x, top3, leftZ),
            new THREE.Vector3(maxB.x, bottom3, rightZ),
            new THREE.Vector3(maxB.x, bottom3, leftZ),
            new THREE.Vector3(maxT.x, top3, middleZ),
            new THREE.Vector3(maxB.x, bottom3, middleZ),
            new THREE.Vector3(maxT.x, top3, doorCorners[0].z),
            new THREE.Vector3(maxB.x, bottom3, doorCorners[0].z),
            new THREE.Vector3(maxT.x, top3, doorCorners[1].z),
            new THREE.Vector3(maxB.x, bottom3, doorCorners[1].z),

            new THREE.Vector3(maxT.x, top4, rightZ),
            new THREE.Vector3(maxB.x, bottom4, rightZ),
            new THREE.Vector3(maxT.x, top4, leftZ),
            new THREE.Vector3(maxB.x, bottom4, leftZ),
            new THREE.Vector3(maxT.x, top4, middleZ),
            new THREE.Vector3(maxB.x, bottom4, middleZ),
            new THREE.Vector3(maxT.x, top4, doorCorners[0].z),
            new THREE.Vector3(maxB.x, bottom4, doorCorners[0].z),
            new THREE.Vector3(maxT.x, top4, doorCorners[1].z),
            new THREE.Vector3(maxB.x, bottom4, doorCorners[1].z),
          ];
        } else {
          // lstPoints = [
          //   new THREE.Vector3(maxT.x, minT.y, minL.z),
          //   new THREE.Vector3(maxT.x, minT.y, maxR.z),
          //   new THREE.Vector3(maxB.x, maxB.y, minL.z),
          //   new THREE.Vector3(maxB.x, maxB.y, maxR.z),
          //   new THREE.Vector3(maxT.x, minT.y, (minL.z + maxR.z) / 2),
          //   new THREE.Vector3(maxB.x, maxB.y, (minL.z + maxR.z) / 2),
          // ];
        }
        break;

      case 'ROTATED_90':
        if (doorType === 0) {
          const rightX = checkR ? (maxR.x + minR.x) / 2 + this.slit : maxR.x;
          const leftX = checkL ? (minL.x + maxL.x) / 2 - this.slit : minL.x;
          const middleX = (rightX + leftX) / 2;

          const top1 = maxT.y;
          const top2 = (maxT.y + minT.y) / 2 - this.slit;
          const top3 = minT.y;
          const top4 = doorCorners[2].y;

          const bottom1 = maxB.y;
          const bottom2 = (maxB.y + minB.y) / 2 - this.slit;
          const bottom3 = minB.y;
          const bottom4 = doorCorners[0].y;

          lstPoints = [
            new THREE.Vector3(leftX, top1, minT.z),
            new THREE.Vector3(leftX, bottom1, minB.z),
            new THREE.Vector3(middleX, top1, minT.z),
            new THREE.Vector3(middleX, bottom1, minB.z),
            new THREE.Vector3(rightX, top1, minT.z),
            new THREE.Vector3(rightX, bottom1, minB.z),
            new THREE.Vector3(doorCorners[0].x, top1, minT.z),
            new THREE.Vector3(doorCorners[0].x, bottom1, minB.z),
            new THREE.Vector3(doorCorners[1].x, top1, minT.z),
            new THREE.Vector3(doorCorners[1].x, bottom1, minB.z),

            new THREE.Vector3(leftX, top2, minT.z),
            new THREE.Vector3(leftX, bottom2, minB.z),
            new THREE.Vector3(middleX, top2, minT.z),
            new THREE.Vector3(middleX, bottom2, minB.z),
            new THREE.Vector3(rightX, top2, minT.z),
            new THREE.Vector3(rightX, bottom2, minB.z),
            new THREE.Vector3(doorCorners[0].x, top2, minT.z),
            new THREE.Vector3(doorCorners[0].x, bottom2, minB.z),
            new THREE.Vector3(doorCorners[1].x, top2, minT.z),
            new THREE.Vector3(doorCorners[1].x, bottom2, minB.z),

            new THREE.Vector3(leftX, top3, minT.z),
            new THREE.Vector3(leftX, bottom3, minB.z),
            new THREE.Vector3(middleX, top3, minT.z),
            new THREE.Vector3(middleX, bottom3, minB.z),
            new THREE.Vector3(rightX, top3, minT.z),
            new THREE.Vector3(rightX, bottom3, minB.z),
            new THREE.Vector3(doorCorners[0].x, top3, minT.z),
            new THREE.Vector3(doorCorners[0].x, bottom3, minB.z),
            new THREE.Vector3(doorCorners[1].x, top3, minT.z),
            new THREE.Vector3(doorCorners[1].x, bottom3, minB.z),

            new THREE.Vector3(leftX, top4, minT.z),
            new THREE.Vector3(leftX, bottom4, minB.z),
            new THREE.Vector3(middleX, top4, minT.z),
            new THREE.Vector3(middleX, bottom4, minB.z),
            new THREE.Vector3(rightX, top4, minT.z),
            new THREE.Vector3(rightX, bottom4, minB.z),
            new THREE.Vector3(doorCorners[0].x, top4, minT.z),
            new THREE.Vector3(doorCorners[0].x, bottom4, minB.z),
            new THREE.Vector3(doorCorners[1].x, top4, minT.z),
            new THREE.Vector3(doorCorners[1].x, bottom4, minB.z),
          ];
        } else {
          // lstPoints = [
          //   new THREE.Vector3(minL.x, minT.y, minT.z),
          //   new THREE.Vector3(maxR.x, minT.y, minT.z),
          //   new THREE.Vector3(minL.x, maxB.y, minB.z),
          //   new THREE.Vector3(maxR.x, maxB.y, minB.z),
          //   new THREE.Vector3((minL.x + maxR.x) / 2, minT.y, minT.z),
          //   new THREE.Vector3((minL.x + maxR.x) / 2, maxB.y, minB.z),
          // ];
        }
        break;

      case 'ROTATED_180':
        if (doorType === 0) {
          const rightZ = checkR ? (maxR.z + minR.z) / 2 + this.slit : minR.z;
          const leftZ = checkL ? (minL.z + maxL.z) / 2 - this.slit : maxL.z;
          const middleZ = (rightZ + leftZ) / 2;

          const top1 = maxT.y;
          const top2 = (maxT.y + minT.y) / 2 - this.slit;
          const top3 = minT.y;
          const top4 = doorCorners[2].y;

          const bottom1 = maxB.y;
          const bottom2 = (maxB.y + minB.y) / 2 - this.slit;
          const bottom3 = minB.y;
          const bottom4 = doorCorners[0].y;

          lstPoints = [
            new THREE.Vector3(minT.x, top1, rightZ),
            new THREE.Vector3(minB.x, bottom1, rightZ),
            new THREE.Vector3(minT.x, top1, leftZ),
            new THREE.Vector3(minB.x, bottom1, leftZ),
            new THREE.Vector3(minT.x, top1, middleZ),
            new THREE.Vector3(minB.x, bottom1, middleZ),
            new THREE.Vector3(minT.x, top1, doorCorners[0].z),
            new THREE.Vector3(minB.x, bottom1, doorCorners[0].z),
            new THREE.Vector3(minT.x, top1, doorCorners[1].z),
            new THREE.Vector3(minB.x, bottom1, doorCorners[1].z),

            new THREE.Vector3(minT.x, top2, rightZ),
            new THREE.Vector3(minT.x, top2, leftZ),
            new THREE.Vector3(minB.x, bottom2, rightZ),
            new THREE.Vector3(minB.x, bottom2, leftZ),
            new THREE.Vector3(minT.x, top2, middleZ),
            new THREE.Vector3(minB.x, bottom2, middleZ),
            new THREE.Vector3(minT.x, top2, doorCorners[0].z),
            new THREE.Vector3(minB.x, bottom2, doorCorners[0].z),
            new THREE.Vector3(minT.x, top2, doorCorners[1].z),
            new THREE.Vector3(minB.x, bottom2, doorCorners[1].z),

            new THREE.Vector3(minT.x, top3, rightZ),
            new THREE.Vector3(minT.x, top3, leftZ),
            new THREE.Vector3(minB.x, bottom3, rightZ),
            new THREE.Vector3(minB.x, bottom3, leftZ),
            new THREE.Vector3(minT.x, top3, middleZ),
            new THREE.Vector3(minB.x, bottom3, middleZ),
            new THREE.Vector3(minT.x, top3, doorCorners[0].z),
            new THREE.Vector3(minB.x, bottom3, doorCorners[0].z),
            new THREE.Vector3(minT.x, top3, doorCorners[1].z),
            new THREE.Vector3(minB.x, bottom3, doorCorners[1].z),

            new THREE.Vector3(minT.x, top4, rightZ),
            new THREE.Vector3(minB.x, bottom4, rightZ),
            new THREE.Vector3(minT.x, top4, leftZ),
            new THREE.Vector3(minB.x, bottom4, leftZ),
            new THREE.Vector3(minT.x, top4, middleZ),
            new THREE.Vector3(minB.x, bottom4, middleZ),
            new THREE.Vector3(minT.x, top4, doorCorners[0].z),
            new THREE.Vector3(minB.x, bottom4, doorCorners[0].z),
            new THREE.Vector3(minT.x, top4, doorCorners[1].z),
            new THREE.Vector3(minB.x, bottom4, doorCorners[1].z),
          ];
        } else {
          // lstPoints = [
          //   new THREE.Vector3(minT.x, minT.y, minL.z),
          //   new THREE.Vector3(minT.x, minT.y, maxR.z),
          //   new THREE.Vector3(minB.x, maxB.y, minL.z),
          //   new THREE.Vector3(minB.x, maxB.y, maxR.z),
          //   new THREE.Vector3(minT.x, minT.y, (minL.z + maxR.z) / 2),
          //   new THREE.Vector3(minB.x, maxB.y, (minL.z + maxR.z) / 2),
          // ];
        }
        break;

      case 'ROTATED_270':
        if (doorType === 0) {
          const rightX = checkR ? (maxR.x + minR.x) / 2 + this.slit : maxR.x;
          const leftX = checkL ? (minL.x + maxL.x) / 2 - this.slit : minL.x;
          const middleX = (rightX + leftX) / 2;

          const top1 = maxT.y;
          const top2 = (maxT.y + minT.y) / 2 - this.slit;
          const top3 = minT.y;
          const top4 = doorCorners[2].y;

          const bottom1 = maxB.y;
          const bottom2 = (maxB.y + minB.y) / 2 - this.slit;
          const bottom3 = minB.y;
          const bottom4 = doorCorners[0].y;

          lstPoints = [
            new THREE.Vector3(leftX, top1, maxT.z),
            new THREE.Vector3(leftX, bottom1, maxB.z),
            new THREE.Vector3(middleX, top1, maxT.z),
            new THREE.Vector3(middleX, bottom1, maxB.z),
            new THREE.Vector3(rightX, top1, maxT.z),
            new THREE.Vector3(rightX, bottom1, maxB.z),
            new THREE.Vector3(doorCorners[0].x, top1, maxT.z),
            new THREE.Vector3(doorCorners[0].x, bottom1, maxB.z),
            new THREE.Vector3(doorCorners[1].x, top1, maxT.z),
            new THREE.Vector3(doorCorners[1].x, bottom1, maxB.z),

            new THREE.Vector3(leftX, top2, maxT.z),
            new THREE.Vector3(leftX, bottom2, maxB.z),
            new THREE.Vector3(middleX, top2, maxT.z),
            new THREE.Vector3(middleX, bottom2, maxB.z),
            new THREE.Vector3(rightX, top2, maxT.z),
            new THREE.Vector3(rightX, bottom2, maxB.z),
            new THREE.Vector3(doorCorners[0].x, top2, maxT.z),
            new THREE.Vector3(doorCorners[0].x, bottom2, maxB.z),
            new THREE.Vector3(doorCorners[1].x, top2, maxT.z),
            new THREE.Vector3(doorCorners[1].x, bottom2, maxB.z),

            new THREE.Vector3(leftX, top3, maxT.z),
            new THREE.Vector3(leftX, bottom3, maxB.z),
            new THREE.Vector3(middleX, top3, maxT.z),
            new THREE.Vector3(middleX, bottom3, maxB.z),
            new THREE.Vector3(rightX, top3, maxT.z),
            new THREE.Vector3(rightX, bottom3, maxB.z),
            new THREE.Vector3(doorCorners[0].x, top3, maxT.z),
            new THREE.Vector3(doorCorners[0].x, bottom3, maxB.z),
            new THREE.Vector3(doorCorners[1].x, top3, maxT.z),
            new THREE.Vector3(doorCorners[1].x, bottom3, maxB.z),

            new THREE.Vector3(leftX, top4, maxT.z),
            new THREE.Vector3(leftX, bottom4, maxB.z),
            new THREE.Vector3(middleX, top4, maxT.z),
            new THREE.Vector3(middleX, bottom4, maxB.z),
            new THREE.Vector3(rightX, top4, maxT.z),
            new THREE.Vector3(rightX, bottom4, maxB.z),
            new THREE.Vector3(doorCorners[0].x, top4, maxT.z),
            new THREE.Vector3(doorCorners[0].x, bottom4, maxB.z),
            new THREE.Vector3(doorCorners[1].x, top4, maxT.z),
            new THREE.Vector3(doorCorners[1].x, bottom4, maxB.z),
          ];
        } else {
          // lstPoints = [
          //   new THREE.Vector3(minL.x, minT.y, maxT.z),
          //   new THREE.Vector3(maxR.x, minT.y, maxT.z),
          //   new THREE.Vector3(minL.x, maxB.y, maxB.z),
          //   new THREE.Vector3(maxR.x, maxB.y, maxB.z),
          //   new THREE.Vector3((minL.x + maxR.x) / 2, minT.y, maxT.z),
          //   new THREE.Vector3((minL.x + maxR.x) / 2, maxB.y, maxB.z),
          // ];
        }
        break;
    }

    lstPoints.forEach((corner, index) => {
      const pointMaterial = new THREE.MeshBasicMaterial({ color: 0xff9668 });
      const sphereGeometry = new THREE.SphereGeometry(0.005, 10, 10);
      const sphere = new THREE.Mesh(sphereGeometry, pointMaterial);
      sphere.position.copy(corner);
      this.scene.add(sphere);
      sphere.userData.index = index;
      this.arrayPointRecommend.push(sphere);
    });

    return this.arrayPointRecommend;
  }

  removePointRecommend() {
    this.arrayPointRecommend.forEach(sphere => {
      this.scene.remove(sphere);
      sphere.geometry.dispose();
      sphere.material.dispose();
    });

    this.arrayPointRecommend = [];
  }

  removeAllPoints() {
    this.arrayPointDoor.forEach(sphere => {
      this.scene.remove(sphere);
      sphere.geometry.dispose();
      sphere.material.dispose();
    });
    this.arrayPointRecommend.forEach(sphere => {
      this.scene.remove(sphere);
      sphere.geometry.dispose();
      sphere.material.dispose();
    });

    this.arrayPointDoor = [];
    this.arrayPointRecommend = [];

    this.arrayPointDoorPrev = [];
  }

  calculateOptimalCameraForScreenshot() {
    const floorSize = this.getFloorSize();
    const wallHeight = this.wallHeight || 3;

    // Tính diagonal của phòng
    const diagonal = Math.sqrt(
      floorSize.width * floorSize.width + floorSize.depth * floorSize.depth
    );

    // FOV của camera (mặc định 50 độ)
    const fov = this.camera.fov || 50;
    const fovRadians = (fov * Math.PI) / 180;

    // Tính khoảng cách camera cần lùi để thấy hết phòng
    const distance = diagonal / 2 / Math.tan(fovRadians / 2);

    // Thêm margin 20% để đảm bảo không bị cắt
    const finalDistance = distance * 1.2;

    return {
      position: {
        x: 0,
        y: wallHeight * 1.5, // Nhìn từ độ cao 55% chiều cao tường
        z: finalDistance,
      },
      lookAt: {
        x: 0,
        y: wallHeight * 0.4, // Nhìn vào 40% chiều cao tường
        z: 0,
      },
    };
  }

  /**
   * Setup camera tối ưu cho screenshot
   */
  setupScreenshotCamera() {
    // Lưu vị trí hiện tại
    this.savedCameraPosition = this.camera.position.clone();
    this.savedCameraTarget = this.controls
      ? this.controls.target.clone()
      : null;

    this.hideMeasurementArrows();

    // Tính toán vị trí tối ưu
    const optimal = this.calculateOptimalCameraForScreenshot();

    // Đặt camera
    this.camera.position.set(
      optimal.position.x,
      optimal.position.y,
      optimal.position.z
    );

    this.camera.lookAt(optimal.lookAt.x, optimal.lookAt.y, optimal.lookAt.z);

    // Update controls
    if (this.controls) {
      this.controls.target.set(
        optimal.lookAt.x,
        optimal.lookAt.y,
        optimal.lookAt.z
      );
      this.controls.update();
    }

    // Force render
    this.renderer.render(this.scene, this.camera);
  }

  /**
   * Restore camera về vị trí ban đầu
   */
  restoreCamera() {
    if (this.savedCameraPosition) {
      this.camera.position.copy(this.savedCameraPosition);

      if (this.controls && this.savedCameraTarget) {
        this.controls.target.copy(this.savedCameraTarget);
        this.controls.update();
      }

      this.showMeasurementArrows();

      this.renderer.render(this.scene, this.camera);
    }
  }

  // ============================================
  // THÊM VÀO SceneManager.js
  // ============================================

  /**
   * Ẩn các arrows và text đo kích thước
   */
  hideMeasurementArrows() {
    // Ẩn arrows
    if (this.measurementArrows && this.measurementArrows.length > 0) {
      this.measurementArrows.forEach(arrow => {
        if (arrow) arrow.visible = false;
      });
    }

    // Ẩn text labels
    if (this.labels && this.labels.length > 0) {
      this.labels.forEach(label => {
        if (label) label.visible = false;
      });
    }
  }

  /**
   * Hiện lại các arrows và text đo kích thước
   */
  showMeasurementArrows() {
    // Hiện arrows
    if (this.measurementArrows && this.measurementArrows.length > 0) {
      this.measurementArrows.forEach(arrow => {
        if (arrow) arrow.visible = true;
      });
    }

    // Hiện text labels
    if (this.labels && this.labels.length > 0) {
      this.labels.forEach(label => {
        if (label) label.visible = true;
      });
    }
  }

  /**
   * Lấy tất cả cửa có sử dụng tay nắm
   */
  getAllDoorsWithHandles() {
    const doorsWithHandles = [];

    this.scene.traverse(object => {
      if (
        object.userData &&
        object.userData.type === InsideType.DOOR &&
        object.userData.beveled !== true
      ) {
        doorsWithHandles.push(object);
      }
    });

    return doorsWithHandles;
  }

  /**
   * Lấy tất cả model cùng loại
   */
  getAllModelByType(type) {
    const result = [];
    this.scene.traverse(object => {
      if (object.userData?.type === type) {
        result.push(object);
      }
    });

    return result;
  }

  /**
   * Reset camera về vị trí ban đầu
   */
  resetCamera() {
    if (!this.controls) return;

    const startPosition = this.camera.position.clone();
    const startTarget = this.controls.target.clone();

    const endPosition = new THREE.Vector3(0, 4, 8);
    const endTarget = new THREE.Vector3(0, 1.5, 0);

    const duration = 800; // ms
    const startTime = performance.now();

    const animate = currentTime => {
      const elapsed = currentTime - startTime;
      const t = Math.min(elapsed / duration, 1);

      // Easing (ease in-out)
      const eased = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

      this.camera.position.lerpVectors(startPosition, endPosition, eased);
      this.controls.target.lerpVectors(startTarget, endTarget, eased);
      this.controls.update();

      this.renderer.render(this.scene, this.camera);

      if (t < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }

  /**
   * START EXPORT 2D
   */

  //old
  exportComplete3ViewTechnicalDrawingOld(
    filename = 'technical-drawing-3views.png'
  ) {
    return new Promise(resolve => {
      const allModules = [];

      this.scene.traverse(child => {
        if (
          child.userData &&
          (child.userData.type === 'module' ||
            child.userData.type === 'cabinetTrim' ||
            child.userData.type === 'cabinetCover')
        ) {
          const moduleData = {
            original: child,
            meshes: [],
            group: new THREE.Group(),
          };

          child.traverse(cItem => {
            if (
              cItem.scale.x === 0 ||
              cItem.scale.y === 0 ||
              cItem.scale.y === 0
            ) {
              return;
            }

            if (cItem.isMesh && cItem.visible) {
              const cloneCItem = cItem.clone();
              const worldPos = cItem.getWorldPosition(new THREE.Vector3());
              const worldQuat = cItem.getWorldQuaternion(
                new THREE.Quaternion()
              );
              const worldScale = cItem.getWorldScale(new THREE.Vector3());

              cloneCItem.position.copy(worldPos);
              cloneCItem.quaternion.copy(worldQuat);
              cloneCItem.scale.copy(worldScale);

              moduleData.group.add(cloneCItem);
              moduleData.meshes.push(cloneCItem);
            }
          });

          if (moduleData.meshes.length > 0) {
            const bbox = new THREE.Box3().setFromObject(moduleData.group);
            moduleData.bbox = bbox;
            moduleData.size = bbox.getSize(new THREE.Vector3());
            moduleData.center = bbox.getCenter(new THREE.Vector3());
            moduleData.min = bbox.min.clone();
            moduleData.max = bbox.max.clone();

            allModules.push(moduleData);
          }
        }
      });

      // Tính bounds từ modules
      let minX = Infinity,
        minY = Infinity,
        minZ = Infinity;
      let maxX = -Infinity,
        maxY = -Infinity,
        maxZ = -Infinity;

      allModules.forEach(module => {
        minX = Math.min(minX, module.min.x);
        minY = Math.min(minY, module.min.y);
        minZ = Math.min(minZ, module.min.z);
        maxX = Math.max(maxX, module.max.x);
        maxY = Math.max(maxY, module.max.y);
        maxZ = Math.max(maxZ, module.max.z);
      });

      const sceneBounds = {
        min: { x: minX, y: minY, z: minZ },
        max: { x: maxX, y: maxY, z: maxZ },
      };

      const sceneSize = {
        x: maxX - minX,
        y: maxY - minY,
        z: maxZ - minZ,
      };

      const sceneCenter = {
        x: (minX + maxX) / 2,
        y: (minY + maxY) / 2,
        z: (minZ + maxZ) / 2,
      };

      // Sort and group modules
      allModules.sort((a, b) => {
        if (Math.abs(a.center.y - b.center.y) > sceneSize.y * 0.1) {
          return b.center.y - a.center.y;
        }
        return a.center.x - b.center.x;
      });

      const rows = [];
      allModules.forEach(module => {
        let foundRow = false;
        for (let row of rows) {
          if (Math.abs(row[0].center.y - module.center.y) < sceneSize.y * 0.1) {
            row.push(module);
            foundRow = true;
            break;
          }
        }
        if (!foundRow) {
          rows.push([module]);
        }
      });

      rows.sort((a, b) => b[0].center.y - a[0].center.y);
      rows.forEach(row => row.sort((a, b) => a.center.x - b.center.x));

      const columns = [];
      allModules.forEach(module => {
        let foundCol = false;
        for (let col of columns) {
          if (
            Math.abs(col[0].center.x - module.center.x) <
            sceneSize.x * 0.05
          ) {
            col.push(module);
            foundCol = true;
            break;
          }
        }
        if (!foundCol) {
          columns.push([module]);
        }
      });

      columns.sort((a, b) => a[0].center.x - b[0].center.x);
      columns.forEach(col => col.sort((a, b) => b.center.y - a.center.y));

      const resolution = 3000;
      const lineColor = '#000000';
      const backgroundColor = '#ffffff';

      const renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true,
        preserveDrawingBuffer: true,
      });
      renderer.setSize(resolution, resolution);

      const renderScene = new THREE.Scene();
      renderScene.background = new THREE.Color(backgroundColor);

      const renderView = (cameraPos, lookAt, up) => {
        while (renderScene.children.length > 0) {
          renderScene.remove(renderScene.children[0]);
        }

        allModules.forEach(module => {
          module.group.traverse(mesh => {
            if (mesh.isMesh && mesh.geometry) {
              const edges = new THREE.EdgesGeometry(mesh.geometry, 1);

              // Chuyển edges sang positions
              const positions = edges.attributes.position.array;

              // Tạo LineSegmentsGeometry
              const lineGeometry = new LineSegmentsGeometry();
              lineGeometry.setPositions(positions);

              // Tạo LineMaterial (thay vì LineBasicMaterial)
              const lineMaterial = new LineMaterial({
                color: 0x000000,
                linewidth: 4,
                resolution: new THREE.Vector2(resolution, resolution),
                worldUnits: false,
                alphaToCoverage: true,
                depthTest: true,
                depthWrite: true,
              });

              const lineSegments = new LineSegments2(
                lineGeometry,
                lineMaterial
              );
              lineSegments.position.copy(mesh.position);
              lineSegments.quaternion.copy(mesh.quaternion);
              lineSegments.scale.copy(mesh.scale);
              renderScene.add(lineSegments);
            }
          });
        });

        const frustumSize =
          Math.max(sceneSize.x, sceneSize.y, sceneSize.z) * 1.2;
        const camera = new THREE.OrthographicCamera(
          -frustumSize / 2,
          frustumSize / 2,
          frustumSize / 2,
          -frustumSize / 2,
          0.1,
          1000
        );
        camera.position.set(...cameraPos);
        camera.lookAt(...lookAt);
        camera.up.set(...up);

        renderer.render(renderScene, camera);
        return renderer.domElement.toDataURL('image/png');
      };

      const distance = Math.max(sceneSize.x, sceneSize.y, sceneSize.z) * 2;

      const frontView = renderView(
        [sceneCenter.x, sceneCenter.y, sceneCenter.z + distance],
        [sceneCenter.x, sceneCenter.y, sceneCenter.z],
        [0, 1, 0]
      );
      const topView = renderView(
        [sceneCenter.x, sceneCenter.y + distance, sceneCenter.z],
        [sceneCenter.x, sceneCenter.y, sceneCenter.z],
        [0, 0, -1]
      );
      const sideView = renderView(
        [sceneCenter.x + distance, sceneCenter.y, sceneCenter.z],
        [sceneCenter.x, sceneCenter.y, sceneCenter.z],
        [0, 1, 0]
      );

      // Canvas for 3 views
      const viewSize = resolution;
      const margin = 100;
      const spacing = 180;
      const dimSpace = 400;
      const titleHeight = 150;
      const infoHeight = 120;

      const canvasWidth = viewSize * 3 + margin * 4 + spacing * 2;
      const canvasHeight =
        viewSize + titleHeight + margin * 2 + dimSpace * 2 + infoHeight;

      const canvas = document.createElement('canvas');
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      const ctx = canvas.getContext('2d');

      ctx.fillStyle = backgroundColor;
      ctx.fillRect(0, 0, canvasWidth, canvasHeight);

      // Title
      ctx.fillStyle = '#000000';
      ctx.font = 'bold 70px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('TECHNICAL DRAWING', canvasWidth / 2, titleHeight / 2 + 25);

      const viewY = titleHeight + margin + dimSpace / 2;

      // Hàm vẽ dimension
      const drawDimensionArrow = (x1, y1, x2, y2, text, offsetY = 0) => {
        ctx.save();
        ctx.strokeStyle = '#000000';
        ctx.fillStyle = '#000000';
        ctx.lineWidth = 2.5;
        ctx.font = 'bold 38px Arial';
        ctx.textAlign = 'center';

        const isHorizontal = Math.abs(y1 - y2) < 5;

        if (isHorizontal) {
          const y = y1 + offsetY;

          // Extension lines
          if (Math.abs(offsetY) > 5) {
            ctx.setLineDash([]);
            ctx.lineWidth = 1.2;
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.lineTo(x1, y);
            ctx.stroke();

            ctx.beginPath();
            ctx.moveTo(x2, y2);
            ctx.lineTo(x2, y);
            ctx.stroke();
          }

          ctx.lineWidth = 2.5;
          ctx.beginPath();
          ctx.moveTo(x1, y);
          ctx.lineTo(x2, y);
          ctx.stroke();

          const arrowSize = 10;
          const arrowWidth = 5;

          ctx.beginPath();
          ctx.moveTo(x1, y);
          ctx.lineTo(x1 + arrowSize, y - arrowWidth);
          ctx.lineTo(x1 + arrowSize, y + arrowWidth);
          ctx.closePath();
          ctx.fill();

          ctx.beginPath();
          ctx.moveTo(x2, y);
          ctx.lineTo(x2 - arrowSize, y - arrowWidth);
          ctx.lineTo(x2 - arrowSize, y + arrowWidth);
          ctx.closePath();
          ctx.fill();

          const textWidth = ctx.measureText(text).width;
          const padding = 8;

          ctx.fillStyle = '#ffffff';
          ctx.fillRect(
            (x1 + x2) / 2 - textWidth / 2 - padding,
            y - 18,
            textWidth + padding * 2,
            36
          );

          ctx.fillStyle = '#000000';
          ctx.fillText(text, (x1 + x2) / 2, y + 8);
        } else {
          const x = x1 + offsetY;

          if (Math.abs(offsetY) > 5) {
            ctx.setLineDash([]);
            ctx.lineWidth = 1.2;
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.lineTo(x, y1);
            ctx.stroke();

            ctx.beginPath();
            ctx.moveTo(x2, y2);
            ctx.lineTo(x, y2);
            ctx.stroke();
          }

          ctx.lineWidth = 2.5;
          ctx.beginPath();
          ctx.moveTo(x, y1);
          ctx.lineTo(x, y2);
          ctx.stroke();

          const arrowSize = 10;
          const arrowWidth = 5;

          ctx.beginPath();
          ctx.moveTo(x, y1);
          ctx.lineTo(x - arrowWidth, y1 + arrowSize);
          ctx.lineTo(x + arrowWidth, y1 + arrowSize);
          ctx.closePath();
          ctx.fill();

          ctx.beginPath();
          ctx.moveTo(x, y2);
          ctx.lineTo(x - arrowWidth, y2 - arrowSize);
          ctx.lineTo(x + arrowWidth, y2 - arrowSize);
          ctx.closePath();
          ctx.fill();

          ctx.save();
          ctx.translate(x, (y1 + y2) / 2);
          ctx.rotate(-Math.PI / 2);

          const textWidth = ctx.measureText(text).width;
          const padding = 8;

          ctx.fillStyle = '#ffffff';
          ctx.fillRect(
            -textWidth / 2 - padding,
            -18,
            textWidth + padding * 2,
            36
          );

          ctx.fillStyle = '#000000';
          ctx.fillText(text, 0, 8);

          ctx.restore();
        }

        ctx.restore();
      };

      const drawView = (viewImg, viewName, baseX, viewType) => {
        return new Promise(resolveView => {
          const img = new Image();

          // img.onload = () => {
          //   ctx.drawImage(img, baseX, viewY, viewSize, viewSize);

          //   ctx.fillStyle = '#000000';
          //   ctx.font = 'bold 50px Arial';
          //   ctx.textAlign = 'center';
          //   ctx.fillText(
          //     viewName,
          //     baseX + viewSize / 2,
          //     viewY - dimSpace / 2 + 30
          //   );

          //   // worldToScreen - CHÍNH XÁC pixels
          //   const worldToScreen = worldPos => {
          //     let relativeX, relativeY;

          //     if (viewType === 'front') {
          //       relativeX = (worldPos.x - sceneBounds.min.x) / sceneSize.x;
          //       relativeY = (sceneBounds.max.y - worldPos.y) / sceneSize.y;
          //     } else if (viewType === 'top') {
          //       relativeX = (worldPos.x - sceneBounds.min.x) / sceneSize.x;
          //       relativeY = (sceneBounds.max.z - worldPos.z) / sceneSize.z;
          //     } else if (viewType === 'side') {
          //       relativeX = (worldPos.z - sceneBounds.min.z) / sceneSize.z;
          //       relativeY = (sceneBounds.max.y - worldPos.y) / sceneSize.y;
          //     }

          //     // Scale to actual model size on canvas (1.2 frustum)
          //     const scale = 1 / 1.2;
          //     const centerOffset = (viewSize * (1 - scale)) / 2;

          //     return {
          //       x: baseX + centerOffset + relativeX * viewSize * scale,
          //       y: viewY + centerOffset + relativeY * viewSize * scale,
          //     };
          //   };

          //   // === DIMENSIONS PHÍA TRÊN ===
          //   if (viewType === 'front' || viewType === 'top') {
          //     const topRow = rows[0];
          //     if (topRow && topRow.length > 0) {
          //       // 1. Dimensions chi tiết cho từng module
          //       topRow.forEach(module => {
          //         const moduleTopY = module.max.y;
          //         const moduleTopZ = module.max.z;

          //         const minPos =
          //           viewType === 'front'
          //             ? new THREE.Vector3(module.min.x, moduleTopY, 0)
          //             : new THREE.Vector3(module.min.x, 0, moduleTopZ);
          //         const maxPos =
          //           viewType === 'front'
          //             ? new THREE.Vector3(module.max.x, moduleTopY, 0)
          //             : new THREE.Vector3(module.max.x, 0, moduleTopZ);

          //         const minScreen = worldToScreen(minPos);
          //         const maxScreen = worldToScreen(maxPos);

          //         const widthMM = Math.round(module.size.x * 1000);

          //         drawDimensionArrow(
          //           minScreen.x,
          //           minScreen.y,
          //           maxScreen.x,
          //           maxScreen.y,
          //           `${widthMM}`,
          //           -60
          //         );
          //       });

          //       // 2. Dimension tổng - CHỈ VẼ NẾU CÓ NHIỀU HƠN 1 MODULE
          //       if (topRow.length > 1) {
          //         const firstModule = topRow[0];
          //         const lastModule = topRow[topRow.length - 1];

          //         const moduleTopY = firstModule.max.y;
          //         const moduleTopZ = firstModule.max.z;

          //         const topMinPos =
          //           viewType === 'front'
          //             ? new THREE.Vector3(firstModule.min.x, moduleTopY, 0)
          //             : new THREE.Vector3(firstModule.min.x, 0, moduleTopZ);

          //         const topMaxPos =
          //           viewType === 'front'
          //             ? new THREE.Vector3(lastModule.max.x, moduleTopY, 0)
          //             : new THREE.Vector3(lastModule.max.x, 0, moduleTopZ);

          //         const topMinScreen = worldToScreen(topMinPos);
          //         const topMaxScreen = worldToScreen(topMaxPos);

          //         const topRowTotalWidth = lastModule.max.x - firstModule.min.x;
          //         const totalWidthMM = Math.round(topRowTotalWidth * 1000);

          //         drawDimensionArrow(
          //           topMinScreen.x,
          //           topMinScreen.y,
          //           topMaxScreen.x,
          //           topMaxScreen.y,
          //           `${totalWidthMM}`,
          //           -120
          //         );
          //       }
          //     }
          //   }

          //   // === DIMENSIONS PHÍA DƯỚI ===
          //   if (
          //     viewType === 'front' ||
          //     viewType === 'top' ||
          //     viewType === 'side'
          //   ) {
          //     const bottomRow = rows[rows.length - 1];
          //     if (bottomRow && bottomRow.length > 0) {
          //       // 1. Dimensions chi tiết cho từng module
          //       bottomRow.forEach(module => {
          //         const moduleBottomY = module.min.y;
          //         const moduleBottomZ = module.min.z;

          //         let minPos, maxPos;

          //         if (viewType === 'side') {
          //           // SIDE VIEW: đo theo chiều Z (depth)
          //           minPos = new THREE.Vector3(0, 0, module.min.z);
          //           maxPos = new THREE.Vector3(0, 0, module.max.z);
          //         } else if (viewType === 'front') {
          //           // FRONT VIEW: đo theo chiều X (width)
          //           minPos = new THREE.Vector3(module.min.x, moduleBottomY, 0);
          //           maxPos = new THREE.Vector3(module.max.x, moduleBottomY, 0);
          //         } else {
          //           // TOP VIEW: đo theo chiều X (width)
          //           minPos = new THREE.Vector3(module.min.x, 0, moduleBottomZ);
          //           maxPos = new THREE.Vector3(module.max.x, 0, moduleBottomZ);
          //         }

          //         const minScreen = worldToScreen(minPos);
          //         const maxScreen = worldToScreen(maxPos);

          //         const dimensionMM =
          //           viewType === 'side'
          //             ? Math.round(module.size.z * 1000) // depth cho side view
          //             : Math.round(module.size.x * 1000); // width cho front/top view

          //         drawDimensionArrow(
          //           minScreen.x,
          //           minScreen.y,
          //           maxScreen.x,
          //           maxScreen.y,
          //           `${dimensionMM}`,
          //           60
          //         );
          //       });

          //       // 2. Dimension tổng - CHỈ VẼ NẾU CÓ NHIỀU HƠN 1 MODULE
          //       if (bottomRow.length > 1) {
          //         const firstModule = bottomRow[0];
          //         const lastModule = bottomRow[bottomRow.length - 1];

          //         let bottomMinPos, bottomMaxPos, totalDimension;

          //         if (viewType === 'side') {
          //           // SIDE VIEW: tổng theo chiều Z
          //           bottomMinPos = new THREE.Vector3(0, 0, firstModule.min.z);
          //           bottomMaxPos = new THREE.Vector3(0, 0, lastModule.max.z);
          //           totalDimension = lastModule.max.z - firstModule.min.z;
          //         } else if (viewType === 'front') {
          //           // FRONT VIEW: tổng theo chiều X
          //           const moduleBottomY = firstModule.min.y;
          //           bottomMinPos = new THREE.Vector3(
          //             firstModule.min.x,
          //             moduleBottomY,
          //             0
          //           );
          //           bottomMaxPos = new THREE.Vector3(
          //             lastModule.max.x,
          //             moduleBottomY,
          //             0
          //           );
          //           totalDimension = lastModule.max.x - firstModule.min.x;
          //         } else {
          //           // TOP VIEW: tổng theo chiều X
          //           const moduleBottomZ = firstModule.min.z;
          //           bottomMinPos = new THREE.Vector3(
          //             firstModule.min.x,
          //             0,
          //             moduleBottomZ
          //           );
          //           bottomMaxPos = new THREE.Vector3(
          //             lastModule.max.x,
          //             0,
          //             moduleBottomZ
          //           );
          //           totalDimension = lastModule.max.x - firstModule.min.x;
          //         }

          //         const bottomMinScreen = worldToScreen(bottomMinPos);
          //         const bottomMaxScreen = worldToScreen(bottomMaxPos);

          //         const totalWidthMM = Math.round(totalDimension * 1000);

          //         drawDimensionArrow(
          //           bottomMinScreen.x,
          //           bottomMinScreen.y,
          //           bottomMaxScreen.x,
          //           bottomMaxScreen.y,
          //           `${totalWidthMM}`,
          //           120
          //         );
          //       }
          //     }
          //   }

          //   // === DIMENSIONS BÊN PHẢI ===
          //   if (viewType === 'front' || viewType === 'top') {
          //     const rightmostColumn = columns[columns.length - 1];

          //     if (rightmostColumn && rightmostColumn.length > 0) {
          //       let dimOffset = 60;

          //       // 1. Dimensions chi tiết cho CHIỀU CAO TỪNG MODULE và KHOẢNG CÁCH giữa chúng
          //       rightmostColumn.forEach((module, idx) => {
          //         // Vẽ chiều cao của module hiện tại
          //         const moduleMinPos =
          //           viewType === 'front'
          //             ? new THREE.Vector3(module.max.x, module.min.y, 0)
          //             : new THREE.Vector3(0, module.min.y, module.max.z);

          //         const moduleMaxPos =
          //           viewType === 'front'
          //             ? new THREE.Vector3(module.max.x, module.max.y, 0)
          //             : new THREE.Vector3(0, module.max.y, module.max.z);

          //         const moduleMinScreen = worldToScreen(moduleMinPos);
          //         const moduleMaxScreen = worldToScreen(moduleMaxPos);

          //         const moduleHeightMM = Math.round(module.size.y * 1000);

          //         drawDimensionArrow(
          //           moduleMinScreen.x,
          //           moduleMaxScreen.y,
          //           moduleMaxScreen.x,
          //           moduleMinScreen.y,
          //           `${moduleHeightMM}`,
          //           dimOffset
          //         );

          //         // Vẽ khoảng cách đến module tiếp theo (nếu có)
          //         if (idx < rightmostColumn.length - 1) {
          //           const nextModule = rightmostColumn[idx + 1];

          //           const gapMinPos =
          //             viewType === 'front'
          //               ? new THREE.Vector3(module.max.x, nextModule.max.y, 0)
          //               : new THREE.Vector3(0, nextModule.max.y, module.max.z);

          //           const gapMaxPos =
          //             viewType === 'front'
          //               ? new THREE.Vector3(module.max.x, module.min.y, 0)
          //               : new THREE.Vector3(0, module.min.y, module.max.z);

          //           const gapMinScreen = worldToScreen(gapMinPos);
          //           const gapMaxScreen = worldToScreen(gapMaxPos);

          //           const gapHeightMM = Math.round(
          //             Math.abs(module.min.y - nextModule.max.y) * 1000
          //           );

          //           // Chỉ vẽ nếu có khoảng cách (> 0mm)
          //           if (gapHeightMM > 0) {
          //             drawDimensionArrow(
          //               gapMinScreen.x,
          //               gapMinScreen.y,
          //               gapMaxScreen.x,
          //               gapMaxScreen.y,
          //               `${gapHeightMM}`,
          //               dimOffset
          //             );
          //           }
          //         }
          //       });

          //       // 2. Dimension tổng - CHỈ VẼ NẾU CÓ NHIỀU HƠN 1 MODULE
          //       if (rightmostColumn.length > 1) {
          //         dimOffset += 60;

          //         const topModule = rightmostColumn[0];
          //         const bottomModule =
          //           rightmostColumn[rightmostColumn.length - 1];

          //         const heightMinPos =
          //           viewType === 'front'
          //             ? new THREE.Vector3(
          //                 topModule.max.x,
          //                 bottomModule.min.y,
          //                 0
          //               )
          //             : new THREE.Vector3(
          //                 0,
          //                 bottomModule.min.y,
          //                 topModule.max.z
          //               );

          //         const heightMaxPos =
          //           viewType === 'front'
          //             ? new THREE.Vector3(topModule.max.x, topModule.max.y, 0)
          //             : new THREE.Vector3(0, topModule.max.y, topModule.max.z);

          //         const heightMin = worldToScreen(heightMinPos);
          //         const heightMax = worldToScreen(heightMaxPos);

          //         const columnTotalHeight =
          //           topModule.max.y - bottomModule.min.y;
          //         const totalHeightMM = Math.round(columnTotalHeight * 1000);

          //         drawDimensionArrow(
          //           heightMin.x,
          //           heightMax.y,
          //           heightMax.x,
          //           heightMin.y,
          //           `${totalHeightMM}`,
          //           dimOffset
          //         );
          //       }
          //     }
          //   }

          //   // === DIMENSIONS BÊN TRÁI ===
          //   if (
          //     viewType === 'front' ||
          //     viewType === 'top' ||
          //     viewType === 'side'
          //   ) {
          //     const leftmostColumn = columns[0];

          //     if (leftmostColumn && leftmostColumn.length > 0) {
          //       let dimOffset = -60;

          //       // 1. Dimensions chi tiết cho CHIỀU CAO TỪNG MODULE và KHOẢNG CÁCH giữa chúng
          //       if (viewType === 'front' || viewType === 'side') {
          //         leftmostColumn.forEach((module, idx) => {
          //           // Vẽ chiều cao của module hiện tại
          //           const moduleMinPos =
          //             viewType === 'front'
          //               ? new THREE.Vector3(module.min.x, module.min.y, 0)
          //               : new THREE.Vector3(0, module.min.y, module.min.z);

          //           const moduleMaxPos =
          //             viewType === 'front'
          //               ? new THREE.Vector3(module.min.x, module.max.y, 0)
          //               : new THREE.Vector3(0, module.max.y, module.min.z);

          //           const moduleMinScreen = worldToScreen(moduleMinPos);
          //           const moduleMaxScreen = worldToScreen(moduleMaxPos);

          //           const moduleHeightMM = Math.round(module.size.y * 1000);

          //           drawDimensionArrow(
          //             moduleMinScreen.x,
          //             moduleMaxScreen.y,
          //             moduleMaxScreen.x,
          //             moduleMinScreen.y,
          //             `${moduleHeightMM}`,
          //             dimOffset
          //           );

          //           // Vẽ khoảng cách đến module tiếp theo (nếu có)
          //           if (idx < leftmostColumn.length - 1) {
          //             const nextModule = leftmostColumn[idx + 1];

          //             const gapMinPos =
          //               viewType === 'front'
          //                 ? new THREE.Vector3(module.min.x, nextModule.max.y, 0)
          //                 : new THREE.Vector3(
          //                     0,
          //                     nextModule.max.y,
          //                     module.min.z
          //                   );

          //             const gapMaxPos =
          //               viewType === 'front'
          //                 ? new THREE.Vector3(module.min.x, module.min.y, 0)
          //                 : new THREE.Vector3(0, module.min.y, module.min.z);

          //             const gapMinScreen = worldToScreen(gapMinPos);
          //             const gapMaxScreen = worldToScreen(gapMaxPos);

          //             const gapHeightMM = Math.round(
          //               Math.abs(module.min.y - nextModule.max.y) * 1000
          //             );

          //             // Chỉ vẽ nếu có khoảng cách (> 0mm)
          //             if (gapHeightMM > 0) {
          //               drawDimensionArrow(
          //                 gapMinScreen.x,
          //                 gapMinScreen.y,
          //                 gapMaxScreen.x,
          //                 gapMaxScreen.y,
          //                 `${gapHeightMM}`,
          //                 dimOffset
          //               );
          //             }
          //           }
          //         });

          //         // CHỈ VẼ DIMENSION TỔNG NẾU CÓ NHIỀU HƠN 1 MODULE
          //         if (leftmostColumn.length > 1) {
          //           dimOffset -= 60;
          //         }
          //       }

          //       // 2. Dimension tổng
          //       // Cho front/side: chỉ vẽ nếu có nhiều hơn 1 module
          //       // Cho top: luôn vẽ (vì đo depth, không phải chiều cao từng module)
          //       const shouldDrawTotal =
          //         viewType === 'top' || leftmostColumn.length > 1;

          //       if (shouldDrawTotal) {
          //         const topModule = leftmostColumn[0];
          //         const bottomModule =
          //           leftmostColumn[leftmostColumn.length - 1];

          //         const leftMinPos =
          //           viewType === 'front'
          //             ? new THREE.Vector3(
          //                 topModule.min.x,
          //                 bottomModule.min.y,
          //                 0
          //               )
          //             : viewType === 'top'
          //             ? new THREE.Vector3(
          //                 topModule.min.x,
          //                 0,
          //                 bottomModule.min.z
          //               )
          //             : new THREE.Vector3(
          //                 bottomModule.min.z,
          //                 bottomModule.min.y,
          //                 0
          //               );

          //         const leftMaxPos =
          //           viewType === 'front'
          //             ? new THREE.Vector3(topModule.min.x, topModule.max.y, 0)
          //             : viewType === 'top'
          //             ? new THREE.Vector3(topModule.min.x, 0, topModule.max.z)
          //             : new THREE.Vector3(topModule.min.z, topModule.max.y, 0);

          //         const leftMin = worldToScreen(leftMinPos);
          //         const leftMax = worldToScreen(leftMaxPos);

          //         let leftDimValue;
          //         if (viewType === 'side') {
          //           leftDimValue = topModule.max.y - bottomModule.min.y;
          //         } else if (viewType === 'front') {
          //           leftDimValue = topModule.max.y - bottomModule.min.y;
          //         } else {
          //           leftDimValue = topModule.max.z - bottomModule.min.z;
          //         }

          //         const leftDimMM = Math.round(leftDimValue * 1000);

          //         drawDimensionArrow(
          //           leftMin.x,
          //           leftMax.y,
          //           leftMax.x,
          //           leftMin.y,
          //           viewType === 'side' ? `H=${leftDimMM}` : `D=${leftDimMM}`,
          //           dimOffset
          //         );
          //       }
          //     }
          //   }

          //   resolveView();
          // };

          img.onload = () => {
            ctx.drawImage(img, baseX, viewY, viewSize, viewSize);

            ctx.fillStyle = '#000000';
            ctx.font = 'bold 50px Arial';
            ctx.textAlign = 'center';
            ctx.fillText(
              viewName,
              baseX + viewSize / 2,
              viewY - dimSpace / 2 + 30
            );

            // worldToScreen - CHÍNH XÁC pixels
            const worldToScreen = worldPos => {
              let relativeX, relativeY;

              if (viewType === 'front') {
                relativeX = (worldPos.x - sceneBounds.min.x) / sceneSize.x;
                relativeY = (sceneBounds.max.y - worldPos.y) / sceneSize.y;
              } else if (viewType === 'top') {
                relativeX = (worldPos.x - sceneBounds.min.x) / sceneSize.x;
                relativeY = (sceneBounds.max.z - worldPos.z) / sceneSize.z;
              } else if (viewType === 'side') {
                relativeX = (worldPos.z - sceneBounds.min.z) / sceneSize.z;
                relativeY = (sceneBounds.max.y - worldPos.y) / sceneSize.y;
              }

              // Scale to actual model size on canvas (1.2 frustum)
              const scale = 1 / 1.2;
              const centerOffset = (viewSize * (1 - scale)) / 2;

              return {
                x: baseX + centerOffset + relativeX * viewSize * scale,
                y: viewY + centerOffset + relativeY * viewSize * scale,
              };
            };

            // === DIMENSIONS PHÍA TRÊN ===
            if (viewType === 'front' || viewType === 'top') {
              const topRow = rows[0];
              if (topRow && topRow.length > 0) {
                // Tính tổng trước
                const firstModule = topRow[0];
                const lastModule = topRow[topRow.length - 1];
                const topRowTotalWidth = lastModule.max.x - firstModule.min.x;
                const totalWidthMM = Math.round(topRowTotalWidth * 1000);

                // 1. Dimensions chi tiết
                topRow.forEach(module => {
                  const widthMM = Math.round(module.size.x * 1000);

                  // CHỈ VẼ NẾU KHÔNG TRÙNG
                  if (widthMM !== totalWidthMM) {
                    const moduleTopY = module.max.y;
                    const moduleTopZ = module.max.z;

                    const minPos =
                      viewType === 'front'
                        ? new THREE.Vector3(module.min.x, moduleTopY, 0)
                        : new THREE.Vector3(module.min.x, 0, moduleTopZ);
                    const maxPos =
                      viewType === 'front'
                        ? new THREE.Vector3(module.max.x, moduleTopY, 0)
                        : new THREE.Vector3(module.max.x, 0, moduleTopZ);

                    const minScreen = worldToScreen(minPos);
                    const maxScreen = worldToScreen(maxPos);

                    drawDimensionArrow(
                      minScreen.x,
                      minScreen.y,
                      maxScreen.x,
                      maxScreen.y,
                      `${widthMM}`,
                      -60
                    );
                  }
                });

                // 2. Dimension tổng
                if (topRow.length > 1) {
                  const moduleTopY = firstModule.max.y;
                  const moduleTopZ = firstModule.max.z;

                  const topMinPos =
                    viewType === 'front'
                      ? new THREE.Vector3(firstModule.min.x, moduleTopY, 0)
                      : new THREE.Vector3(firstModule.min.x, 0, moduleTopZ);

                  const topMaxPos =
                    viewType === 'front'
                      ? new THREE.Vector3(lastModule.max.x, moduleTopY, 0)
                      : new THREE.Vector3(lastModule.max.x, 0, moduleTopZ);

                  const topMinScreen = worldToScreen(topMinPos);
                  const topMaxScreen = worldToScreen(topMaxPos);

                  drawDimensionArrow(
                    topMinScreen.x,
                    topMinScreen.y,
                    topMaxScreen.x,
                    topMaxScreen.y,
                    `${totalWidthMM}`,
                    -120
                  );
                }
              }
            }

            // === DIMENSIONS PHÍA DƯỚI ===
            if (
              viewType === 'front' ||
              viewType === 'top' ||
              viewType === 'side'
            ) {
              const bottomRow = rows[rows.length - 1];
              if (bottomRow && bottomRow.length > 0) {
                // Tính tổng trước
                const firstModule = bottomRow[0];
                const lastModule = bottomRow[bottomRow.length - 1];
                let totalDimension, totalDimensionMM;

                if (viewType === 'side') {
                  totalDimension = lastModule.max.z - firstModule.min.z;
                } else {
                  totalDimension = lastModule.max.x - firstModule.min.x;
                }
                totalDimensionMM = Math.round(totalDimension * 1000);

                // 1. Dimensions chi tiết
                bottomRow.forEach(module => {
                  const dimensionMM =
                    viewType === 'side'
                      ? Math.round(module.size.z * 1000)
                      : Math.round(module.size.x * 1000);

                  // CHỈ VẼ NẾU KHÔNG TRÙNG
                  if (dimensionMM !== totalDimensionMM) {
                    const moduleBottomY = module.min.y;

                    let minPos, maxPos;

                    if (viewType === 'side') {
                      minPos = new THREE.Vector3(
                        0,
                        moduleBottomY,
                        module.min.z
                      );
                      maxPos = new THREE.Vector3(
                        0,
                        moduleBottomY,
                        module.max.z
                      );
                    } else if (viewType === 'front') {
                      minPos = new THREE.Vector3(
                        module.min.x,
                        moduleBottomY,
                        0
                      );
                      maxPos = new THREE.Vector3(
                        module.max.x,
                        moduleBottomY,
                        0
                      );
                    } else {
                      const moduleBottomZ = module.min.z;
                      minPos = new THREE.Vector3(
                        module.min.x,
                        0,
                        moduleBottomZ
                      );
                      maxPos = new THREE.Vector3(
                        module.max.x,
                        0,
                        moduleBottomZ
                      );
                    }

                    const minScreen = worldToScreen(minPos);
                    const maxScreen = worldToScreen(maxPos);

                    drawDimensionArrow(
                      minScreen.x,
                      minScreen.y,
                      maxScreen.x,
                      maxScreen.y,
                      `${dimensionMM}`,
                      60
                    );
                  }
                });

                // 2. Dimension tổng
                if (bottomRow.length > 1) {
                  const moduleBottomY = firstModule.min.y;
                  let bottomMinPos, bottomMaxPos;

                  if (viewType === 'side') {
                    bottomMinPos = new THREE.Vector3(
                      0,
                      moduleBottomY,
                      firstModule.min.z
                    );
                    bottomMaxPos = new THREE.Vector3(
                      0,
                      moduleBottomY,
                      lastModule.max.z
                    );
                  } else if (viewType === 'front') {
                    bottomMinPos = new THREE.Vector3(
                      firstModule.min.x,
                      moduleBottomY,
                      0
                    );
                    bottomMaxPos = new THREE.Vector3(
                      lastModule.max.x,
                      moduleBottomY,
                      0
                    );
                  } else {
                    const moduleBottomZ = firstModule.min.z;
                    bottomMinPos = new THREE.Vector3(
                      firstModule.min.x,
                      0,
                      moduleBottomZ
                    );
                    bottomMaxPos = new THREE.Vector3(
                      lastModule.max.x,
                      0,
                      moduleBottomZ
                    );
                  }

                  const bottomMinScreen = worldToScreen(bottomMinPos);
                  const bottomMaxScreen = worldToScreen(bottomMaxPos);

                  drawDimensionArrow(
                    bottomMinScreen.x,
                    bottomMinScreen.y,
                    bottomMaxScreen.x,
                    bottomMaxScreen.y,
                    `${totalDimensionMM}`,
                    120
                  );
                }
              }
            }

            // === DIMENSIONS BÊN PHẢI ===
            if (viewType === 'front' || viewType === 'side') {
              const rightmostColumn = columns[columns.length - 1];

              if (rightmostColumn && rightmostColumn.length > 0) {
                // Tính tổng trước
                const topModule = rightmostColumn[0];
                const bottomModule =
                  rightmostColumn[rightmostColumn.length - 1];
                const columnTotalHeight = topModule.max.y - bottomModule.min.y;
                const totalHeightMM = Math.round(columnTotalHeight * 1000);

                let dimOffset = 60;

                // 1. Dimensions chi tiết
                rightmostColumn.forEach((module, idx) => {
                  const moduleHeightMM = Math.round(module.size.y * 1000);

                  // CHỈ VẼ NẾU KHÔNG TRÙNG
                  if (moduleHeightMM !== totalHeightMM) {
                    const moduleMinPos =
                      viewType === 'front'
                        ? new THREE.Vector3(module.max.x, module.min.y, 0)
                        : new THREE.Vector3(0, module.min.y, module.max.z);

                    const moduleMaxPos =
                      viewType === 'front'
                        ? new THREE.Vector3(module.max.x, module.max.y, 0)
                        : new THREE.Vector3(0, module.max.y, module.max.z);

                    const moduleMinScreen = worldToScreen(moduleMinPos);
                    const moduleMaxScreen = worldToScreen(moduleMaxPos);

                    drawDimensionArrow(
                      moduleMinScreen.x,
                      moduleMaxScreen.y,
                      moduleMaxScreen.x,
                      moduleMinScreen.y,
                      `${moduleHeightMM}`,
                      dimOffset
                    );
                  }

                  // Vẽ khoảng cách
                  if (idx < rightmostColumn.length - 1) {
                    const nextModule = rightmostColumn[idx + 1];

                    const gapMinPos =
                      viewType === 'front'
                        ? new THREE.Vector3(module.max.x, nextModule.max.y, 0)
                        : new THREE.Vector3(0, nextModule.max.y, module.max.z);

                    const gapMaxPos =
                      viewType === 'front'
                        ? new THREE.Vector3(module.max.x, module.min.y, 0)
                        : new THREE.Vector3(0, module.min.y, module.max.z);

                    const gapMinScreen = worldToScreen(gapMinPos);
                    const gapMaxScreen = worldToScreen(gapMaxPos);

                    const gapHeightMM = Math.round(
                      Math.abs(module.min.y - nextModule.max.y) * 1000
                    );

                    if (gapHeightMM > 0) {
                      drawDimensionArrow(
                        gapMinScreen.x,
                        gapMinScreen.y,
                        gapMaxScreen.x,
                        gapMaxScreen.y,
                        `${gapHeightMM}`,
                        dimOffset
                      );
                    }
                  }
                });

                // 2. Dimension tổng (chỉ front view)
                if (viewType === 'front' && rightmostColumn.length > 1) {
                  dimOffset += 60;

                  const heightMinPos = new THREE.Vector3(
                    topModule.max.x,
                    bottomModule.min.y,
                    0
                  );

                  const heightMaxPos = new THREE.Vector3(
                    topModule.max.x,
                    topModule.max.y,
                    0
                  );

                  const heightMin = worldToScreen(heightMinPos);
                  const heightMax = worldToScreen(heightMaxPos);

                  drawDimensionArrow(
                    heightMin.x,
                    heightMax.y,
                    heightMax.x,
                    heightMin.y,
                    `${totalHeightMM}`,
                    dimOffset
                  );
                }
              }
            }

            // // === DIMENSIONS BÊN TRÁI ===
            // if (
            //   viewType === 'front' ||
            //   viewType === 'top' ||
            //   viewType === 'side'
            // ) {
            //   const leftmostColumn = columns[0];

            //   if (leftmostColumn && leftmostColumn.length > 0) {
            //     // Tính tổng trước
            //     const topModule = leftmostColumn[0];
            //     const bottomModule = leftmostColumn[leftmostColumn.length - 1];
            //     let totalDimValue;
            //     if (viewType === 'side') {
            //       totalDimValue = topModule.max.y - bottomModule.min.y;
            //     } else if (viewType === 'front') {
            //       totalDimValue = topModule.max.y - bottomModule.min.y;
            //     } else {
            //       totalDimValue = topModule.max.z - bottomModule.min.z;
            //     }
            //     const totalDimMM = Math.round(totalDimValue * 1000);

            //     let dimOffset = -60;

            //     // 1. Dimensions chi tiết (front/side view)
            //     if (viewType === 'front' || viewType === 'side') {
            //       leftmostColumn.forEach((module, idx) => {
            //         const moduleHeightMM = Math.round(module.size.y * 1000);

            //         // CHỈ VẼ NẾU KHÔNG TRÙNG
            //         if (moduleHeightMM !== totalDimMM) {
            //           const moduleMinPos =
            //             viewType === 'front'
            //               ? new THREE.Vector3(module.min.x, module.min.y, 0)
            //               : new THREE.Vector3(0, module.min.y, module.min.z);

            //           const moduleMaxPos =
            //             viewType === 'front'
            //               ? new THREE.Vector3(module.min.x, module.max.y, 0)
            //               : new THREE.Vector3(0, module.max.y, module.min.z);

            //           const moduleMinScreen = worldToScreen(moduleMinPos);
            //           const moduleMaxScreen = worldToScreen(moduleMaxPos);

            //           drawDimensionArrow(
            //             moduleMinScreen.x,
            //             moduleMaxScreen.y,
            //             moduleMaxScreen.x,
            //             moduleMinScreen.y,
            //             `${moduleHeightMM}`,
            //             dimOffset
            //           );
            //         }

            //         // Vẽ khoảng cách
            //         if (idx < leftmostColumn.length - 1) {
            //           const nextModule = leftmostColumn[idx + 1];

            //           const gapMinPos =
            //             viewType === 'front'
            //               ? new THREE.Vector3(module.min.x, nextModule.max.y, 0)
            //               : new THREE.Vector3(
            //                   0,
            //                   nextModule.max.y,
            //                   module.min.z
            //                 );

            //           const gapMaxPos =
            //             viewType === 'front'
            //               ? new THREE.Vector3(module.min.x, module.min.y, 0)
            //               : new THREE.Vector3(0, module.min.y, module.min.z);

            //           const gapMinScreen = worldToScreen(gapMinPos);
            //           const gapMaxScreen = worldToScreen(gapMaxPos);

            //           const gapHeightMM = Math.round(
            //             Math.abs(module.min.y - nextModule.max.y) * 1000
            //           );

            //           if (gapHeightMM > 0) {
            //             drawDimensionArrow(
            //               gapMinScreen.x,
            //               gapMinScreen.y,
            //               gapMaxScreen.x,
            //               gapMaxScreen.y,
            //               `${gapHeightMM}`,
            //               dimOffset
            //             );
            //           }
            //         }
            //       });

            //       if (viewType === 'side' || leftmostColumn.length > 1) {
            //         dimOffset -= 60;
            //       }
            //     }

            //     // 2. Dimension tổng
            //     const shouldDrawTotal =
            //       viewType === 'top' ||
            //       viewType === 'side' ||
            //       (viewType === 'front' && leftmostColumn.length > 1);

            //     if (shouldDrawTotal) {
            //       const leftMinPos =
            //         viewType === 'front'
            //           ? new THREE.Vector3(
            //               topModule.min.x,
            //               bottomModule.min.y,
            //               0
            //             )
            //           : viewType === 'top'
            //           ? new THREE.Vector3(
            //               topModule.min.x,
            //               0,
            //               bottomModule.min.z
            //             )
            //           : new THREE.Vector3(
            //               bottomModule.min.z,
            //               bottomModule.min.y,
            //               0
            //             );

            //       const leftMaxPos =
            //         viewType === 'front'
            //           ? new THREE.Vector3(topModule.min.x, topModule.max.y, 0)
            //           : viewType === 'top'
            //           ? new THREE.Vector3(topModule.min.x, 0, topModule.max.z)
            //           : new THREE.Vector3(topModule.min.z, topModule.max.y, 0);

            //       const leftMin = worldToScreen(leftMinPos);
            //       const leftMax = worldToScreen(leftMaxPos);

            //       drawDimensionArrow(
            //         leftMin.x,
            //         leftMax.y,
            //         leftMax.x,
            //         leftMin.y,
            //         viewType === 'side' ? `H=${totalDimMM}` : `D=${totalDimMM}`,
            //         dimOffset
            //       );
            //     }
            //   }
            // }

            // // === DIMENSIONS BÊN TRÁI ===
            // if (
            //   viewType === 'front' ||
            //   viewType === 'top' ||
            //   viewType === 'side'
            // ) {
            //   if (viewType === 'front') {
            //     // FRONT VIEW: Đo chiều cao của CỘT TRÁI
            //     const leftmostColumn = columns[0];

            //     if (leftmostColumn && leftmostColumn.length > 0) {
            //       const topModule = leftmostColumn[0];
            //       const bottomModule =
            //         leftmostColumn[leftmostColumn.length - 1];

            //       const totalDimValue = topModule.max.y - bottomModule.min.y;
            //       const totalDimMM = Math.round(totalDimValue * 1000);

            //       let dimOffset = -100;

            //       // 1. Dimensions chi tiết
            //       leftmostColumn.forEach((module, idx) => {
            //         const moduleHeightMM = Math.round(module.size.y * 1000);

            //         // CHỈ VẼ NẾU KHÔNG TRÙNG
            //         if (moduleHeightMM !== totalDimMM) {
            //           const moduleMinPos = new THREE.Vector3(
            //             module.min.x,
            //             module.min.y,
            //             0
            //           );
            //           const moduleMaxPos = new THREE.Vector3(
            //             module.min.x,
            //             module.max.y,
            //             0
            //           );

            //           const moduleMinScreen = worldToScreen(moduleMinPos);
            //           const moduleMaxScreen = worldToScreen(moduleMaxPos);

            //           drawDimensionArrow(
            //             moduleMinScreen.x,
            //             moduleMaxScreen.y,
            //             moduleMaxScreen.x,
            //             moduleMinScreen.y,
            //             `${moduleHeightMM}`,
            //             dimOffset
            //           );
            //         }

            //         // Vẽ khoảng cách
            //         if (idx < leftmostColumn.length - 1) {
            //           const nextModule = leftmostColumn[idx + 1];

            //           const gapMinPos = new THREE.Vector3(
            //             module.min.x,
            //             nextModule.max.y,
            //             0
            //           );
            //           const gapMaxPos = new THREE.Vector3(
            //             module.min.x,
            //             module.min.y,
            //             0
            //           );

            //           const gapMinScreen = worldToScreen(gapMinPos);
            //           const gapMaxScreen = worldToScreen(gapMaxPos);

            //           const gapHeightMM = Math.round(
            //             Math.abs(module.min.y - nextModule.max.y) * 1000
            //           );

            //           if (gapHeightMM > 0) {
            //             drawDimensionArrow(
            //               gapMinScreen.x,
            //               gapMinScreen.y,
            //               gapMaxScreen.x,
            //               gapMaxScreen.y,
            //               `${gapHeightMM}`,
            //               dimOffset
            //             );
            //           }
            //         }
            //       });

            //       // 2. Dimension tổng
            //       if (leftmostColumn.length > 1) {
            //         dimOffset -= 150;

            //         const leftMinPos = new THREE.Vector3(
            //           topModule.min.x,
            //           bottomModule.min.y,
            //           0
            //         );
            //         const leftMaxPos = new THREE.Vector3(
            //           topModule.min.x,
            //           topModule.max.y,
            //           0
            //         );

            //         const leftMin = worldToScreen(leftMinPos);
            //         const leftMax = worldToScreen(leftMaxPos);

            //         drawDimensionArrow(
            //           leftMin.x,
            //           leftMax.y,
            //           leftMax.x,
            //           leftMin.y,
            //           `${totalDimMM}`,
            //           dimOffset
            //         );
            //       }
            //     }
            //   } else if (viewType === 'top') {
            //     // TOP VIEW: Đo DEPTH (Z) của cột trái
            //     const leftmostColumn = columns[0];

            //     if (leftmostColumn && leftmostColumn.length > 0) {
            //       // Tìm module có min.x nhỏ nhất (module ngoài cùng bên trái)
            //       let leftmost = leftmostColumn[0];
            //       leftmostColumn.forEach(module => {
            //         if (module.min.x < leftmost.min.x) {
            //           leftmost = module;
            //         }
            //       });

            //       // Tính depth của module này
            //       const totalDimValue = leftmost.max.z - leftmost.min.z;
            //       const totalDimMM = Math.round(totalDimValue * 1000);

            //       // Vẽ dimension dọc theo Z
            //       const leftMinPos = new THREE.Vector3(
            //         leftmost.min.x,
            //         0,
            //         leftmost.min.z
            //       );
            //       const leftMaxPos = new THREE.Vector3(
            //         leftmost.min.x,
            //         0,
            //         leftmost.max.z
            //       );

            //       const leftMin = worldToScreen(leftMinPos);
            //       const leftMax = worldToScreen(leftMaxPos);

            //       drawDimensionArrow(
            //         leftMin.x,
            //         leftMax.y,
            //         leftMax.x,
            //         leftMin.y,
            //         `D=${totalDimMM}`,
            //         -100
            //       );
            //     }
            //   } else if (viewType === 'side') {
            //     // SIDE VIEW: Đo chiều cao của CỘT TRÁI
            //     const leftmostColumn = columns[0];

            //     if (leftmostColumn && leftmostColumn.length > 0) {
            //       const topModule = leftmostColumn[0];
            //       const bottomModule =
            //         leftmostColumn[leftmostColumn.length - 1];

            //       const totalDimValue = topModule.max.y - bottomModule.min.y;
            //       const totalDimMM = Math.round(totalDimValue * 1000);

            //       let dimOffset = -100;

            //       // 1. Dimensions chi tiết
            //       leftmostColumn.forEach((module, idx) => {
            //         const moduleHeightMM = Math.round(module.size.y * 1000);

            //         // CHỈ VẼ NẾU KHÔNG TRÙNG
            //         if (moduleHeightMM !== totalDimMM) {
            //           const moduleMinPos = new THREE.Vector3(
            //             0,
            //             module.min.y,
            //             module.min.z
            //           );
            //           const moduleMaxPos = new THREE.Vector3(
            //             0,
            //             module.max.y,
            //             module.min.z
            //           );

            //           const moduleMinScreen = worldToScreen(moduleMinPos);
            //           const moduleMaxScreen = worldToScreen(moduleMaxPos);

            //           drawDimensionArrow(
            //             moduleMinScreen.x,
            //             moduleMaxScreen.y,
            //             moduleMaxScreen.x,
            //             moduleMinScreen.y,
            //             `${moduleHeightMM}`,
            //             dimOffset
            //           );
            //         }

            //         // Vẽ khoảng cách
            //         if (idx < leftmostColumn.length - 1) {
            //           const nextModule = leftmostColumn[idx + 1];

            //           const gapMinPos = new THREE.Vector3(
            //             0,
            //             nextModule.max.y,
            //             module.min.z
            //           );
            //           const gapMaxPos = new THREE.Vector3(
            //             0,
            //             module.min.y,
            //             module.min.z
            //           );

            //           const gapMinScreen = worldToScreen(gapMinPos);
            //           const gapMaxScreen = worldToScreen(gapMaxPos);

            //           const gapHeightMM = Math.round(
            //             Math.abs(module.min.y - nextModule.max.y) * 1000
            //           );

            //           if (gapHeightMM > 0) {
            //             drawDimensionArrow(
            //               gapMinScreen.x,
            //               gapMinScreen.y,
            //               gapMaxScreen.x,
            //               gapMaxScreen.y,
            //               `${gapHeightMM}`,
            //               dimOffset
            //             );
            //           }
            //         }
            //       });

            //       // 2. Dimension tổng
            //       if (leftmostColumn.length > 1) {
            //         dimOffset -= 150;
            //       }

            //       const leftMinPos = new THREE.Vector3(
            //         bottomModule.min.z,
            //         bottomModule.min.y,
            //         0
            //       );
            //       const leftMaxPos = new THREE.Vector3(
            //         topModule.min.z,
            //         topModule.max.y,
            //         0
            //       );

            //       const leftMin = worldToScreen(leftMinPos);
            //       const leftMax = worldToScreen(leftMaxPos);

            //       drawDimensionArrow(
            //         leftMin.x,
            //         leftMax.y,
            //         leftMax.x,
            //         leftMin.y,
            //         `H=${totalDimMM}`,
            //         dimOffset
            //       );
            //     }
            //   }
            // }

            // === DIMENSIONS BÊN TRÁI ===
            if (
              viewType === 'front' ||
              viewType === 'top' ||
              viewType === 'side'
            ) {
              if (viewType === 'front') {
                // FRONT VIEW: Đo chiều cao của CỘT TRÁI
                const leftmostColumn = columns[0];

                if (leftmostColumn && leftmostColumn.length > 0) {
                  const topModule = leftmostColumn[0];
                  const bottomModule =
                    leftmostColumn[leftmostColumn.length - 1];

                  const totalDimValue = topModule.max.y - bottomModule.min.y;
                  const totalDimMM = Math.round(totalDimValue * 1000);

                  let dimOffset = -100;

                  // 1. Dimensions chi tiết
                  leftmostColumn.forEach((module, idx) => {
                    const moduleHeightMM = Math.round(module.size.y * 1000);

                    // CHỈ VẼ NẾU KHÔNG TRÙNG
                    if (moduleHeightMM !== totalDimMM) {
                      const moduleMinPos = new THREE.Vector3(
                        module.min.x,
                        module.min.y,
                        0
                      );
                      const moduleMaxPos = new THREE.Vector3(
                        module.min.x,
                        module.max.y,
                        0
                      );

                      const moduleMinScreen = worldToScreen(moduleMinPos);
                      const moduleMaxScreen = worldToScreen(moduleMaxPos);

                      drawDimensionArrow(
                        moduleMinScreen.x,
                        moduleMaxScreen.y,
                        moduleMaxScreen.x,
                        moduleMinScreen.y,
                        `${moduleHeightMM}`,
                        dimOffset
                      );
                    }

                    // Vẽ khoảng cách
                    if (idx < leftmostColumn.length - 1) {
                      const nextModule = leftmostColumn[idx + 1];

                      const gapMinPos = new THREE.Vector3(
                        module.min.x,
                        nextModule.max.y,
                        0
                      );
                      const gapMaxPos = new THREE.Vector3(
                        module.min.x,
                        module.min.y,
                        0
                      );

                      const gapMinScreen = worldToScreen(gapMinPos);
                      const gapMaxScreen = worldToScreen(gapMaxPos);

                      const gapHeightMM = Math.round(
                        Math.abs(module.min.y - nextModule.max.y) * 1000
                      );

                      if (gapHeightMM > 0) {
                        drawDimensionArrow(
                          gapMinScreen.x,
                          gapMinScreen.y,
                          gapMaxScreen.x,
                          gapMaxScreen.y,
                          `${gapHeightMM}`,
                          dimOffset
                        );
                      }
                    }
                  });

                  // 2. Dimension tổng
                  if (leftmostColumn.length > 1) {
                    dimOffset -= 150;

                    const leftMinPos = new THREE.Vector3(
                      topModule.min.x,
                      bottomModule.min.y,
                      0
                    );
                    const leftMaxPos = new THREE.Vector3(
                      topModule.min.x,
                      topModule.max.y,
                      0
                    );

                    const leftMin = worldToScreen(leftMinPos);
                    const leftMax = worldToScreen(leftMaxPos);

                    drawDimensionArrow(
                      leftMin.x,
                      leftMax.y,
                      leftMax.x,
                      leftMin.y,
                      `${totalDimMM}`,
                      dimOffset
                    );
                  }
                }
              } else if (viewType === 'top') {
                // TOP VIEW: Đo DEPTH (Z) chi tiết cho TỪNG MODULE trong cột trái
                const leftmostColumn = columns[0];

                if (leftmostColumn && leftmostColumn.length > 0) {
                  // Tìm module có min.x nhỏ nhất (module ngoài cùng bên trái)
                  let leftmost = leftmostColumn[0];
                  leftmostColumn.forEach(module => {
                    if (module.min.x < leftmost.min.x) {
                      leftmost = module;
                    }
                  });

                  // Sắp xếp tất cả modules theo Z (từ phía trước ra sau)
                  const sortedByZ = [...allModules].sort(
                    (a, b) => a.center.z - b.center.z
                  );

                  // Lọc các modules ở cột trái (có cùng hoặc gần min.x)
                  const leftColumnModules = sortedByZ.filter(
                    module =>
                      Math.abs(module.min.x - leftmost.min.x) <
                      sceneSize.x * 0.05
                  );

                  if (leftColumnModules.length > 0) {
                    // Tính dimension tổng
                    const frontModule = leftColumnModules[0];
                    const backModule =
                      leftColumnModules[leftColumnModules.length - 1];
                    const totalDimValue = backModule.max.z - frontModule.min.z;
                    const totalDimMM = Math.round(totalDimValue * 1000);

                    let dimOffset = -100;

                    // 1. Dimensions chi tiết cho TỪNG MODULE
                    leftColumnModules.forEach((module, idx) => {
                      const moduleDepthMM = Math.round(module.size.z * 1000);

                      // CHỈ VẼ NẾU KHÔNG TRÙNG VỚI TỔNG
                      if (moduleDepthMM !== totalDimMM) {
                        const moduleMinPos = new THREE.Vector3(
                          module.min.x,
                          0,
                          module.min.z
                        );
                        const moduleMaxPos = new THREE.Vector3(
                          module.min.x,
                          0,
                          module.max.z
                        );

                        const moduleMinScreen = worldToScreen(moduleMinPos);
                        const moduleMaxScreen = worldToScreen(moduleMaxPos);

                        drawDimensionArrow(
                          moduleMinScreen.x,
                          moduleMaxScreen.y,
                          moduleMaxScreen.x,
                          moduleMinScreen.y,
                          `${moduleDepthMM}`,
                          dimOffset
                        );
                      }

                      // Vẽ khoảng cách giữa các module
                      if (idx < leftColumnModules.length - 1) {
                        const nextModule = leftColumnModules[idx + 1];

                        const gapMinPos = new THREE.Vector3(
                          module.min.x,
                          0,
                          module.max.z
                        );
                        const gapMaxPos = new THREE.Vector3(
                          module.min.x,
                          0,
                          nextModule.min.z
                        );

                        const gapMinScreen = worldToScreen(gapMinPos);
                        const gapMaxScreen = worldToScreen(gapMaxPos);

                        const gapDepthMM = Math.round(
                          Math.abs(nextModule.min.z - module.max.z) * 1000
                        );

                        // Chỉ vẽ nếu có khoảng cách
                        if (gapDepthMM > 0) {
                          drawDimensionArrow(
                            gapMinScreen.x,
                            gapMinScreen.y,
                            gapMaxScreen.x,
                            gapMaxScreen.y,
                            `${gapDepthMM}`,
                            dimOffset
                          );
                        }
                      }
                    });

                    // 2. Dimension tổng - CHỈ VẼ NẾU CÓ NHIỀU HƠN 1 MODULE
                    if (leftColumnModules.length > 1) {
                      dimOffset -= 150;

                      const leftMinPos = new THREE.Vector3(
                        frontModule.min.x,
                        0,
                        frontModule.min.z
                      );
                      const leftMaxPos = new THREE.Vector3(
                        frontModule.min.x,
                        0,
                        backModule.max.z
                      );

                      const leftMin = worldToScreen(leftMinPos);
                      const leftMax = worldToScreen(leftMaxPos);

                      drawDimensionArrow(
                        leftMin.x,
                        leftMax.y,
                        leftMax.x,
                        leftMin.y,
                        `D=${totalDimMM}`,
                        dimOffset
                      );
                    }
                  }
                }
              } else if (viewType === 'side') {
                // SIDE VIEW: Đo chiều cao của CỘT TRÁI
                const leftmostColumn = columns[0];

                if (leftmostColumn && leftmostColumn.length > 0) {
                  const topModule = leftmostColumn[0];
                  const bottomModule =
                    leftmostColumn[leftmostColumn.length - 1];

                  const totalDimValue = topModule.max.y - bottomModule.min.y;
                  const totalDimMM = Math.round(totalDimValue * 1000);

                  let dimOffset = -100;

                  // 1. Dimensions chi tiết
                  leftmostColumn.forEach((module, idx) => {
                    const moduleHeightMM = Math.round(module.size.y * 1000);

                    // CHỈ VẼ NẾU KHÔNG TRÙNG
                    if (moduleHeightMM !== totalDimMM) {
                      const moduleMinPos = new THREE.Vector3(
                        0,
                        module.min.y,
                        module.min.z
                      );
                      const moduleMaxPos = new THREE.Vector3(
                        0,
                        module.max.y,
                        module.min.z
                      );

                      const moduleMinScreen = worldToScreen(moduleMinPos);
                      const moduleMaxScreen = worldToScreen(moduleMaxPos);

                      drawDimensionArrow(
                        moduleMinScreen.x,
                        moduleMaxScreen.y,
                        moduleMaxScreen.x,
                        moduleMinScreen.y,
                        `${moduleHeightMM}`,
                        dimOffset
                      );
                    }

                    // Vẽ khoảng cách
                    if (idx < leftmostColumn.length - 1) {
                      const nextModule = leftmostColumn[idx + 1];

                      const gapMinPos = new THREE.Vector3(
                        0,
                        nextModule.max.y,
                        module.min.z
                      );
                      const gapMaxPos = new THREE.Vector3(
                        0,
                        module.min.y,
                        module.min.z
                      );

                      const gapMinScreen = worldToScreen(gapMinPos);
                      const gapMaxScreen = worldToScreen(gapMaxPos);

                      const gapHeightMM = Math.round(
                        Math.abs(module.min.y - nextModule.max.y) * 1000
                      );

                      if (gapHeightMM > 0) {
                        drawDimensionArrow(
                          gapMinScreen.x,
                          gapMinScreen.y,
                          gapMaxScreen.x,
                          gapMaxScreen.y,
                          `${gapHeightMM}`,
                          dimOffset
                        );
                      }
                    }
                  });

                  // 2. Dimension tổng
                  if (leftmostColumn.length > 1) {
                    dimOffset -= 150;
                  }

                  const leftMinPos = new THREE.Vector3(
                    bottomModule.min.z,
                    bottomModule.min.y,
                    0
                  );
                  const leftMaxPos = new THREE.Vector3(
                    topModule.min.z,
                    topModule.max.y,
                    0
                  );

                  const leftMin = worldToScreen(leftMinPos);
                  const leftMax = worldToScreen(leftMaxPos);

                  drawDimensionArrow(
                    leftMin.x,
                    leftMax.y,
                    leftMax.x,
                    leftMin.y,
                    `H=${totalDimMM}`,
                    dimOffset
                  );
                }
              }
            }

            resolveView();
          };

          img.src = viewImg;
        });
      };

      Promise.all([
        drawView(frontView, 'FRONT VIEW', margin, 'front'),
        drawView(topView, 'TOP VIEW', margin * 2 + viewSize + spacing, 'top'),
        drawView(
          sideView,
          'SIDE VIEW',
          margin * 3 + viewSize * 2 + spacing * 2,
          'side'
        ),
      ]).then(() => {
        const infoY = viewY + viewSize + dimSpace / 2 + 80;
        const totalSizeMM = {
          x: Math.round(sceneSize.x * 1000),
          y: Math.round(sceneSize.y * 1000),
          z: Math.round(sceneSize.z * 1000),
        };

        ctx.fillStyle = '#000000';
        ctx.font = 'bold 40px Arial';
        ctx.textAlign = 'left';
        ctx.fillText(
          `Overall: W=${totalSizeMM.x}mm × H=${totalSizeMM.y}mm × D=${totalSizeMM.z}mm`,
          margin,
          infoY
        );

        canvas.toBlob(
          blob => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

            renderer.dispose();
            renderScene.clear();

            resolve(true);
          },
          'image/png',
          1.0
        );
      });
    });
  }

  //new
  exportComplete3ViewTechnicalDrawing(
    filename = 'technical-drawing-3views.png'
  ) {
    return new Promise(resolve => {
      const allModules = [];

      this.scene.traverse(child => {
        if (
          child.userData &&
          (child.userData.type === 'module' ||
            child.userData.type === 'cabinetTrim' ||
            child.userData.type === 'cabinetCover')
        ) {
          const moduleData = {
            original: child,
            meshes: [],
            group: new THREE.Group(),
          };

          child.traverse(cItem => {
            if (
              cItem.scale.x === 0 ||
              cItem.scale.y === 0 ||
              cItem.scale.y === 0
            ) {
              return;
            }

            if (cItem.isMesh && cItem.visible) {
              const cloneCItem = cItem.clone();
              const worldPos = cItem.getWorldPosition(new THREE.Vector3());
              const worldQuat = cItem.getWorldQuaternion(
                new THREE.Quaternion()
              );
              const worldScale = cItem.getWorldScale(new THREE.Vector3());

              cloneCItem.position.copy(worldPos);
              cloneCItem.quaternion.copy(worldQuat);
              cloneCItem.scale.copy(worldScale);

              moduleData.group.add(cloneCItem);
              moduleData.meshes.push(cloneCItem);
            }
          });

          if (moduleData.meshes.length > 0) {
            const bbox = new THREE.Box3().setFromObject(moduleData.group);
            moduleData.bbox = bbox;
            moduleData.size = bbox.getSize(new THREE.Vector3());
            moduleData.center = bbox.getCenter(new THREE.Vector3());
            moduleData.min = bbox.min.clone();
            moduleData.max = bbox.max.clone();

            allModules.push(moduleData);
          }
        }
      });

      // Tính bounds từ modules
      let minX = Infinity,
        minY = Infinity,
        minZ = Infinity;
      let maxX = -Infinity,
        maxY = -Infinity,
        maxZ = -Infinity;

      allModules.forEach(module => {
        minX = Math.min(minX, module.min.x);
        minY = Math.min(minY, module.min.y);
        minZ = Math.min(minZ, module.min.z);
        maxX = Math.max(maxX, module.max.x);
        maxY = Math.max(maxY, module.max.y);
        maxZ = Math.max(maxZ, module.max.z);
      });

      const sceneBounds = {
        min: { x: minX, y: minY, z: minZ },
        max: { x: maxX, y: maxY, z: maxZ },
      };

      const sceneSize = {
        x: maxX - minX,
        y: maxY - minY,
        z: maxZ - minZ,
      };

      const sceneCenter = {
        x: (minX + maxX) / 2,
        y: (minY + maxY) / 2,
        z: (minZ + maxZ) / 2,
      };

      // Sort and group modules
      allModules.sort((a, b) => {
        if (Math.abs(a.center.y - b.center.y) > sceneSize.y * 0.1) {
          return b.center.y - a.center.y;
        }
        return a.center.x - b.center.x;
      });

      const rows = [];
      allModules.forEach(module => {
        let foundRow = false;
        for (let row of rows) {
          if (Math.abs(row[0].center.y - module.center.y) < sceneSize.y * 0.1) {
            row.push(module);
            foundRow = true;
            break;
          }
        }
        if (!foundRow) {
          rows.push([module]);
        }
      });

      rows.sort((a, b) => b[0].center.y - a[0].center.y);
      rows.forEach(row => row.sort((a, b) => a.center.x - b.center.x));

      const columns = [];
      allModules.forEach(module => {
        let foundCol = false;
        for (let col of columns) {
          if (
            Math.abs(col[0].center.x - module.center.x) <
            sceneSize.x * 0.05
          ) {
            col.push(module);
            foundCol = true;
            break;
          }
        }
        if (!foundCol) {
          columns.push([module]);
        }
      });

      columns.sort((a, b) => a[0].center.x - b[0].center.x);
      columns.forEach(col => col.sort((a, b) => b.center.y - a.center.y));

      const resolution = 3000;
      const backgroundColor = '#ffffff';

      const renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true,
        preserveDrawingBuffer: true,
      });
      renderer.setSize(resolution, resolution);

      const renderScene = new THREE.Scene();
      renderScene.background = new THREE.Color(backgroundColor);

      const renderView = (cameraPos, lookAt, up) => {
        while (renderScene.children.length > 0) {
          renderScene.remove(renderScene.children[0]);
        }

        allModules.forEach(module => {
          module.group.traverse(mesh => {
            if (mesh.isMesh && mesh.geometry) {
              const edges = new THREE.EdgesGeometry(mesh.geometry, 1);
              const positions = edges.attributes.position.array;

              const lineGeometry = new LineSegmentsGeometry();
              lineGeometry.setPositions(positions);

              const lineMaterial = new LineMaterial({
                color: 0x000000,
                linewidth: 4,
                resolution: new THREE.Vector2(resolution, resolution),
                worldUnits: false,
                alphaToCoverage: true,
                depthTest: true,
                depthWrite: true,
              });

              const lineSegments = new LineSegments2(
                lineGeometry,
                lineMaterial
              );
              lineSegments.position.copy(mesh.position);
              lineSegments.quaternion.copy(mesh.quaternion);
              lineSegments.scale.copy(mesh.scale);
              renderScene.add(lineSegments);
            }
          });
        });

        const frustumSize =
          Math.max(sceneSize.x, sceneSize.y, sceneSize.z) * 1.2;
        const camera = new THREE.OrthographicCamera(
          -frustumSize / 2,
          frustumSize / 2,
          frustumSize / 2,
          -frustumSize / 2,
          0.1,
          1000
        );
        camera.position.set(...cameraPos);
        camera.lookAt(...lookAt);
        camera.up.set(...up);

        renderer.render(renderScene, camera);
        return renderer.domElement.toDataURL('image/png');
      };

      const distance = Math.max(sceneSize.x, sceneSize.y, sceneSize.z) * 2;

      const frontView = renderView(
        [sceneCenter.x, sceneCenter.y, sceneCenter.z + distance],
        [sceneCenter.x, sceneCenter.y, sceneCenter.z],
        [0, 1, 0]
      );
      const topView = renderView(
        [sceneCenter.x, sceneCenter.y + distance, sceneCenter.z],
        [sceneCenter.x, sceneCenter.y, sceneCenter.z],
        [0, 0, -1]
      );
      const sideView = renderView(
        [sceneCenter.x + distance, sceneCenter.y, sceneCenter.z],
        [sceneCenter.x, sceneCenter.y, sceneCenter.z],
        [0, 1, 0]
      );

      // Canvas for 3 views
      const viewSize = resolution;
      const margin = 100;
      const spacing = 180;
      const dimSpace = 400;
      const titleHeight = 150;
      const infoHeight = 120;

      const canvasWidth = viewSize * 3 + margin * 4 + spacing * 2;
      const canvasHeight =
        viewSize + titleHeight + margin * 2 + dimSpace * 2 + infoHeight;

      const canvas = document.createElement('canvas');
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      const ctx = canvas.getContext('2d');

      ctx.fillStyle = backgroundColor;
      ctx.fillRect(0, 0, canvasWidth, canvasHeight);

      // Title
      ctx.fillStyle = '#000000';
      ctx.font = 'bold 70px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('TECHNICAL DRAWING', canvasWidth / 2, titleHeight / 2 + 25);

      const viewY = titleHeight + margin + dimSpace / 2;

      // =============================================
      // Hàm vẽ dimension arrow - hỗ trợ cả horizontal và vertical
      // offsetX dùng cho vertical (âm = sang trái, dương = sang phải)
      // offsetY dùng cho horizontal (âm = lên trên, dương = xuống dưới)
      // =============================================
      const drawDimensionArrow = (x1, y1, x2, y2, text, offset = 0) => {
        ctx.save();
        ctx.strokeStyle = '#000000';
        ctx.fillStyle = '#000000';
        ctx.lineWidth = 2.5;
        ctx.font = 'bold 38px Arial';
        ctx.textAlign = 'center';

        const isHorizontal = Math.abs(y1 - y2) < 5;

        if (isHorizontal) {
          // HORIZONTAL dimension: offset dịch chuyển theo Y
          const y = y1 + offset;

          if (Math.abs(offset) > 5) {
            ctx.lineWidth = 1.2;
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.lineTo(x1, y);
            ctx.stroke();

            ctx.beginPath();
            ctx.moveTo(x2, y2);
            ctx.lineTo(x2, y);
            ctx.stroke();
          }

          ctx.lineWidth = 2.5;
          ctx.beginPath();
          ctx.moveTo(x1, y);
          ctx.lineTo(x2, y);
          ctx.stroke();

          const arrowSize = 10;
          const arrowWidth = 5;

          ctx.beginPath();
          ctx.moveTo(x1, y);
          ctx.lineTo(x1 + arrowSize, y - arrowWidth);
          ctx.lineTo(x1 + arrowSize, y + arrowWidth);
          ctx.closePath();
          ctx.fill();

          ctx.beginPath();
          ctx.moveTo(x2, y);
          ctx.lineTo(x2 - arrowSize, y - arrowWidth);
          ctx.lineTo(x2 - arrowSize, y + arrowWidth);
          ctx.closePath();
          ctx.fill();

          const textWidth = ctx.measureText(text).width;
          const padding = 8;

          ctx.fillStyle = '#ffffff';
          ctx.fillRect(
            (x1 + x2) / 2 - textWidth / 2 - padding,
            y - 18,
            textWidth + padding * 2,
            36
          );

          ctx.fillStyle = '#000000';
          ctx.fillText(text, (x1 + x2) / 2, y + 8);
        } else {
          // VERTICAL dimension: offset dịch chuyển theo X
          const x = x1 + offset;

          if (Math.abs(offset) > 5) {
            ctx.lineWidth = 1.2;
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.lineTo(x, y1);
            ctx.stroke();

            ctx.beginPath();
            ctx.moveTo(x2, y2);
            ctx.lineTo(x, y2);
            ctx.stroke();
          }

          ctx.lineWidth = 2.5;
          ctx.beginPath();
          ctx.moveTo(x, y1);
          ctx.lineTo(x, y2);
          ctx.stroke();

          const arrowSize = 10;
          const arrowWidth = 5;

          // Mũi tên tại y1 (trên)
          ctx.beginPath();
          ctx.moveTo(x, y1);
          ctx.lineTo(x - arrowWidth, y1 + arrowSize);
          ctx.lineTo(x + arrowWidth, y1 + arrowSize);
          ctx.closePath();
          ctx.fill();

          // Mũi tên tại y2 (dưới)
          ctx.beginPath();
          ctx.moveTo(x, y2);
          ctx.lineTo(x - arrowWidth, y2 - arrowSize);
          ctx.lineTo(x + arrowWidth, y2 - arrowSize);
          ctx.closePath();
          ctx.fill();

          ctx.save();
          ctx.translate(x, (y1 + y2) / 2);
          ctx.rotate(-Math.PI / 2);

          const textWidth = ctx.measureText(text).width;
          const padding = 8;

          ctx.fillStyle = '#ffffff';
          ctx.fillRect(
            -textWidth / 2 - padding,
            -18,
            textWidth + padding * 2,
            36
          );

          ctx.fillStyle = '#000000';
          ctx.fillText(text, 0, 8);

          ctx.restore();
        }

        ctx.restore();
      };

      const drawView = (viewImg, viewName, baseX, viewType) => {
        return new Promise(resolveView => {
          const img = new Image();

          img.onload = () => {
            ctx.drawImage(img, baseX, viewY, viewSize, viewSize);

            ctx.fillStyle = '#000000';
            ctx.font = 'bold 50px Arial';
            ctx.textAlign = 'center';
            ctx.fillText(
              viewName,
              baseX + viewSize / 2,
              viewY - dimSpace / 2 + 30
            );

            // worldToScreen
            const worldToScreen = worldPos => {
              let relativeX, relativeY;

              if (viewType === 'front') {
                relativeX = (worldPos.x - sceneBounds.min.x) / sceneSize.x;
                relativeY = (sceneBounds.max.y - worldPos.y) / sceneSize.y;
              } else if (viewType === 'top') {
                // top view: X = world X, Y = world Z (max.z ở trên canvas = nhỏ hơn về Z)
                relativeX = (worldPos.x - sceneBounds.min.x) / sceneSize.x;
                relativeY = (sceneBounds.max.z - worldPos.z) / sceneSize.z;
              } else if (viewType === 'side') {
                relativeX = (worldPos.z - sceneBounds.min.z) / sceneSize.z;
                relativeY = (sceneBounds.max.y - worldPos.y) / sceneSize.y;
              }

              const scale = 1 / 1.2;
              const centerOffset = (viewSize * (1 - scale)) / 2;

              return {
                x: baseX + centerOffset + relativeX * viewSize * scale,
                y: viewY + centerOffset + relativeY * viewSize * scale,
              };
            };

            // =============================================
            // === DIMENSIONS PHÍA TRÊN ===
            // =============================================
            if (viewType === 'front' || viewType === 'top') {
              const topRow = rows[0];
              if (topRow && topRow.length > 0) {
                const firstModule = topRow[0];
                const lastModule = topRow[topRow.length - 1];
                const topRowTotalWidth = lastModule.max.x - firstModule.min.x;
                const totalWidthMM = Math.round(topRowTotalWidth * 1000);

                // 1. Dimensions chi tiết từng module
                topRow.forEach(module => {
                  const widthMM = Math.round(module.size.x * 1000);

                  if (widthMM !== totalWidthMM) {
                    const minPos =
                      viewType === 'front'
                        ? new THREE.Vector3(module.min.x, module.max.y, 0)
                        : new THREE.Vector3(module.min.x, 0, sceneBounds.min.z);
                    const maxPos =
                      viewType === 'front'
                        ? new THREE.Vector3(module.max.x, module.max.y, 0)
                        : new THREE.Vector3(module.max.x, 0, sceneBounds.min.z);

                    const minScreen = worldToScreen(minPos);
                    const maxScreen = worldToScreen(maxPos);

                    drawDimensionArrow(
                      minScreen.x,
                      minScreen.y,
                      maxScreen.x,
                      maxScreen.y,
                      `${widthMM}`,
                      -60
                    );
                  }
                });

                // 2. Dimension tổng
                if (topRow.length > 1) {
                  const minPos =
                    viewType === 'front'
                      ? new THREE.Vector3(
                          firstModule.min.x,
                          firstModule.max.y,
                          0
                        )
                      : new THREE.Vector3(
                          firstModule.min.x,
                          0,
                          sceneBounds.min.z
                        );
                  const maxPos =
                    viewType === 'front'
                      ? new THREE.Vector3(
                          lastModule.max.x,
                          firstModule.max.y,
                          0
                        )
                      : new THREE.Vector3(
                          lastModule.max.x,
                          0,
                          sceneBounds.min.z
                        );

                  const minScreen = worldToScreen(minPos);
                  const maxScreen = worldToScreen(maxPos);

                  drawDimensionArrow(
                    minScreen.x,
                    minScreen.y,
                    maxScreen.x,
                    maxScreen.y,
                    `${totalWidthMM}`,
                    -120
                  );
                }
              }
            }

            // =============================================
            // === DIMENSIONS PHÍA DƯỚI ===
            // =============================================
            if (
              viewType === 'front' ||
              viewType === 'top' ||
              viewType === 'side'
            ) {
              const bottomRow = rows[rows.length - 1];
              if (bottomRow && bottomRow.length > 0) {
                const firstModule = bottomRow[0];
                const lastModule = bottomRow[bottomRow.length - 1];
                let totalDimension, totalDimensionMM;

                if (viewType === 'side') {
                  totalDimension = lastModule.max.z - firstModule.min.z;
                } else {
                  totalDimension = lastModule.max.x - firstModule.min.x;
                }
                totalDimensionMM = Math.round(totalDimension * 1000);

                // 1. Dimensions chi tiết
                bottomRow.forEach(module => {
                  const dimensionMM =
                    viewType === 'side'
                      ? Math.round(module.size.z * 1000)
                      : Math.round(module.size.x * 1000);

                  if (dimensionMM !== totalDimensionMM) {
                    let minPos, maxPos;

                    if (viewType === 'side') {
                      minPos = new THREE.Vector3(0, module.min.y, module.min.z);
                      maxPos = new THREE.Vector3(0, module.min.y, module.max.z);
                    } else if (viewType === 'front') {
                      minPos = new THREE.Vector3(module.min.x, module.min.y, 0);
                      maxPos = new THREE.Vector3(module.max.x, module.min.y, 0);
                    } else {
                      // top view: dưới = max.z (bottom của canvas)
                      minPos = new THREE.Vector3(
                        module.min.x,
                        0,
                        sceneBounds.max.z
                      );
                      maxPos = new THREE.Vector3(
                        module.max.x,
                        0,
                        sceneBounds.max.z
                      );
                    }

                    const minScreen = worldToScreen(minPos);
                    const maxScreen = worldToScreen(maxPos);

                    drawDimensionArrow(
                      minScreen.x,
                      minScreen.y,
                      maxScreen.x,
                      maxScreen.y,
                      `${dimensionMM}`,
                      60
                    );
                  }
                });

                // 2. Dimension tổng
                if (bottomRow.length > 1) {
                  let bottomMinPos, bottomMaxPos;

                  if (viewType === 'side') {
                    bottomMinPos = new THREE.Vector3(
                      0,
                      firstModule.min.y,
                      firstModule.min.z
                    );
                    bottomMaxPos = new THREE.Vector3(
                      0,
                      firstModule.min.y,
                      lastModule.max.z
                    );
                  } else if (viewType === 'front') {
                    bottomMinPos = new THREE.Vector3(
                      firstModule.min.x,
                      firstModule.min.y,
                      0
                    );
                    bottomMaxPos = new THREE.Vector3(
                      lastModule.max.x,
                      firstModule.min.y,
                      0
                    );
                  } else {
                    bottomMinPos = new THREE.Vector3(
                      firstModule.min.x,
                      0,
                      sceneBounds.max.z
                    );
                    bottomMaxPos = new THREE.Vector3(
                      lastModule.max.x,
                      0,
                      sceneBounds.max.z
                    );
                  }

                  const bottomMinScreen = worldToScreen(bottomMinPos);
                  const bottomMaxScreen = worldToScreen(bottomMaxPos);

                  drawDimensionArrow(
                    bottomMinScreen.x,
                    bottomMinScreen.y,
                    bottomMaxScreen.x,
                    bottomMaxScreen.y,
                    `${totalDimensionMM}`,
                    120
                  );
                }
              }
            }

            // =============================================
            // === DIMENSIONS BÊN PHẢI ===
            // =============================================
            if (viewType === 'front' || viewType === 'side') {
              const rightmostColumn = columns[columns.length - 1];

              if (rightmostColumn && rightmostColumn.length > 0) {
                const topModule = rightmostColumn[0];
                const bottomModule =
                  rightmostColumn[rightmostColumn.length - 1];
                const columnTotalHeight = topModule.max.y - bottomModule.min.y;
                const totalHeightMM = Math.round(columnTotalHeight * 1000);

                let dimOffset = 60;

                // 1. Dimensions chi tiết
                rightmostColumn.forEach((module, idx) => {
                  const moduleHeightMM = Math.round(module.size.y * 1000);

                  if (moduleHeightMM !== totalHeightMM) {
                    const moduleMinPos =
                      viewType === 'front'
                        ? new THREE.Vector3(module.max.x, module.min.y, 0)
                        : new THREE.Vector3(0, module.min.y, module.max.z);
                    const moduleMaxPos =
                      viewType === 'front'
                        ? new THREE.Vector3(module.max.x, module.max.y, 0)
                        : new THREE.Vector3(0, module.max.y, module.max.z);

                    const moduleMinScreen = worldToScreen(moduleMinPos);
                    const moduleMaxScreen = worldToScreen(moduleMaxPos);

                    // vertical: y1=top(max.y), y2=bottom(min.y)
                    drawDimensionArrow(
                      moduleMaxScreen.x,
                      moduleMaxScreen.y,
                      moduleMinScreen.x,
                      moduleMinScreen.y,
                      `${moduleHeightMM}`,
                      dimOffset
                    );
                  }

                  // Vẽ khoảng cách
                  if (idx < rightmostColumn.length - 1) {
                    const nextModule = rightmostColumn[idx + 1];

                    const gapMinPos =
                      viewType === 'front'
                        ? new THREE.Vector3(module.max.x, nextModule.max.y, 0)
                        : new THREE.Vector3(0, nextModule.max.y, module.max.z);
                    const gapMaxPos =
                      viewType === 'front'
                        ? new THREE.Vector3(module.max.x, module.min.y, 0)
                        : new THREE.Vector3(0, module.min.y, module.max.z);

                    const gapMinScreen = worldToScreen(gapMinPos);
                    const gapMaxScreen = worldToScreen(gapMaxPos);

                    const gapHeightMM = Math.round(
                      Math.abs(module.min.y - nextModule.max.y) * 1000
                    );

                    if (gapHeightMM > 0) {
                      drawDimensionArrow(
                        gapMinScreen.x,
                        gapMinScreen.y,
                        gapMaxScreen.x,
                        gapMaxScreen.y,
                        `${gapHeightMM}`,
                        dimOffset
                      );
                    }
                  }
                });

                // 2. Dimension tổng (chỉ front view)
                if (viewType === 'front' && rightmostColumn.length > 1) {
                  dimOffset += 60;

                  const heightMinPos = new THREE.Vector3(
                    topModule.max.x,
                    topModule.max.y,
                    0
                  );
                  const heightMaxPos = new THREE.Vector3(
                    topModule.max.x,
                    bottomModule.min.y,
                    0
                  );

                  const heightMin = worldToScreen(heightMinPos);
                  const heightMax = worldToScreen(heightMaxPos);

                  drawDimensionArrow(
                    heightMin.x,
                    heightMin.y,
                    heightMax.x,
                    heightMax.y,
                    `${totalHeightMM}`,
                    dimOffset
                  );
                }
              }
            }

            // =============================================
            // === DIMENSIONS BÊN TRÁI ===
            // =============================================
            if (
              viewType === 'front' ||
              viewType === 'top' ||
              viewType === 'side'
            ) {
              if (viewType === 'front') {
                // FRONT VIEW: Đo chiều cao cột trái
                const leftmostColumn = columns[0];

                if (leftmostColumn && leftmostColumn.length > 0) {
                  const topModule = leftmostColumn[0];
                  const bottomModule =
                    leftmostColumn[leftmostColumn.length - 1];
                  const totalDimValue = topModule.max.y - bottomModule.min.y;
                  const totalDimMM = Math.round(totalDimValue * 1000);

                  let dimOffset = -100;

                  // 1. Dimensions chi tiết
                  leftmostColumn.forEach((module, idx) => {
                    const moduleHeightMM = Math.round(module.size.y * 1000);

                    if (moduleHeightMM !== totalDimMM) {
                      const moduleMaxPos = new THREE.Vector3(
                        module.min.x,
                        module.max.y,
                        0
                      );
                      const moduleMinPos = new THREE.Vector3(
                        module.min.x,
                        module.min.y,
                        0
                      );

                      const moduleMaxScreen = worldToScreen(moduleMaxPos);
                      const moduleMinScreen = worldToScreen(moduleMinPos);

                      drawDimensionArrow(
                        moduleMaxScreen.x,
                        moduleMaxScreen.y,
                        moduleMinScreen.x,
                        moduleMinScreen.y,
                        `${moduleHeightMM}`,
                        dimOffset
                      );
                    }

                    // Vẽ khoảng cách
                    if (idx < leftmostColumn.length - 1) {
                      const nextModule = leftmostColumn[idx + 1];

                      const gapTopPos = new THREE.Vector3(
                        module.min.x,
                        module.min.y,
                        0
                      );
                      const gapBotPos = new THREE.Vector3(
                        module.min.x,
                        nextModule.max.y,
                        0
                      );

                      const gapTopScreen = worldToScreen(gapTopPos);
                      const gapBotScreen = worldToScreen(gapBotPos);

                      const gapHeightMM = Math.round(
                        Math.abs(module.min.y - nextModule.max.y) * 1000
                      );

                      if (gapHeightMM > 0) {
                        drawDimensionArrow(
                          gapTopScreen.x,
                          gapTopScreen.y,
                          gapBotScreen.x,
                          gapBotScreen.y,
                          `${gapHeightMM}`,
                          dimOffset
                        );
                      }
                    }
                  });

                  // 2. Dimension tổng
                  if (leftmostColumn.length > 1) {
                    dimOffset -= 150;

                    const leftMaxPos = new THREE.Vector3(
                      topModule.min.x,
                      topModule.max.y,
                      0
                    );
                    const leftMinPos = new THREE.Vector3(
                      topModule.min.x,
                      bottomModule.min.y,
                      0
                    );

                    const leftMax = worldToScreen(leftMaxPos);
                    const leftMin = worldToScreen(leftMinPos);

                    drawDimensionArrow(
                      leftMax.x,
                      leftMax.y,
                      leftMin.x,
                      leftMin.y,
                      `${totalDimMM}`,
                      dimOffset
                    );
                  }
                }
              } else if (viewType === 'top') {
                // =============================================
                // TOP VIEW: Đo DEPTH (Z) bên trái
                // Trong top view: trục Y canvas = trục Z world
                // Z nhỏ (front) → screen Y nhỏ (trên canvas)
                // Z lớn (back)  → screen Y lớn (dưới canvas)
                // Dimension bên trái: vẽ theo chiều dọc (vertical)
                // offset âm → sang trái
                // =============================================
                const leftmostColumn = columns[0];

                if (leftmostColumn && leftmostColumn.length > 0) {
                  // Tìm module ngoài cùng bên trái (min.x nhỏ nhất)
                  let leftmost = leftmostColumn[0];
                  leftmostColumn.forEach(module => {
                    if (module.min.x < leftmost.min.x) leftmost = module;
                  });

                  // Sắp xếp tất cả modules theo Z tăng dần (front → back)
                  const sortedByZ = [...allModules].sort(
                    (a, b) => a.center.z - b.center.z
                  );

                  // Lọc modules ở cột trái (cùng x với leftmost)
                  const leftColumnModules = sortedByZ.filter(
                    module =>
                      Math.abs(module.min.x - leftmost.min.x) <
                      sceneSize.x * 0.05
                  );

                  if (leftColumnModules.length > 0) {
                    const frontModule = leftColumnModules[0]; // Z nhỏ nhất = phía trên canvas
                    const backModule =
                      leftColumnModules[leftColumnModules.length - 1]; // Z lớn nhất = phía dưới canvas
                    const totalDimValue = backModule.max.z - frontModule.min.z;
                    const totalDimMM = Math.round(totalDimValue * 1000);

                    let dimOffset = -100; // sang trái

                    // 1. Dimensions chi tiết từng module
                    leftColumnModules.forEach((module, idx) => {
                      const moduleDepthMM = Math.round(module.size.z * 1000);

                      if (moduleDepthMM !== totalDimMM) {
                        // min.z → screen y nhỏ hơn (phía trên)
                        // max.z → screen y lớn hơn (phía dưới)
                        const topPos = new THREE.Vector3(
                          module.min.x,
                          0,
                          module.min.z
                        );
                        const botPos = new THREE.Vector3(
                          module.min.x,
                          0,
                          module.max.z
                        );

                        const topScreen = worldToScreen(topPos);
                        const botScreen = worldToScreen(botPos);

                        drawDimensionArrow(
                          topScreen.x,
                          topScreen.y, // y1 = nhỏ hơn (trên)
                          botScreen.x,
                          botScreen.y, // y2 = lớn hơn (dưới)
                          `${moduleDepthMM}`,
                          dimOffset
                        );
                      }

                      // Vẽ khoảng cách giữa các module
                      if (idx < leftColumnModules.length - 1) {
                        const nextModule = leftColumnModules[idx + 1];

                        const gapTopPos = new THREE.Vector3(
                          module.min.x,
                          0,
                          module.max.z
                        );
                        const gapBotPos = new THREE.Vector3(
                          module.min.x,
                          0,
                          nextModule.min.z
                        );

                        const gapTopScreen = worldToScreen(gapTopPos);
                        const gapBotScreen = worldToScreen(gapBotPos);

                        const gapDepthMM = Math.round(
                          Math.abs(nextModule.min.z - module.max.z) * 1000
                        );

                        if (gapDepthMM > 0) {
                          drawDimensionArrow(
                            gapTopScreen.x,
                            gapTopScreen.y,
                            gapBotScreen.x,
                            gapBotScreen.y,
                            `${gapDepthMM}`,
                            dimOffset
                          );
                        }
                      }
                    });

                    // 2. Dimension tổng D=
                    if (leftColumnModules.length > 1) {
                      dimOffset -= 150;
                    }

                    const totalTopPos = new THREE.Vector3(
                      frontModule.min.x,
                      0,
                      frontModule.min.z
                    );
                    const totalBotPos = new THREE.Vector3(
                      frontModule.min.x,
                      0,
                      backModule.max.z
                    );

                    const totalTopScreen = worldToScreen(totalTopPos);
                    const totalBotScreen = worldToScreen(totalBotPos);

                    drawDimensionArrow(
                      totalTopScreen.x,
                      totalTopScreen.y, // y1 = nhỏ hơn (trên)
                      totalBotScreen.x,
                      totalBotScreen.y, // y2 = lớn hơn (dưới)
                      `D=${totalDimMM}`,
                      dimOffset
                    );
                  }
                }
              } else if (viewType === 'side') {
                // SIDE VIEW: Đo chiều cao cột trái
                const leftmostColumn = columns[0];

                if (leftmostColumn && leftmostColumn.length > 0) {
                  const topModule = leftmostColumn[0];
                  const bottomModule =
                    leftmostColumn[leftmostColumn.length - 1];
                  const totalDimValue = topModule.max.y - bottomModule.min.y;
                  const totalDimMM = Math.round(totalDimValue * 1000);

                  let dimOffset = -100;

                  // 1. Dimensions chi tiết
                  leftmostColumn.forEach((module, idx) => {
                    const moduleHeightMM = Math.round(module.size.y * 1000);

                    if (moduleHeightMM !== totalDimMM) {
                      const moduleMaxPos = new THREE.Vector3(
                        0,
                        module.max.y,
                        module.min.z
                      );
                      const moduleMinPos = new THREE.Vector3(
                        0,
                        module.min.y,
                        module.min.z
                      );

                      const moduleMaxScreen = worldToScreen(moduleMaxPos);
                      const moduleMinScreen = worldToScreen(moduleMinPos);

                      drawDimensionArrow(
                        moduleMaxScreen.x,
                        moduleMaxScreen.y,
                        moduleMinScreen.x,
                        moduleMinScreen.y,
                        `${moduleHeightMM}`,
                        dimOffset
                      );
                    }

                    // Vẽ khoảng cách
                    if (idx < leftmostColumn.length - 1) {
                      const nextModule = leftmostColumn[idx + 1];

                      const gapTopPos = new THREE.Vector3(
                        0,
                        module.min.y,
                        module.min.z
                      );
                      const gapBotPos = new THREE.Vector3(
                        0,
                        nextModule.max.y,
                        module.min.z
                      );

                      const gapTopScreen = worldToScreen(gapTopPos);
                      const gapBotScreen = worldToScreen(gapBotPos);

                      const gapHeightMM = Math.round(
                        Math.abs(module.min.y - nextModule.max.y) * 1000
                      );

                      if (gapHeightMM > 0) {
                        drawDimensionArrow(
                          gapTopScreen.x,
                          gapTopScreen.y,
                          gapBotScreen.x,
                          gapBotScreen.y,
                          `${gapHeightMM}`,
                          dimOffset
                        );
                      }
                    }
                  });

                  // 2. Dimension tổng H=
                  if (leftmostColumn.length > 1) {
                    dimOffset -= 150;
                  }

                  const leftMaxPos = new THREE.Vector3(
                    0,
                    topModule.max.y,
                    topModule.min.z
                  );
                  const leftMinPos = new THREE.Vector3(
                    0,
                    bottomModule.min.y,
                    bottomModule.min.z
                  );

                  const leftMax = worldToScreen(leftMaxPos);
                  const leftMin = worldToScreen(leftMinPos);

                  drawDimensionArrow(
                    leftMax.x,
                    leftMax.y,
                    leftMin.x,
                    leftMin.y,
                    `H=${totalDimMM}`,
                    dimOffset
                  );
                }
              }
            }

            resolveView();
          };

          img.src = viewImg;
        });
      };

      Promise.all([
        drawView(frontView, 'FRONT VIEW', margin, 'front'),
        drawView(topView, 'TOP VIEW', margin * 2 + viewSize + spacing, 'top'),
        drawView(
          sideView,
          'SIDE VIEW',
          margin * 3 + viewSize * 2 + spacing * 2,
          'side'
        ),
      ]).then(() => {
        const infoY = viewY + viewSize + dimSpace / 2 + 80;
        const totalSizeMM = {
          x: Math.round(sceneSize.x * 1000),
          y: Math.round(sceneSize.y * 1000),
          z: Math.round(sceneSize.z * 1000),
        };

        ctx.fillStyle = '#000000';
        ctx.font = 'bold 40px Arial';
        ctx.textAlign = 'left';
        ctx.fillText(
          `Overall: W=${totalSizeMM.x}mm × H=${totalSizeMM.y}mm × D=${totalSizeMM.z}mm`,
          margin,
          infoY
        );

        canvas.toBlob(
          blob => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

            renderer.dispose();
            renderScene.clear();

            resolve(true);
          },
          'image/png',
          1.0
        );
      });
    });
  }

  //ban ve lap rap
  /* =============================================================================
   *  XUẤT MẶT CẮT 2D TỪNG MODULE RA PDF (mỗi module = 1 trang)
   * -----------------------------------------------------------------------------
   *  CÁCH DÙNG:
   *    1) Cài jsPDF:   npm install jspdf
   *    2) Dán TẤT CẢ các method dưới đây vào trong class SceneManager
   *       (cùng cấp với exportComplete3ViewTechnicalDrawing).
   *       Các import cần thiết (THREE, LineSegmentsGeometry, LineSegments2,
   *       LineMaterial, InsideType, openMessageError) bạn đã có sẵn ở đầu file.
   *    3) Gọi:
   *         await sceneManager.exportModules2DToPDF('mat-cat-2d.pdf');
   *       hoặc tuỳ chỉnh:
   *         await sceneManager.exportModules2DToPDF('out.pdf', {
   *           views: ['front', 'side'],   // các mặt cần vẽ
   *           includeTypes: ['module'],   // userData.type được coi là module
   *           resolution: 1600,           // độ phân giải render mỗi mặt (px)
   *         });
   * ========================================================================== */

  /**
   * Hàm chính: duyệt từng module, render mặt cắt 2D và xuất ra PDF.
   * @param {string} filename
   * @param {object} options
   *   - views {string[]}        : mặt cần vẽ, gồm 'front' | 'side' | 'top'
   *   - includeTypes {string[]} : userData.type được coi là module
   *   - resolution {number}     : độ phân giải render mỗi mặt (px)
   * @returns {Promise<boolean>}
   */
  async exportModules2DToPDF(filename = 'mat-cat-2d.pdf', options = {}) {
    const {
      views = ['front', 'side'],
      includeTypes = ['module'],
      resolution = 1600,
      // Các loại inside cần đo khoảng cách lân cận (đọc từ userData.topEdge...)
      internalDimTypes = [InsideType.HPANEL, InsideType.VPANEL].filter(
        v => v !== undefined
      ),
      // Xoay thêm để đưa mặt trước về chính diện nếu model dựng front ở trục khác +Z.
      // Thử 0 / 90 / 180 / 270 nếu hình đang nhìn từ hông.
      frontOffsetDeg = 0,
    } = options;

    // 1) Thu thập danh sách module
    const modules = this._collectModulesForDrawing(
      includeTypes,
      internalDimTypes,
      frontOffsetDeg
    );

    // Chẩn đoán: giúp phát hiện sai tên enum hoặc thiếu edge trong userData
    if (internalDimTypes.length === 0) {
      console.warn(
        '[export2D] internalDimTypes rỗng — InsideType.HPANEL/VPANEL có thể undefined. ' +
          'Hãy truyền giá trị thực: exportModules2DToPDF(name, { internalDimTypes: [...] })'
      );
    } else {
      const totalPanels = modules.reduce(
        (n, m) => n + (m.internalPanels?.length || 0),
        0
      );
      if (totalPanels === 0) {
        console.warn(
          '[export2D] Không tìm thấy inside nào khớp internalDimTypes:',
          internalDimTypes,
          '— kiểm tra lại userData.type của HPANEL/VPANEL.'
        );
      }
    }
    if (!modules.length) {
      openMessageError?.({ content: 'Không tìm thấy module nào để xuất!' });
      return false;
    }

    // 2) Nạp jsPDF (import động để không phải sửa import ở đầu file)
    let jsPDF;
    try {
      ({ jsPDF } = await import('jspdf'));
    } catch (e) {
      console.error(e);
      openMessageError?.({
        content: 'Chưa cài jsPDF. Hãy chạy: npm install jspdf',
      });
      return false;
    }

    // 3) Renderer offscreen dùng chung cho mọi lần render
    const renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true,
      preserveDrawingBuffer: true,
    });
    renderer.setSize(resolution, resolution);
    renderer.setPixelRatio(1);

    const renderScene = new THREE.Scene();
    renderScene.background = new THREE.Color('#ffffff');

    // 4) Tạo PDF khổ A4 ngang
    const pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
    });
    const pageW = pdf.internal.pageSize.getWidth();
    const pageH = pdf.internal.pageSize.getHeight();

    try {
      for (let i = 0; i < modules.length; i++) {
        const pageCanvas = this._composeModulePageCanvas(
          modules[i],
          i + 1,
          modules.length,
          views,
          renderer,
          renderScene,
          resolution
        );

        const imgData = pageCanvas.toDataURL('image/png');
        if (i > 0) pdf.addPage();
        // pageCanvas đã đúng tỉ lệ A4 ngang nên fill trọn trang
        pdf.addImage(imgData, 'PNG', 0, 0, pageW, pageH);
      }

      pdf.save(filename);
      return true;
    } catch (err) {
      console.error('Export modules 2D PDF error:', err);
      openMessageError?.({ content: 'Có lỗi khi xuất PDF mặt cắt 2D!' });
      return false;
    } finally {
      // dọn dẹp
      while (renderScene.children.length) {
        const obj = renderScene.children[0];
        renderScene.remove(obj);
        obj.geometry?.dispose?.();
        obj.material?.dispose?.();
      }
      renderer.dispose();
    }
  }

  /**
   * Thu thập tất cả module trong scene, clone mesh kèm world-transform,
   * tính bounding box phục vụ render mặt cắt.
   */
  _collectModulesForDrawing(
    includeTypes = ['module'],
    internalDimTypes = [],
    frontOffsetDeg = 0
  ) {
    const modules = [];

    // Đảm bảo ma trận world mới nhất để tính bbox/khoảng cách chính xác
    this.scene.updateMatrixWorld(true);

    const offsetRad = (frontOffsetDeg * Math.PI) / 180;

    this.scene.traverse(child => {
      if (!child.userData || !includeTypes.includes(child.userData.type))
        return;

      // Góc quay world quanh trục đứng (Y) — dùng để gom nhóm + đưa về chính diện
      const wq = child.getWorldQuaternion(new THREE.Quaternion());
      const rotationY = new THREE.Euler().setFromQuaternion(wq, 'YXZ').y;

      // Góc bake: đưa mặt trước về +Z. Nếu mặt trước của model nằm ở trục khác,
      // chỉnh frontOffsetDeg (0/90/180/270) để xoay thêm cho đúng chính diện.
      const bakeRad = -rotationY + offsetRad;
      const R = new THREE.Matrix4().makeRotationY(bakeRad);
      const tmpM = new THREE.Matrix4();
      const tpos = new THREE.Vector3();
      const tquat = new THREE.Quaternion();
      const tscl = new THREE.Vector3();

      const group = new THREE.Group();
      const internalPanels = []; // các inside cần đo khoảng cách (HPANEL, VPANEL...)

      child.traverse(cItem => {
        // Ghi nhận panel (inside) cần đo khoảng cách — áp dụng cho CẢ Group lẫn Mesh.
        // Phải đặt TRƯỚC guard isMesh vì inside thường là Group bọc nhiều mesh,
        // và userData.type / topEdge / bottomEdge được lưu trên Group đó.
        if (
          cItem.userData?.type !== undefined &&
          internalDimTypes.includes(cItem.userData.type)
        ) {
          internalPanels.push(cItem);
        }

        if (!cItem.isMesh || !cItem.visible) return;
        if (cItem.scale.x === 0 || cItem.scale.y === 0 || cItem.scale.z === 0)
          return;
        // Bỏ phụ kiện gây nhiễu mặt cắt (giống logic export 3-view của bạn)
        if (cItem.userData?.type === InsideType.ACCESSORY_DISH_UPPER) return;
        // Bỏ qua cánh cửa để thấy rõ bên trong tủ (mặt cắt)
        if (cItem.userData?.type === InsideType.DOOR) return;

        // Lấy world matrix rồi premultiply R để đưa về chính diện
        cItem.updateWorldMatrix(true, false);
        tmpM.copy(R).multiply(cItem.matrixWorld);

        const clone = cItem.clone();
        tmpM.decompose(tpos, tquat, tscl);
        clone.position.copy(tpos);
        clone.quaternion.copy(tquat);
        clone.scale.copy(tscl);
        group.add(clone);
      });

      if (group.children.length === 0) return;

      const bbox = new THREE.Box3().setFromObject(group);
      const size = bbox.getSize(new THREE.Vector3());
      const center = bbox.getCenter(new THREE.Vector3());

      modules.push({
        original: child,
        group,
        size,
        center,
        min: bbox.min.clone(),
        max: bbox.max.clone(),
        internalPanels,
        rotationY,
        bakeRad,
        name:
          child.userData?.moduleName ||
          child.userData?.name ||
          child.name ||
          `Module ${modules.length + 1}`,
      });
    });

    // Sắp xếp trái → phải, trên → dưới cho thứ tự trang dễ theo dõi
    modules.sort((a, b) => {
      if (Math.abs(a.center.x - b.center.x) > 0.01)
        return a.center.x - b.center.x;
      return b.center.y - a.center.y;
    });

    return modules;
  }

  /**
   * Lấy mesh từ tham chiếu edge trong userData. Hỗ trợ cả 2 dạng:
   *   - userData.topEdge là chính mesh
   *   - userData.topEdge = { mesh: ... }
   */
  _resolveEdgeMesh(edge) {
    if (!edge) return null;

    // Helper: tra mesh từ uuid trong scene (ưu tiên hàm sẵn có findGLTFByUuid)
    const byUuid = uuid =>
      (typeof this.findGLTFByUuid === 'function'
        ? this.findGLTFByUuid(uuid)
        : null) ||
      this.scene?.getObjectByProperty('uuid', uuid) ||
      null;

    // Lưu dạng uuid string
    if (typeof edge === 'string') return byUuid(edge);
    // Lưu trực tiếp là Object3D
    if (edge.isObject3D) return edge;
    // Lưu dạng { mesh: Object3D }
    if (edge.mesh?.isObject3D) return edge.mesh;
    // Lưu dạng object có field uuid (không phải Object3D)
    if (typeof edge.uuid === 'string') return byUuid(edge.uuid);

    return null;
  }

  /**
   * Tính các đoạn kích thước "khoảng cách" bên trong module.
   * Với mỗi panel (HPANEL/VPANEL...) đọc topEdge/bottomEdge/leftEdge/rightEdge
   * trong userData, tự xác định trục (X/Y/Z) theo vị trí tương đối rồi tính khe hở.
   *   - Trục Y  -> mặt trước, kích thước dọc (khoảng cách trên/dưới HPANEL)
   *   - Trục X  -> mặt trước, kích thước ngang (khoảng cách trái/phải VPANEL)
   *   - Trục Z  -> mặt cạnh, kích thước ngang
   * Trả về: { front: [...], side: [...] }, mỗi phần tử { orient, lo, hi, valueMM }.
   */
  _buildInternalDimSegments(mod) {
    const out = { front: [], side: [] };
    const panels = mod.internalPanels || [];
    if (!panels.length) return out;

    // Cùng phép bake với hình: đưa box panel/edge về hệ canonical (front = +Z)
    const R = new THREE.Matrix4().makeRotationY(
      mod.bakeRad ?? -(mod.rotationY || 0)
    );
    const boxOf = obj => {
      const b = new THREE.Box3().setFromObject(obj);
      if (b.isEmpty()) return null;
      return b.applyMatrix4(R);
    };

    const EDGE_DEFS = {
      topEdge: ['topEdgeUuid', 'topEdge'],
      bottomEdge: ['bottomEdgeUuid', 'bottomEdge'],
      leftEdge: ['leftEdgeUuid', 'leftEdge'],
      rightEdge: ['rightEdgeUuid', 'rightEdge'],
    };

    const readEdgeBox = (panel, name) => {
      let ref;
      for (const k of EDGE_DEFS[name]) {
        ref = panel.userData?.[k] ?? panel.userData?.edges?.[k];
        if (ref) break;
      }
      const m = this._resolveEdgeMesh(ref);
      if (!m) return null;
      return boxOf(m);
    };

    // Phân loại tấm theo trục mỏng nhất (= pháp tuyến của tấm)
    const shelves = []; // tấm nằm ngang -> đo khoảng hở theo Y (mặt trước, dọc)
    const dividers = []; // tấm dựng đứng -> đo khoảng hở theo X (mặt trước, ngang)

    // Biên khung suy ra từ chính các edge tham chiếu
    let yTop = -Infinity; // mặt dưới của khung trên
    let yBot = Infinity; //  mặt trên của khung dưới
    let xLeft = Infinity; // mặt phải của khung trái
    let xRight = -Infinity; // mặt trái của khung phải

    for (const panel of panels) {
      const pBox = boxOf(panel);
      if (!pBox) continue;
      const s = pBox.getSize(new THREE.Vector3());

      // Trục mỏng nhất
      const thin =
        s.y <= s.x && s.y <= s.z ? 'y' : s.x <= s.y && s.x <= s.z ? 'x' : 'z';

      if (thin === 'y') {
        // Tấm ngang (HPANEL)
        shelves.push({ min: pBox.min.y, max: pBox.max.y });
        const top = readEdgeBox(panel, 'topEdge');
        const bottom = readEdgeBox(panel, 'bottomEdge');
        if (top) yTop = Math.max(yTop, top.min.y);
        if (bottom) yBot = Math.min(yBot, bottom.max.y);
      } else if (thin === 'x') {
        // Tấm dựng (VPANEL)
        dividers.push({ min: pBox.min.x, max: pBox.max.x });
        const left = readEdgeBox(panel, 'leftEdge');
        const right = readEdgeBox(panel, 'rightEdge');
        if (left) xLeft = Math.min(xLeft, left.max.x);
        if (right) xRight = Math.max(xRight, right.min.x);
      }
    }

    // Fallback biên khung về bbox module nếu thiếu edge
    if (yTop === -Infinity) yTop = mod.max.y;
    if (yBot === Infinity) yBot = mod.min.y;
    if (xLeft === Infinity) xLeft = mod.min.x;
    if (xRight === -Infinity) xRight = mod.max.x;

    const EPS = 0.0005;

    // ===== Chuỗi khoảng hở theo CHIỀU DỌC (giữa các tấm ngang) =====
    if (shelves.length) {
      shelves.sort((a, b) => b.max - a.max); // từ trên xuống dưới
      let prev = yTop; // mặt dưới của vật rắn phía trên hiện tại
      for (const sh of shelves) {
        const gap = prev - sh.max;
        if (gap > EPS) {
          out.front.push({
            orient: 'v',
            lo: sh.max,
            hi: prev,
            valueMM: Math.round(gap * 1000),
          });
        }
        prev = sh.min;
      }
      const last = prev - yBot;
      if (last > EPS) {
        out.front.push({
          orient: 'v',
          lo: yBot,
          hi: prev,
          valueMM: Math.round(last * 1000),
        });
      }
    }

    // ===== Chuỗi khoảng hở theo CHIỀU NGANG (giữa các tấm dựng) =====
    if (dividers.length) {
      dividers.sort((a, b) => a.min - b.min); // từ trái sang phải
      let prev = xLeft; // mặt phải của vật rắn bên trái hiện tại
      for (const dv of dividers) {
        const gap = dv.min - prev;
        if (gap > EPS) {
          out.front.push({
            orient: 'h',
            lo: prev,
            hi: dv.min,
            valueMM: Math.round(gap * 1000),
          });
        }
        prev = dv.max;
      }
      const last = xRight - prev;
      if (last > EPS) {
        out.front.push({
          orient: 'h',
          lo: prev,
          hi: xRight,
          valueMM: Math.round(last * 1000),
        });
      }
    }

    return out;
  }

  /**
   * Render edges (đường nét) của 1 module theo 1 mặt nhìn vào offscreen renderer.
   * Trả về frustum (kích thước khung nhìn theo mét) để quy đổi world → pixel.
   */
  _renderModuleEdges(mod, viewType, renderer, renderScene, resolution) {
    // Xoá + dispose nội dung lần render trước
    while (renderScene.children.length) {
      const obj = renderScene.children[0];
      renderScene.remove(obj);
      obj.geometry?.dispose?.();
      obj.material?.dispose?.();
    }

    const lineWidth = Math.max(1.5, resolution / 700);

    mod.group.traverse(mesh => {
      if (!mesh.isMesh || !mesh.geometry) return;

      // threshold 30°: giữ các cạnh vuông của panel/ngăn kéo, bỏ tam giác đồng phẳng
      const edges = new THREE.EdgesGeometry(mesh.geometry, 30);
      if (!edges.attributes.position || edges.attributes.position.count === 0) {
        edges.dispose();
        return;
      }

      const lineGeometry = new LineSegmentsGeometry();
      lineGeometry.setPositions(edges.attributes.position.array);

      const lineMaterial = new LineMaterial({
        color: 0x000000,
        linewidth: lineWidth,
        resolution: new THREE.Vector2(resolution, resolution),
        worldUnits: false,
        alphaToCoverage: true,
        depthTest: true,
        depthWrite: true,
      });

      const ls = new LineSegments2(lineGeometry, lineMaterial);
      ls.position.copy(mesh.position);
      ls.quaternion.copy(mesh.quaternion);
      ls.scale.copy(mesh.scale);
      renderScene.add(ls);

      edges.dispose();
    });

    const c = mod.center;
    const s = mod.size;
    const maxDim = Math.max(s.x, s.y, s.z) || 1;
    const frustum = maxDim * 1.08; // lề nhỏ → bản vẽ to hơn, dễ nhìn
    const dist = maxDim * 4 + 1;

    const cam = new THREE.OrthographicCamera(
      -frustum / 2,
      frustum / 2,
      frustum / 2,
      -frustum / 2,
      0.001,
      dist * 4
    );

    if (viewType === 'front') {
      cam.position.set(c.x, c.y, c.z + dist);
      cam.up.set(0, 1, 0);
    } else if (viewType === 'side') {
      cam.position.set(c.x + dist, c.y, c.z);
      cam.up.set(0, 1, 0);
    } else if (viewType === 'top') {
      cam.position.set(c.x, c.y + dist, c.z);
      cam.up.set(0, 0, -1);
    }
    cam.lookAt(c.x, c.y, c.z);

    renderer.render(renderScene, cam);
    return frustum;
  }

  /**
   * Dựng 1 canvas khổ A4 ngang cho 1 module: tiêu đề + các mặt + kích thước.
   * Blit trực tiếp từ renderer.domElement (đồng bộ) nên không cần load ảnh async.
   */
  _composeModulePageCanvas(
    mod,
    pageIndex,
    pageCount,
    views,
    renderer,
    renderScene,
    resolution
  ) {
    const W = 2480;
    const H = 1753; // tỉ lệ ~ A4 ngang (297:210)

    const canvas = document.createElement('canvas');
    canvas.width = W;
    canvas.height = H;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, W, H);

    // ===== Tiêu đề =====
    ctx.fillStyle = '#111111';
    ctx.textAlign = 'left';
    ctx.font = 'bold 56px Arial';
    ctx.fillText(`MẶT CẮT 2D — ${mod.name}`, 60, 92);

    ctx.textAlign = 'right';
    ctx.font = '34px Arial';
    ctx.fillText(`Trang ${pageIndex}/${pageCount}`, W - 60, 86);

    ctx.strokeStyle = '#222222';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(60, 125);
    ctx.lineTo(W - 60, 125);
    ctx.stroke();

    // ===== Khu vực các mặt nhìn =====
    const areaTop = 170;
    const areaBottom = H - 120;
    const areaH = areaBottom - areaTop;
    const nV = views.length;
    const cellW = (W - 120) / nV;
    const labelH = 70;
    const dimPad = 120; // giảm padding → vùng vẽ to hơn

    const sizeMM = {
      x: Math.round(mod.size.x * 1000),
      y: Math.round(mod.size.y * 1000),
      z: Math.round(mod.size.z * 1000),
    };

    const labelMap = { front: 'MẶT TRƯỚC', side: 'MẶT CẠNH', top: 'MẶT BẰNG' };

    // Các đoạn kích thước khoảng cách bên trong (HPANEL/VPANEL...)
    const internalSegs = this._buildInternalDimSegments(mod);

    views.forEach((vt, idx) => {
      const cellX = 60 + idx * cellW;
      const innerSize = Math.max(
        50,
        Math.min(cellW - dimPad * 2, areaH - dimPad * 2 - labelH)
      );
      const cx = cellX + cellW / 2;
      const cy = areaTop + (areaH - labelH) / 2;

      // Render mặt rồi vẽ trực tiếp lên canvas
      const frustum = this._renderModuleEdges(
        mod,
        vt,
        renderer,
        renderScene,
        resolution
      );
      const dx = cx - innerSize / 2;
      const dy = cy - innerSize / 2;
      ctx.drawImage(
        renderer.domElement,
        0,
        0,
        resolution,
        resolution,
        dx,
        dy,
        innerSize,
        innerSize
      );

      // Tính khung bao thực tế của module trên canvas (để gắn kích thước)
      let hw, hh; // world size theo phương ngang / dọc của mặt này
      if (vt === 'front') {
        hw = mod.size.x;
        hh = mod.size.y;
      } else if (vt === 'side') {
        hw = mod.size.z;
        hh = mod.size.y;
      } else {
        hw = mod.size.x;
        hh = mod.size.z;
      }

      const pw = (hw / frustum) * innerSize;
      const ph = (hh / frustum) * innerSize;
      const left = cx - pw / 2;
      const right = cx + pw / 2;
      const top = cy - ph / 2;
      const bottom = cy + ph / 2;

      // Giá trị kích thước theo từng mặt
      let hVal, vVal, hLbl, vLbl;
      if (vt === 'front') {
        hVal = sizeMM.x;
        vVal = sizeMM.y;
        hLbl = 'Rộng';
        vLbl = 'Cao';
      } else if (vt === 'side') {
        hVal = sizeMM.z;
        vVal = sizeMM.y;
        hLbl = 'Sâu';
        vLbl = 'Cao';
      } else {
        hVal = sizeMM.x;
        vVal = sizeMM.z;
        hLbl = 'Rộng';
        vLbl = 'Sâu';
      }

      // ===== Kích thước khoảng cách bên trong (chỉ trên MẶT TRƯỚC) =====
      let widthDimY = bottom + 70; // mặc định kích thước Rộng nằm sát đáy

      if (vt === 'front') {
        // Hàm quy đổi world -> pixel cho mặt trước
        const wx2sx = wx => cx + ((wx - mod.center.x) / frustum) * innerSize;
        const wy2sy = wy => cy - ((wy - mod.center.y) / frustum) * innerSize;

        const fronts = internalSegs.front || [];
        const vSegs = fronts.filter(s => s.orient === 'v'); // khoảng cách dọc (HPANEL)
        const hSegs = fronts.filter(s => s.orient === 'h'); // khoảng cách ngang (VPANEL)

        // Kích thước dọc (trên/dưới HPANEL): đặt thành chuỗi bên TRÁI khung
        vSegs.forEach(s => {
          this._drawDimV(
            ctx,
            wy2sy(s.hi),
            wy2sy(s.lo),
            left - 80,
            `${s.valueMM}`
          );
        });

        // Kích thước ngang (trái/phải VPANEL): chuỗi sát đáy khung
        hSegs.forEach(s => {
          this._drawDimH(
            ctx,
            wx2sx(s.lo),
            wx2sx(s.hi),
            bottom + 70,
            `${s.valueMM}`
          );
        });

        // Nếu đã có chuỗi khoảng cách ngang thì đẩy "Rộng" tổng xuống dưới
        if (hSegs.length > 0) widthDimY = bottom + 150;
      }

      this._drawDimH(ctx, left, right, widthDimY, `${hLbl}: ${hVal}`);
      this._drawDimV(ctx, top, bottom, right + 70, `${vLbl}: ${vVal}`);

      // Nhãn mặt
      ctx.fillStyle = '#111111';
      ctx.font = 'bold 40px Arial';
      ctx.textAlign = 'center';
      ctx.fillText(labelMap[vt] || vt, cx, areaBottom + 5);
    });

    // ===== Chân trang =====
    ctx.fillStyle = '#111111';
    ctx.textAlign = 'left';
    ctx.font = '32px Arial';
    ctx.fillText(
      `Kích thước tổng:  Rộng ${sizeMM.x} × Cao ${sizeMM.y} × Sâu ${sizeMM.z} (mm)`,
      60,
      H - 50
    );

    return canvas;
  }

  /** Vẽ đường kích thước nằm ngang (mũi tên 2 đầu + nhãn). */
  _drawDimH(ctx, x1, x2, y, text) {
    ctx.save();
    ctx.strokeStyle = '#000000';
    ctx.fillStyle = '#000000';
    ctx.lineWidth = 2;
    ctx.font = 'bold 34px Arial';
    ctx.textAlign = 'center';

    // gạch nối 2 đầu
    ctx.beginPath();
    ctx.moveTo(x1, y - 12);
    ctx.lineTo(x1, y + 12);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(x2, y - 12);
    ctx.lineTo(x2, y + 12);
    ctx.stroke();
    // đường chính
    ctx.beginPath();
    ctx.moveTo(x1, y);
    ctx.lineTo(x2, y);
    ctx.stroke();

    const a = 12;
    ctx.beginPath();
    ctx.moveTo(x1, y);
    ctx.lineTo(x1 + a, y - 6);
    ctx.lineTo(x1 + a, y + 6);
    ctx.closePath();
    ctx.fill();
    ctx.beginPath();
    ctx.moveTo(x2, y);
    ctx.lineTo(x2 - a, y - 6);
    ctx.lineTo(x2 - a, y + 6);
    ctx.closePath();
    ctx.fill();

    const tw = ctx.measureText(text).width;
    ctx.fillStyle = '#ffffff';
    ctx.fillRect((x1 + x2) / 2 - tw / 2 - 8, y - 20, tw + 16, 40);
    ctx.fillStyle = '#000000';
    ctx.fillText(text, (x1 + x2) / 2, y + 11);

    ctx.restore();
  }

  /** Vẽ đường kích thước thẳng đứng (mũi tên 2 đầu + nhãn xoay dọc). */
  _drawDimV(ctx, y1, y2, x, text) {
    ctx.save();
    ctx.strokeStyle = '#000000';
    ctx.fillStyle = '#000000';
    ctx.lineWidth = 2;
    ctx.font = 'bold 34px Arial';
    ctx.textAlign = 'center';

    ctx.beginPath();
    ctx.moveTo(x - 12, y1);
    ctx.lineTo(x + 12, y1);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(x - 12, y2);
    ctx.lineTo(x + 12, y2);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(x, y1);
    ctx.lineTo(x, y2);
    ctx.stroke();

    const a = 12;
    ctx.beginPath();
    ctx.moveTo(x, y1);
    ctx.lineTo(x - 6, y1 + a);
    ctx.lineTo(x + 6, y1 + a);
    ctx.closePath();
    ctx.fill();
    ctx.beginPath();
    ctx.moveTo(x, y2);
    ctx.lineTo(x - 6, y2 - a);
    ctx.lineTo(x + 6, y2 - a);
    ctx.closePath();
    ctx.fill();

    ctx.translate(x, (y1 + y2) / 2);
    ctx.rotate(-Math.PI / 2);
    const tw = ctx.measureText(text).width;
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(-tw / 2 - 8, -20, tw + 16, 40);
    ctx.fillStyle = '#000000';
    ctx.fillText(text, 0, 11);

    ctx.restore();
  }

  /* =============================================================================
   *  XUẤT BẢN VẼ TỔNG THỂ (gom theo rotation) + TỪNG MODULE RA 1 FILE PDF
   * -----------------------------------------------------------------------------
   *  - Gom các module theo góc quay quanh trục đứng (mỗi "tường" cabinet 1 nhóm).
   *  - Mỗi nhóm: xoay phẳng về chính diện, render mặt cắt tổng thể + đo R/C/S tổng.
   *  - Thứ tự trang trong PDF: các trang TỔNG THỂ trước, rồi tới từng module.
   *
   *  CÁCH DÙNG:
   *    await sceneManager.exportFullDrawingToPDF('ban-ve-tong-the.pdf');
   *    // tuỳ chọn:
   *    await sceneManager.exportFullDrawingToPDF('out.pdf', {
   *      views: ['front', 'side'],     // các mặt cho trang từng module
   *      rotationStepDeg: 1,           // bước làm tròn góc khi gom nhóm
   *      internalDimTypes: [...],      // loại inside cần đo khoảng hở
   *    });
   * ========================================================================== */
  async exportFullDrawingToPDF(filename = 'ban-ve-tong-the.pdf', options = {}) {
    const {
      views = ['front', 'side'],
      includeTypes = ['module'],
      resolution = 1600,
      internalDimTypes = [InsideType.HPANEL, InsideType.VPANEL].filter(
        v => v !== undefined
      ),
      rotationStepDeg = 1, // làm tròn góc (độ) khi gom nhóm
      // Xoay thêm để đưa mặt trước về chính diện (thử 0/90/180/270 nếu nhìn từ hông)
      frontOffsetDeg = 0,
    } = options;

    // 1) Thu thập module
    const modules = this._collectModulesForDrawing(
      includeTypes,
      internalDimTypes,
      frontOffsetDeg
    );
    if (!modules.length) {
      openMessageError?.({ content: 'Không tìm thấy module nào để xuất!' });
      return false;
    }

    // 2) jsPDF
    let jsPDF;
    try {
      ({ jsPDF } = await import('jspdf'));
    } catch (e) {
      console.error(e);
      openMessageError?.({
        content: 'Chưa cài jsPDF. Hãy chạy: npm install jspdf',
      });
      return false;
    }

    // 3) Gom module theo rotation (góc quay quanh Y)
    const groupsMap = new Map();
    for (const mod of modules) {
      let deg = ((mod.rotationY * 180) / Math.PI) % 360;
      deg = (deg + 360) % 360;
      const key = (Math.round(deg / rotationStepDeg) * rotationStepDeg) % 360;
      if (!groupsMap.has(key)) groupsMap.set(key, []);
      groupsMap.get(key).push(mod);
    }

    // 4) Dựng dữ liệu từng nhóm. Các module đã được bake về chính diện (+Z)
    //    ngay từ _collectModulesForDrawing, nên ở đây chỉ cần GHÉP lại (không xoay).
    const groups = [];
    let gi = 0;
    for (const [deg, mods] of [...groupsMap.entries()].sort(
      (a, b) => a[0] - b[0]
    )) {
      gi++;
      const sourceMeshes = [];
      mods.forEach(m => m.group.children.forEach(ch => sourceMeshes.push(ch)));

      const flatGroup = this._buildFlatGroup(sourceMeshes, 0);
      const bbox = new THREE.Box3().setFromObject(flatGroup);

      groups.push({
        flatGroup,
        center: bbox.getCenter(new THREE.Vector3()),
        size: bbox.getSize(new THREE.Vector3()),
        angleDeg: deg,
        count: mods.length,
        name: `Nhóm ${gi} — góc ${Math.round(deg)}°`,
      });
    }

    // 5) Renderer offscreen + PDF A4 ngang
    const renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true,
      preserveDrawingBuffer: true,
    });
    renderer.setSize(resolution, resolution);
    renderer.setPixelRatio(1);

    const renderScene = new THREE.Scene();
    renderScene.background = new THREE.Color('#ffffff');

    const pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
    });
    const pageW = pdf.internal.pageSize.getWidth();
    const pageH = pdf.internal.pageSize.getHeight();

    let pageIdx = 0;
    const addCanvas = canvas => {
      const data = canvas.toDataURL('image/png');
      if (pageIdx > 0) pdf.addPage();
      pdf.addImage(data, 'PNG', 0, 0, pageW, pageH);
      pageIdx++;
    };

    try {
      // 6a) Trang TỔNG THỂ từng nhóm (xuất trước)
      groups.forEach((grp, i) => {
        const c = this._composeGroupOverviewCanvas(
          grp,
          i + 1,
          groups.length,
          renderer,
          renderScene,
          resolution
        );
        addCanvas(c);
      });

      // 6b) Trang RIÊNG từng module (xuất sau)
      modules.forEach((mod, i) => {
        const c = this._composeModulePageCanvas(
          mod,
          i + 1,
          modules.length,
          views,
          renderer,
          renderScene,
          resolution
        );
        addCanvas(c);
      });

      pdf.save(filename);
      return true;
    } catch (err) {
      console.error('Export full drawing PDF error:', err);
      openMessageError?.({ content: 'Có lỗi khi xuất PDF bản vẽ tổng thể!' });
      return false;
    } finally {
      while (renderScene.children.length) {
        const obj = renderScene.children[0];
        renderScene.remove(obj);
        obj.geometry?.dispose?.();
        obj.material?.dispose?.();
      }
      renderer.dispose();
    }
  }

  /**
   * Gộp các mesh (đã mang world-transform ở dạng local trong mod.group) thành 1
   * group phẳng, có thể "bake" sẵn 1 góc xoay quanh Y để đưa về chính diện.
   * Trả về Group mới với các mesh clone (local = world sau khi xoay).
   */
  _buildFlatGroup(sourceMeshes, bakeRotY = 0) {
    const g = new THREE.Group();
    const R = new THREE.Matrix4().makeRotationY(bakeRotY);
    const m = new THREE.Matrix4();
    const pos = new THREE.Vector3();
    const quat = new THREE.Quaternion();
    const scl = new THREE.Vector3();

    for (const mesh of sourceMeshes) {
      if (!mesh.isMesh) continue;
      mesh.updateMatrix(); // compose từ position/quaternion/scale hiện tại
      m.copy(R).multiply(mesh.matrix);

      const clone = mesh.clone();
      m.decompose(pos, quat, scl);
      clone.position.copy(pos);
      clone.quaternion.copy(quat);
      clone.scale.copy(scl);
      g.add(clone);
    }
    return g;
  }

  /**
   * Dựng 1 trang A4 ngang cho 1 NHÓM: mặt cắt chính diện tổng thể + kích thước tổng.
   */
  _composeGroupOverviewCanvas(
    grp,
    pageIndex,
    pageCount,
    renderer,
    renderScene,
    resolution
  ) {
    const W = 2480;
    const H = 1753;

    const canvas = document.createElement('canvas');
    canvas.width = W;
    canvas.height = H;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, W, H);

    // ===== Tiêu đề =====
    ctx.fillStyle = '#111111';
    ctx.textAlign = 'left';
    ctx.font = 'bold 56px Arial';
    ctx.fillText(`BẢN VẼ TỔNG THỂ — ${grp.name}`, 60, 92);

    ctx.textAlign = 'right';
    ctx.font = '34px Arial';
    ctx.fillText(`Tổng thể ${pageIndex}/${pageCount}`, W - 60, 86);

    ctx.strokeStyle = '#222222';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(60, 125);
    ctx.lineTo(W - 60, 125);
    ctx.stroke();

    const sizeMM = {
      x: Math.round(grp.size.x * 1000),
      y: Math.round(grp.size.y * 1000),
      z: Math.round(grp.size.z * 1000),
    };

    // ===== Mặt cắt chính diện (lớn, giữa trang) =====
    const areaTop = 180;
    const areaBottom = H - 130;
    const areaH = areaBottom - areaTop;
    const dimPad = 180;
    const labelH = 70;
    const innerSize = Math.max(
      50,
      Math.min(W - 120 - dimPad * 2, areaH - dimPad * 2 - labelH)
    );
    const cx = W / 2;
    const cy = areaTop + (areaH - labelH) / 2;

    const pseudo = { group: grp.flatGroup, center: grp.center, size: grp.size };
    const frustum = this._renderModuleEdges(
      pseudo,
      'front',
      renderer,
      renderScene,
      resolution
    );

    const dx = cx - innerSize / 2;
    const dy = cy - innerSize / 2;
    ctx.drawImage(
      renderer.domElement,
      0,
      0,
      resolution,
      resolution,
      dx,
      dy,
      innerSize,
      innerSize
    );

    const pw = (grp.size.x / frustum) * innerSize;
    const ph = (grp.size.y / frustum) * innerSize;
    const left = cx - pw / 2;
    const right = cx + pw / 2;
    const top = cy - ph / 2;
    const bottom = cy + ph / 2;

    this._drawDimH(ctx, left, right, bottom + 80, `Rộng: ${sizeMM.x}`);
    this._drawDimV(ctx, top, bottom, right + 80, `Cao: ${sizeMM.y}`);

    ctx.fillStyle = '#111111';
    ctx.font = 'bold 44px Arial';
    ctx.textAlign = 'center';
    ctx.fillText('MẶT CẮT CHÍNH DIỆN', cx, areaBottom + 10);

    // ===== Chân trang =====
    ctx.fillStyle = '#111111';
    ctx.textAlign = 'left';
    ctx.font = '32px Arial';
    ctx.fillText(
      `Số module: ${grp.count}   |   Kích thước tổng: Rộng ${sizeMM.x} × Cao ${sizeMM.y} × Sâu ${sizeMM.z} (mm)`,
      60,
      H - 50
    );

    return canvas;
  }

  /**
   * END EXPORT 2D
   */

  dispose() {
    // this.positionController?.dispose();
    this.dimensionSystem?.dispose();
    this.isDisposed = true;
    this._afterRenderListeners?.clear();
    cancelAnimationFrame(this._animationId);
    this.controls?.dispose();
    this.renderer?.dispose();
    this.moduleLoader?.dispose();
    this.dragController?.dispose();
    this.createGroupPlane?.dispose();

    if (this.cornerPillars && this.cornerPillars.length > 0) {
      this.cornerPillars.forEach(pillar => {
        this.scene.remove(pillar);
        pillar.geometry.dispose();
        pillar.material.dispose();
      });
      this.cornerPillars = [];
    }
    if (this.ceiling) {
      this.scene.remove(this.ceiling);
      this.ceiling.geometry.dispose();
      this.ceiling.material.dispose();
      this.ceiling = null;
    }

    if (this.scene) {
      this.scene.clear();
      this.scene = null;
    }
    this.camera = null;
    if (this.renderer) {
      this.renderer.forceContextLoss();
      this.renderer.domElement = null;
      this.renderer = null;
    }
  }
}
